import { useQuery, ApolloClient, InMemoryCache, from, createHttpLink, ApolloLink } from '@apollo/client';
import { RetryLink } from '@apollo/client/link/retry';
import { createClient } from 'contentful';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/cms/__generated__/graphql.ts
var AbnormalLoadLinkingCollectionsB2BRouteCollectionOrder = /* @__PURE__ */ ((AbnormalLoadLinkingCollectionsB2BRouteCollectionOrder2) => {
  AbnormalLoadLinkingCollectionsB2BRouteCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AbnormalLoadLinkingCollectionsB2BRouteCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AbnormalLoadLinkingCollectionsB2BRouteCollectionOrder2["NameAsc"] = "name_ASC";
  AbnormalLoadLinkingCollectionsB2BRouteCollectionOrder2["NameDesc"] = "name_DESC";
  AbnormalLoadLinkingCollectionsB2BRouteCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AbnormalLoadLinkingCollectionsB2BRouteCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AbnormalLoadLinkingCollectionsB2BRouteCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  AbnormalLoadLinkingCollectionsB2BRouteCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  AbnormalLoadLinkingCollectionsB2BRouteCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AbnormalLoadLinkingCollectionsB2BRouteCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AbnormalLoadLinkingCollectionsB2BRouteCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AbnormalLoadLinkingCollectionsB2BRouteCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AbnormalLoadLinkingCollectionsB2BRouteCollectionOrder2;
})(AbnormalLoadLinkingCollectionsB2BRouteCollectionOrder || {});
var AbnormalLoadOrder = /* @__PURE__ */ ((AbnormalLoadOrder2) => {
  AbnormalLoadOrder2["ClassificationAsc"] = "classification_ASC";
  AbnormalLoadOrder2["ClassificationDesc"] = "classification_DESC";
  AbnormalLoadOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AbnormalLoadOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AbnormalLoadOrder2["IdAsc"] = "id_ASC";
  AbnormalLoadOrder2["IdDesc"] = "id_DESC";
  AbnormalLoadOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AbnormalLoadOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AbnormalLoadOrder2["SysIdAsc"] = "sys_id_ASC";
  AbnormalLoadOrder2["SysIdDesc"] = "sys_id_DESC";
  AbnormalLoadOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AbnormalLoadOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AbnormalLoadOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AbnormalLoadOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AbnormalLoadOrder2;
})(AbnormalLoadOrder || {});
var AccordionGroupAccordionItemCollectionOrder = /* @__PURE__ */ ((AccordionGroupAccordionItemCollectionOrder2) => {
  AccordionGroupAccordionItemCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AccordionGroupAccordionItemCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AccordionGroupAccordionItemCollectionOrder2["SummaryAsc"] = "summary_ASC";
  AccordionGroupAccordionItemCollectionOrder2["SummaryDesc"] = "summary_DESC";
  AccordionGroupAccordionItemCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AccordionGroupAccordionItemCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AccordionGroupAccordionItemCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  AccordionGroupAccordionItemCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  AccordionGroupAccordionItemCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AccordionGroupAccordionItemCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AccordionGroupAccordionItemCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AccordionGroupAccordionItemCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AccordionGroupAccordionItemCollectionOrder2;
})(AccordionGroupAccordionItemCollectionOrder || {});
var AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder = /* @__PURE__ */ ((AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder2) => {
  AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder2["TitleAsc"] = "title_ASC";
  AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder2["TitleDesc"] = "title_DESC";
  return AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder2;
})(AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder || {});
var AccordionGroupItemOrder = /* @__PURE__ */ ((AccordionGroupItemOrder2) => {
  AccordionGroupItemOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AccordionGroupItemOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AccordionGroupItemOrder2["SummaryAsc"] = "summary_ASC";
  AccordionGroupItemOrder2["SummaryDesc"] = "summary_DESC";
  AccordionGroupItemOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AccordionGroupItemOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AccordionGroupItemOrder2["SysIdAsc"] = "sys_id_ASC";
  AccordionGroupItemOrder2["SysIdDesc"] = "sys_id_DESC";
  AccordionGroupItemOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AccordionGroupItemOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AccordionGroupItemOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AccordionGroupItemOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AccordionGroupItemOrder2;
})(AccordionGroupItemOrder || {});
var AccordionGroupLinkingCollectionsPageSectionCollectionOrder = /* @__PURE__ */ ((AccordionGroupLinkingCollectionsPageSectionCollectionOrder2) => {
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["ColumnsAsc"] = "columns_ASC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["ColumnsDesc"] = "columns_DESC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["DisplayOptionAsc"] = "displayOption_ASC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["DisplayOptionDesc"] = "displayOption_DESC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["HideBackgroundImageOnMobileAsc"] = "hideBackgroundImageOnMobile_ASC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["HideBackgroundImageOnMobileDesc"] = "hideBackgroundImageOnMobile_DESC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["SectionDescriptionAsc"] = "sectionDescription_ASC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["SectionDescriptionDesc"] = "sectionDescription_DESC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AccordionGroupLinkingCollectionsPageSectionCollectionOrder2;
})(AccordionGroupLinkingCollectionsPageSectionCollectionOrder || {});
var AccordionGroupOrder = /* @__PURE__ */ ((AccordionGroupOrder2) => {
  AccordionGroupOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AccordionGroupOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AccordionGroupOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AccordionGroupOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AccordionGroupOrder2["SysIdAsc"] = "sys_id_ASC";
  AccordionGroupOrder2["SysIdDesc"] = "sys_id_DESC";
  AccordionGroupOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AccordionGroupOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AccordionGroupOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AccordionGroupOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  AccordionGroupOrder2["TitleAsc"] = "title_ASC";
  AccordionGroupOrder2["TitleDesc"] = "title_DESC";
  return AccordionGroupOrder2;
})(AccordionGroupOrder || {});
var AccordionLinkingCollectionsPageSectionCollectionOrder = /* @__PURE__ */ ((AccordionLinkingCollectionsPageSectionCollectionOrder2) => {
  AccordionLinkingCollectionsPageSectionCollectionOrder2["ColumnsAsc"] = "columns_ASC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["ColumnsDesc"] = "columns_DESC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["DisplayOptionAsc"] = "displayOption_ASC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["DisplayOptionDesc"] = "displayOption_DESC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["HideBackgroundImageOnMobileAsc"] = "hideBackgroundImageOnMobile_ASC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["HideBackgroundImageOnMobileDesc"] = "hideBackgroundImageOnMobile_DESC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["SectionDescriptionAsc"] = "sectionDescription_ASC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["SectionDescriptionDesc"] = "sectionDescription_DESC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AccordionLinkingCollectionsPageSectionCollectionOrder2;
})(AccordionLinkingCollectionsPageSectionCollectionOrder || {});
var AccordionOrder = /* @__PURE__ */ ((AccordionOrder2) => {
  AccordionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AccordionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AccordionOrder2["SummaryAsc"] = "summary_ASC";
  AccordionOrder2["SummaryDesc"] = "summary_DESC";
  AccordionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AccordionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AccordionOrder2["SysIdAsc"] = "sys_id_ASC";
  AccordionOrder2["SysIdDesc"] = "sys_id_DESC";
  AccordionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AccordionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AccordionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AccordionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AccordionOrder2;
})(AccordionOrder || {});
var ActionCardLinkingCollectionsCardsSectionCollectionOrder = /* @__PURE__ */ ((ActionCardLinkingCollectionsCardsSectionCollectionOrder2) => {
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["DisplayTypeAsc"] = "displayType_ASC";
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["DisplayTypeDesc"] = "displayType_DESC";
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["OverlineAsc"] = "overline_ASC";
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["OverlineDesc"] = "overline_DESC";
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["SectionBackgroundAndCardColorAsc"] = "sectionBackgroundAndCardColor_ASC";
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["SectionBackgroundAndCardColorDesc"] = "sectionBackgroundAndCardColor_DESC";
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ActionCardLinkingCollectionsCardsSectionCollectionOrder2;
})(ActionCardLinkingCollectionsCardsSectionCollectionOrder || {});
var ActionCardOrder = /* @__PURE__ */ ((ActionCardOrder2) => {
  ActionCardOrder2["BadgeAsc"] = "badge_ASC";
  ActionCardOrder2["BadgeDesc"] = "badge_DESC";
  ActionCardOrder2["CurrencyAsc"] = "currency_ASC";
  ActionCardOrder2["CurrencyDesc"] = "currency_DESC";
  ActionCardOrder2["DiscountAsc"] = "discount_ASC";
  ActionCardOrder2["DiscountDesc"] = "discount_DESC";
  ActionCardOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ActionCardOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ActionCardOrder2["HeaderAsc"] = "header_ASC";
  ActionCardOrder2["HeaderDesc"] = "header_DESC";
  ActionCardOrder2["PriceAsc"] = "price_ASC";
  ActionCardOrder2["PriceDesc"] = "price_DESC";
  ActionCardOrder2["SuffixAsc"] = "suffix_ASC";
  ActionCardOrder2["SuffixDesc"] = "suffix_DESC";
  ActionCardOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ActionCardOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ActionCardOrder2["SysIdAsc"] = "sys_id_ASC";
  ActionCardOrder2["SysIdDesc"] = "sys_id_DESC";
  ActionCardOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ActionCardOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ActionCardOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ActionCardOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ActionCardOrder2;
})(ActionCardOrder || {});
var AmendmentBookingOrder = /* @__PURE__ */ ((AmendmentBookingOrder2) => {
  AmendmentBookingOrder2["DateFormatAsc"] = "dateFormat_ASC";
  AmendmentBookingOrder2["DateFormatDesc"] = "dateFormat_DESC";
  AmendmentBookingOrder2["DisabledLinksPopupHeadingAsc"] = "disabledLinksPopupHeading_ASC";
  AmendmentBookingOrder2["DisabledLinksPopupHeadingDesc"] = "disabledLinksPopupHeading_DESC";
  AmendmentBookingOrder2["PassengerDetailsAsc"] = "passengerDetails_ASC";
  AmendmentBookingOrder2["PassengerDetailsDesc"] = "passengerDetails_DESC";
  AmendmentBookingOrder2["PreliminaryPendingMessageAsc"] = "preliminaryPendingMessage_ASC";
  AmendmentBookingOrder2["PreliminaryPendingMessageDesc"] = "preliminaryPendingMessage_DESC";
  AmendmentBookingOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AmendmentBookingOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AmendmentBookingOrder2["SysIdAsc"] = "sys_id_ASC";
  AmendmentBookingOrder2["SysIdDesc"] = "sys_id_DESC";
  AmendmentBookingOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AmendmentBookingOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AmendmentBookingOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AmendmentBookingOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  AmendmentBookingOrder2["TimeFormatAsc"] = "timeFormat_ASC";
  AmendmentBookingOrder2["TimeFormatDesc"] = "timeFormat_DESC";
  return AmendmentBookingOrder2;
})(AmendmentBookingOrder || {});
var AmendmentCabinOrder = /* @__PURE__ */ ((AmendmentCabinOrder2) => {
  AmendmentCabinOrder2["NoCabinsAvailableAsc"] = "noCabinsAvailable_ASC";
  AmendmentCabinOrder2["NoCabinsAvailableDesc"] = "noCabinsAvailable_DESC";
  AmendmentCabinOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AmendmentCabinOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AmendmentCabinOrder2["SysIdAsc"] = "sys_id_ASC";
  AmendmentCabinOrder2["SysIdDesc"] = "sys_id_DESC";
  AmendmentCabinOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AmendmentCabinOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AmendmentCabinOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AmendmentCabinOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AmendmentCabinOrder2;
})(AmendmentCabinOrder || {});
var AmendmentFaresOrder = /* @__PURE__ */ ((AmendmentFaresOrder2) => {
  AmendmentFaresOrder2["AcceptAndContinueAsc"] = "acceptAndContinue_ASC";
  AmendmentFaresOrder2["AcceptAndContinueDesc"] = "acceptAndContinue_DESC";
  AmendmentFaresOrder2["BookingNumberAsc"] = "bookingNumber_ASC";
  AmendmentFaresOrder2["BookingNumberDesc"] = "bookingNumber_DESC";
  AmendmentFaresOrder2["DateFormatAsc"] = "dateFormat_ASC";
  AmendmentFaresOrder2["DateFormatDesc"] = "dateFormat_DESC";
  AmendmentFaresOrder2["DefaultBookingAsc"] = "defaultBooking_ASC";
  AmendmentFaresOrder2["DefaultBookingDesc"] = "defaultBooking_DESC";
  AmendmentFaresOrder2["DepartureDateAsc"] = "departureDate_ASC";
  AmendmentFaresOrder2["DepartureDateDesc"] = "departureDate_DESC";
  AmendmentFaresOrder2["LegendAsc"] = "legend_ASC";
  AmendmentFaresOrder2["LegendDesc"] = "legend_DESC";
  AmendmentFaresOrder2["OutboundTravelAsc"] = "outboundTravel_ASC";
  AmendmentFaresOrder2["OutboundTravelDesc"] = "outboundTravel_DESC";
  AmendmentFaresOrder2["ReturnDateAsc"] = "returnDate_ASC";
  AmendmentFaresOrder2["ReturnDateDesc"] = "returnDate_DESC";
  AmendmentFaresOrder2["ReturnTravelAsc"] = "returnTravel_ASC";
  AmendmentFaresOrder2["ReturnTravelDesc"] = "returnTravel_DESC";
  AmendmentFaresOrder2["SelectDateAsc"] = "selectDate_ASC";
  AmendmentFaresOrder2["SelectDateDesc"] = "selectDate_DESC";
  AmendmentFaresOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AmendmentFaresOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AmendmentFaresOrder2["SysIdAsc"] = "sys_id_ASC";
  AmendmentFaresOrder2["SysIdDesc"] = "sys_id_DESC";
  AmendmentFaresOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AmendmentFaresOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AmendmentFaresOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AmendmentFaresOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  AmendmentFaresOrder2["Tier3CategoryChangedHeaderAsc"] = "tier3CategoryChangedHeader_ASC";
  AmendmentFaresOrder2["Tier3CategoryChangedHeaderDesc"] = "tier3CategoryChangedHeader_DESC";
  AmendmentFaresOrder2["Tier3CategoryChangedAsc"] = "tier3CategoryChanged_ASC";
  AmendmentFaresOrder2["Tier3CategoryChangedDesc"] = "tier3CategoryChanged_DESC";
  AmendmentFaresOrder2["Tier3WhatIsIncludedAsc"] = "tier3WhatIsIncluded_ASC";
  AmendmentFaresOrder2["Tier3WhatIsIncludedDesc"] = "tier3WhatIsIncluded_DESC";
  AmendmentFaresOrder2["TimeFormatAsc"] = "timeFormat_ASC";
  AmendmentFaresOrder2["TimeFormatDesc"] = "timeFormat_DESC";
  AmendmentFaresOrder2["TitleAsc"] = "title_ASC";
  AmendmentFaresOrder2["TitleDesc"] = "title_DESC";
  return AmendmentFaresOrder2;
})(AmendmentFaresOrder || {});
var AppOrder = /* @__PURE__ */ ((AppOrder2) => {
  AppOrder2["EdgeLabelAsc"] = "edgeLabel_ASC";
  AppOrder2["EdgeLabelDesc"] = "edgeLabel_DESC";
  AppOrder2["ExploreBannerDescriptionAsc"] = "exploreBannerDescription_ASC";
  AppOrder2["ExploreBannerDescriptionDesc"] = "exploreBannerDescription_DESC";
  AppOrder2["FrontPageButtonTextAsc"] = "frontPageButtonText_ASC";
  AppOrder2["FrontPageButtonTextDesc"] = "frontPageButtonText_DESC";
  AppOrder2["InternetExploreOverlayDescriptionAsc"] = "internetExploreOverlayDescription_ASC";
  AppOrder2["InternetExploreOverlayDescriptionDesc"] = "internetExploreOverlayDescription_DESC";
  AppOrder2["InternetExploreOverlayHeaderAsc"] = "internetExploreOverlayHeader_ASC";
  AppOrder2["InternetExploreOverlayHeaderDesc"] = "internetExploreOverlayHeader_DESC";
  AppOrder2["MicrosoftEdgeButtonTextAsc"] = "microsoftEdgeButtonText_ASC";
  AppOrder2["MicrosoftEdgeButtonTextDesc"] = "microsoftEdgeButtonText_DESC";
  AppOrder2["OktaResumeSessionButtonAsc"] = "oktaResumeSessionButton_ASC";
  AppOrder2["OktaResumeSessionButtonDesc"] = "oktaResumeSessionButton_DESC";
  AppOrder2["OktaSessionAboutToExpireDescriptionAsc"] = "oktaSessionAboutToExpireDescription_ASC";
  AppOrder2["OktaSessionAboutToExpireDescriptionDesc"] = "oktaSessionAboutToExpireDescription_DESC";
  AppOrder2["OktaSessionAboutToExpireHeaderAsc"] = "oktaSessionAboutToExpireHeader_ASC";
  AppOrder2["OktaSessionAboutToExpireHeaderDesc"] = "oktaSessionAboutToExpireHeader_DESC";
  AppOrder2["OktaSessionExpiredDescriptionAsc"] = "oktaSessionExpiredDescription_ASC";
  AppOrder2["OktaSessionExpiredDescriptionDesc"] = "oktaSessionExpiredDescription_DESC";
  AppOrder2["OktaSessionExpiredHeaderAsc"] = "oktaSessionExpiredHeader_ASC";
  AppOrder2["OktaSessionExpiredHeaderDesc"] = "oktaSessionExpiredHeader_DESC";
  AppOrder2["OktaStartOverButtonAsc"] = "oktaStartOverButton_ASC";
  AppOrder2["OktaStartOverButtonDesc"] = "oktaStartOverButton_DESC";
  AppOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AppOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AppOrder2["SysIdAsc"] = "sys_id_ASC";
  AppOrder2["SysIdDesc"] = "sys_id_DESC";
  AppOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AppOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AppOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AppOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AppOrder2;
})(AppOrder || {});
var AppSectionLinkingCollectionsArticlePageCollectionOrder = /* @__PURE__ */ ((AppSectionLinkingCollectionsArticlePageCollectionOrder2) => {
  AppSectionLinkingCollectionsArticlePageCollectionOrder2["CategoryAsc"] = "category_ASC";
  AppSectionLinkingCollectionsArticlePageCollectionOrder2["CategoryDesc"] = "category_DESC";
  AppSectionLinkingCollectionsArticlePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AppSectionLinkingCollectionsArticlePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AppSectionLinkingCollectionsArticlePageCollectionOrder2["PublishedDateAsc"] = "publishedDate_ASC";
  AppSectionLinkingCollectionsArticlePageCollectionOrder2["PublishedDateDesc"] = "publishedDate_DESC";
  AppSectionLinkingCollectionsArticlePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AppSectionLinkingCollectionsArticlePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AppSectionLinkingCollectionsArticlePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  AppSectionLinkingCollectionsArticlePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  AppSectionLinkingCollectionsArticlePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AppSectionLinkingCollectionsArticlePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AppSectionLinkingCollectionsArticlePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AppSectionLinkingCollectionsArticlePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AppSectionLinkingCollectionsArticlePageCollectionOrder2;
})(AppSectionLinkingCollectionsArticlePageCollectionOrder || {});
var AppSectionLinkingCollectionsModularPageCollectionOrder = /* @__PURE__ */ ((AppSectionLinkingCollectionsModularPageCollectionOrder2) => {
  AppSectionLinkingCollectionsModularPageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AppSectionLinkingCollectionsModularPageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AppSectionLinkingCollectionsModularPageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AppSectionLinkingCollectionsModularPageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AppSectionLinkingCollectionsModularPageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  AppSectionLinkingCollectionsModularPageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  AppSectionLinkingCollectionsModularPageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AppSectionLinkingCollectionsModularPageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AppSectionLinkingCollectionsModularPageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AppSectionLinkingCollectionsModularPageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AppSectionLinkingCollectionsModularPageCollectionOrder2;
})(AppSectionLinkingCollectionsModularPageCollectionOrder || {});
var AppSectionOrder = /* @__PURE__ */ ((AppSectionOrder2) => {
  AppSectionOrder2["AppTypeAsc"] = "appType_ASC";
  AppSectionOrder2["AppTypeDesc"] = "appType_DESC";
  AppSectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AppSectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AppSectionOrder2["HideBackgroundImageOnMobileAsc"] = "hideBackgroundImageOnMobile_ASC";
  AppSectionOrder2["HideBackgroundImageOnMobileDesc"] = "hideBackgroundImageOnMobile_DESC";
  AppSectionOrder2["SectionDescriptionAsc"] = "sectionDescription_ASC";
  AppSectionOrder2["SectionDescriptionDesc"] = "sectionDescription_DESC";
  AppSectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  AppSectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  AppSectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AppSectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AppSectionOrder2["SysIdAsc"] = "sys_id_ASC";
  AppSectionOrder2["SysIdDesc"] = "sys_id_DESC";
  AppSectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AppSectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AppSectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AppSectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AppSectionOrder2;
})(AppSectionOrder || {});
var ArrayOfItemsOrder = /* @__PURE__ */ ((ArrayOfItemsOrder2) => {
  ArrayOfItemsOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ArrayOfItemsOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ArrayOfItemsOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ArrayOfItemsOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ArrayOfItemsOrder2["SysIdAsc"] = "sys_id_ASC";
  ArrayOfItemsOrder2["SysIdDesc"] = "sys_id_DESC";
  ArrayOfItemsOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ArrayOfItemsOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ArrayOfItemsOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ArrayOfItemsOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ArrayOfItemsOrder2;
})(ArrayOfItemsOrder || {});
var ArticleCategoryOverviewPageOrder = /* @__PURE__ */ ((ArticleCategoryOverviewPageOrder2) => {
  ArticleCategoryOverviewPageOrder2["CategoryAsc"] = "category_ASC";
  ArticleCategoryOverviewPageOrder2["CategoryDesc"] = "category_DESC";
  ArticleCategoryOverviewPageOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ArticleCategoryOverviewPageOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ArticleCategoryOverviewPageOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ArticleCategoryOverviewPageOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ArticleCategoryOverviewPageOrder2["SysIdAsc"] = "sys_id_ASC";
  ArticleCategoryOverviewPageOrder2["SysIdDesc"] = "sys_id_DESC";
  ArticleCategoryOverviewPageOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ArticleCategoryOverviewPageOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ArticleCategoryOverviewPageOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ArticleCategoryOverviewPageOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ArticleCategoryOverviewPageOrder2;
})(ArticleCategoryOverviewPageOrder || {});
var ArticlePageOrder = /* @__PURE__ */ ((ArticlePageOrder2) => {
  ArticlePageOrder2["CategoryAsc"] = "category_ASC";
  ArticlePageOrder2["CategoryDesc"] = "category_DESC";
  ArticlePageOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ArticlePageOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ArticlePageOrder2["PublishedDateAsc"] = "publishedDate_ASC";
  ArticlePageOrder2["PublishedDateDesc"] = "publishedDate_DESC";
  ArticlePageOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ArticlePageOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ArticlePageOrder2["SysIdAsc"] = "sys_id_ASC";
  ArticlePageOrder2["SysIdDesc"] = "sys_id_DESC";
  ArticlePageOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ArticlePageOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ArticlePageOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ArticlePageOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ArticlePageOrder2;
})(ArticlePageOrder || {});
var AssetOrder = /* @__PURE__ */ ((AssetOrder2) => {
  AssetOrder2["ContentTypeAsc"] = "contentType_ASC";
  AssetOrder2["ContentTypeDesc"] = "contentType_DESC";
  AssetOrder2["FileNameAsc"] = "fileName_ASC";
  AssetOrder2["FileNameDesc"] = "fileName_DESC";
  AssetOrder2["HeightAsc"] = "height_ASC";
  AssetOrder2["HeightDesc"] = "height_DESC";
  AssetOrder2["SizeAsc"] = "size_ASC";
  AssetOrder2["SizeDesc"] = "size_DESC";
  AssetOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AssetOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AssetOrder2["SysIdAsc"] = "sys_id_ASC";
  AssetOrder2["SysIdDesc"] = "sys_id_DESC";
  AssetOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AssetOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AssetOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AssetOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  AssetOrder2["UrlAsc"] = "url_ASC";
  AssetOrder2["UrlDesc"] = "url_DESC";
  AssetOrder2["WidthAsc"] = "width_ASC";
  AssetOrder2["WidthDesc"] = "width_DESC";
  return AssetOrder2;
})(AssetOrder || {});
var AuthorLinkingCollectionsArticlePageCollectionOrder = /* @__PURE__ */ ((AuthorLinkingCollectionsArticlePageCollectionOrder2) => {
  AuthorLinkingCollectionsArticlePageCollectionOrder2["CategoryAsc"] = "category_ASC";
  AuthorLinkingCollectionsArticlePageCollectionOrder2["CategoryDesc"] = "category_DESC";
  AuthorLinkingCollectionsArticlePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AuthorLinkingCollectionsArticlePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AuthorLinkingCollectionsArticlePageCollectionOrder2["PublishedDateAsc"] = "publishedDate_ASC";
  AuthorLinkingCollectionsArticlePageCollectionOrder2["PublishedDateDesc"] = "publishedDate_DESC";
  AuthorLinkingCollectionsArticlePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AuthorLinkingCollectionsArticlePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AuthorLinkingCollectionsArticlePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  AuthorLinkingCollectionsArticlePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  AuthorLinkingCollectionsArticlePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AuthorLinkingCollectionsArticlePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AuthorLinkingCollectionsArticlePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AuthorLinkingCollectionsArticlePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AuthorLinkingCollectionsArticlePageCollectionOrder2;
})(AuthorLinkingCollectionsArticlePageCollectionOrder || {});
var AuthorOrder = /* @__PURE__ */ ((AuthorOrder2) => {
  AuthorOrder2["JobTitleAsc"] = "jobTitle_ASC";
  AuthorOrder2["JobTitleDesc"] = "jobTitle_DESC";
  AuthorOrder2["LinkedInAsc"] = "linkedIn_ASC";
  AuthorOrder2["LinkedInDesc"] = "linkedIn_DESC";
  AuthorOrder2["NameAsc"] = "name_ASC";
  AuthorOrder2["NameDesc"] = "name_DESC";
  AuthorOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AuthorOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AuthorOrder2["SysIdAsc"] = "sys_id_ASC";
  AuthorOrder2["SysIdDesc"] = "sys_id_DESC";
  AuthorOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AuthorOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AuthorOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AuthorOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AuthorOrder2;
})(AuthorOrder || {});
var B2BCompositePageOrder = /* @__PURE__ */ ((B2BCompositePageOrder2) => {
  B2BCompositePageOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  B2BCompositePageOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  B2BCompositePageOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  B2BCompositePageOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  B2BCompositePageOrder2["SysIdAsc"] = "sys_id_ASC";
  B2BCompositePageOrder2["SysIdDesc"] = "sys_id_DESC";
  B2BCompositePageOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  B2BCompositePageOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  B2BCompositePageOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  B2BCompositePageOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return B2BCompositePageOrder2;
})(B2BCompositePageOrder || {});
var B2BRouteAbnormalLoadsCollectionOrder = /* @__PURE__ */ ((B2BRouteAbnormalLoadsCollectionOrder2) => {
  B2BRouteAbnormalLoadsCollectionOrder2["ClassificationAsc"] = "classification_ASC";
  B2BRouteAbnormalLoadsCollectionOrder2["ClassificationDesc"] = "classification_DESC";
  B2BRouteAbnormalLoadsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  B2BRouteAbnormalLoadsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  B2BRouteAbnormalLoadsCollectionOrder2["IdAsc"] = "id_ASC";
  B2BRouteAbnormalLoadsCollectionOrder2["IdDesc"] = "id_DESC";
  B2BRouteAbnormalLoadsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  B2BRouteAbnormalLoadsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  B2BRouteAbnormalLoadsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  B2BRouteAbnormalLoadsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  B2BRouteAbnormalLoadsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  B2BRouteAbnormalLoadsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  B2BRouteAbnormalLoadsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  B2BRouteAbnormalLoadsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return B2BRouteAbnormalLoadsCollectionOrder2;
})(B2BRouteAbnormalLoadsCollectionOrder || {});
var B2BRouteHazardousLoadsCollectionOrder = /* @__PURE__ */ ((B2BRouteHazardousLoadsCollectionOrder2) => {
  B2BRouteHazardousLoadsCollectionOrder2["ClassificationAsc"] = "classification_ASC";
  B2BRouteHazardousLoadsCollectionOrder2["ClassificationDesc"] = "classification_DESC";
  B2BRouteHazardousLoadsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  B2BRouteHazardousLoadsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  B2BRouteHazardousLoadsCollectionOrder2["IdAsc"] = "id_ASC";
  B2BRouteHazardousLoadsCollectionOrder2["IdDesc"] = "id_DESC";
  B2BRouteHazardousLoadsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  B2BRouteHazardousLoadsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  B2BRouteHazardousLoadsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  B2BRouteHazardousLoadsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  B2BRouteHazardousLoadsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  B2BRouteHazardousLoadsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  B2BRouteHazardousLoadsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  B2BRouteHazardousLoadsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return B2BRouteHazardousLoadsCollectionOrder2;
})(B2BRouteHazardousLoadsCollectionOrder || {});
var B2BRouteOrder = /* @__PURE__ */ ((B2BRouteOrder2) => {
  B2BRouteOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  B2BRouteOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  B2BRouteOrder2["NameAsc"] = "name_ASC";
  B2BRouteOrder2["NameDesc"] = "name_DESC";
  B2BRouteOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  B2BRouteOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  B2BRouteOrder2["SysIdAsc"] = "sys_id_ASC";
  B2BRouteOrder2["SysIdDesc"] = "sys_id_DESC";
  B2BRouteOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  B2BRouteOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  B2BRouteOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  B2BRouteOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return B2BRouteOrder2;
})(B2BRouteOrder || {});
var B2BRouteUnitTypesCollectionOrder = /* @__PURE__ */ ((B2BRouteUnitTypesCollectionOrder2) => {
  B2BRouteUnitTypesCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  B2BRouteUnitTypesCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  B2BRouteUnitTypesCollectionOrder2["IdAsc"] = "id_ASC";
  B2BRouteUnitTypesCollectionOrder2["IdDesc"] = "id_DESC";
  B2BRouteUnitTypesCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  B2BRouteUnitTypesCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  B2BRouteUnitTypesCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  B2BRouteUnitTypesCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  B2BRouteUnitTypesCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  B2BRouteUnitTypesCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  B2BRouteUnitTypesCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  B2BRouteUnitTypesCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  B2BRouteUnitTypesCollectionOrder2["UnitTypeAsc"] = "unitType_ASC";
  B2BRouteUnitTypesCollectionOrder2["UnitTypeDesc"] = "unitType_DESC";
  return B2BRouteUnitTypesCollectionOrder2;
})(B2BRouteUnitTypesCollectionOrder || {});
var B2CCompositePageOrder = /* @__PURE__ */ ((B2CCompositePageOrder2) => {
  B2CCompositePageOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  B2CCompositePageOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  B2CCompositePageOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  B2CCompositePageOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  B2CCompositePageOrder2["SysIdAsc"] = "sys_id_ASC";
  B2CCompositePageOrder2["SysIdDesc"] = "sys_id_DESC";
  B2CCompositePageOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  B2CCompositePageOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  B2CCompositePageOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  B2CCompositePageOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return B2CCompositePageOrder2;
})(B2CCompositePageOrder || {});
var BannerOrder = /* @__PURE__ */ ((BannerOrder2) => {
  BannerOrder2["EnabledAsc"] = "enabled_ASC";
  BannerOrder2["EnabledDesc"] = "enabled_DESC";
  BannerOrder2["EntityNameAsc"] = "entityName_ASC";
  BannerOrder2["EntityNameDesc"] = "entityName_DESC";
  BannerOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  BannerOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  BannerOrder2["SysIdAsc"] = "sys_id_ASC";
  BannerOrder2["SysIdDesc"] = "sys_id_DESC";
  BannerOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  BannerOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  BannerOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  BannerOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  BannerOrder2["TextAsc"] = "text_ASC";
  BannerOrder2["TextDesc"] = "text_DESC";
  return BannerOrder2;
})(BannerOrder || {});
var CabinDetailsOrder = /* @__PURE__ */ ((CabinDetailsOrder2) => {
  CabinDetailsOrder2["CabinTypeCodeAsc"] = "cabinTypeCode_ASC";
  CabinDetailsOrder2["CabinTypeCodeDesc"] = "cabinTypeCode_DESC";
  CabinDetailsOrder2["HeadlineAsc"] = "headline_ASC";
  CabinDetailsOrder2["HeadlineDesc"] = "headline_DESC";
  CabinDetailsOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CabinDetailsOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CabinDetailsOrder2["SysIdAsc"] = "sys_id_ASC";
  CabinDetailsOrder2["SysIdDesc"] = "sys_id_DESC";
  CabinDetailsOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CabinDetailsOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CabinDetailsOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CabinDetailsOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CabinDetailsOrder2;
})(CabinDetailsOrder || {});
var CabinGroupOrder = /* @__PURE__ */ ((CabinGroupOrder2) => {
  CabinGroupOrder2["CabinGroupCodeAsc"] = "cabinGroupCode_ASC";
  CabinGroupOrder2["CabinGroupCodeDesc"] = "cabinGroupCode_DESC";
  CabinGroupOrder2["EditorDescriptionAsc"] = "editorDescription_ASC";
  CabinGroupOrder2["EditorDescriptionDesc"] = "editorDescription_DESC";
  CabinGroupOrder2["HeadlineAsc"] = "headline_ASC";
  CabinGroupOrder2["HeadlineDesc"] = "headline_DESC";
  CabinGroupOrder2["NoteAsc"] = "note_ASC";
  CabinGroupOrder2["NoteDesc"] = "note_DESC";
  CabinGroupOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CabinGroupOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CabinGroupOrder2["SysIdAsc"] = "sys_id_ASC";
  CabinGroupOrder2["SysIdDesc"] = "sys_id_DESC";
  CabinGroupOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CabinGroupOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CabinGroupOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CabinGroupOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CabinGroupOrder2;
})(CabinGroupOrder || {});
var CabinLinkingCollectionsFerryCollectionOrder = /* @__PURE__ */ ((CabinLinkingCollectionsFerryCollectionOrder2) => {
  CabinLinkingCollectionsFerryCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  CabinLinkingCollectionsFerryCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  CabinLinkingCollectionsFerryCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CabinLinkingCollectionsFerryCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CabinLinkingCollectionsFerryCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  CabinLinkingCollectionsFerryCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  CabinLinkingCollectionsFerryCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CabinLinkingCollectionsFerryCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CabinLinkingCollectionsFerryCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CabinLinkingCollectionsFerryCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CabinLinkingCollectionsFerryCollectionOrder2;
})(CabinLinkingCollectionsFerryCollectionOrder || {});
var CabinOrder = /* @__PURE__ */ ((CabinOrder2) => {
  CabinOrder2["CabinTitleAsc"] = "cabinTitle_ASC";
  CabinOrder2["CabinTitleDesc"] = "cabinTitle_DESC";
  CabinOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  CabinOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  CabinOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CabinOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CabinOrder2["SysIdAsc"] = "sys_id_ASC";
  CabinOrder2["SysIdDesc"] = "sys_id_DESC";
  CabinOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CabinOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CabinOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CabinOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CabinOrder2;
})(CabinOrder || {});
var CampaignBlockLinkingCollectionsMobilePageCollectionOrder = /* @__PURE__ */ ((CampaignBlockLinkingCollectionsMobilePageCollectionOrder2) => {
  CampaignBlockLinkingCollectionsMobilePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  CampaignBlockLinkingCollectionsMobilePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  CampaignBlockLinkingCollectionsMobilePageCollectionOrder2["PageTitleAsc"] = "pageTitle_ASC";
  CampaignBlockLinkingCollectionsMobilePageCollectionOrder2["PageTitleDesc"] = "pageTitle_DESC";
  CampaignBlockLinkingCollectionsMobilePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CampaignBlockLinkingCollectionsMobilePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CampaignBlockLinkingCollectionsMobilePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  CampaignBlockLinkingCollectionsMobilePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  CampaignBlockLinkingCollectionsMobilePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CampaignBlockLinkingCollectionsMobilePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CampaignBlockLinkingCollectionsMobilePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CampaignBlockLinkingCollectionsMobilePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CampaignBlockLinkingCollectionsMobilePageCollectionOrder2;
})(CampaignBlockLinkingCollectionsMobilePageCollectionOrder || {});
var CampaignBlockOrder = /* @__PURE__ */ ((CampaignBlockOrder2) => {
  CampaignBlockOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  CampaignBlockOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  CampaignBlockOrder2["PromotionCodeAsc"] = "promotionCode_ASC";
  CampaignBlockOrder2["PromotionCodeDesc"] = "promotionCode_DESC";
  CampaignBlockOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CampaignBlockOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CampaignBlockOrder2["SysIdAsc"] = "sys_id_ASC";
  CampaignBlockOrder2["SysIdDesc"] = "sys_id_DESC";
  CampaignBlockOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CampaignBlockOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CampaignBlockOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CampaignBlockOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CampaignBlockOrder2;
})(CampaignBlockOrder || {});
var CardsSectionLinkingCollectionsB2BCompositePageCollectionOrder = /* @__PURE__ */ ((CardsSectionLinkingCollectionsB2BCompositePageCollectionOrder2) => {
  CardsSectionLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  CardsSectionLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  CardsSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CardsSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CardsSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  CardsSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  CardsSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CardsSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CardsSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CardsSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CardsSectionLinkingCollectionsB2BCompositePageCollectionOrder2;
})(CardsSectionLinkingCollectionsB2BCompositePageCollectionOrder || {});
var CardsSectionLinkingCollectionsB2CCompositePageCollectionOrder = /* @__PURE__ */ ((CardsSectionLinkingCollectionsB2CCompositePageCollectionOrder2) => {
  CardsSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  CardsSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  CardsSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CardsSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CardsSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  CardsSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  CardsSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CardsSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CardsSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CardsSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CardsSectionLinkingCollectionsB2CCompositePageCollectionOrder2;
})(CardsSectionLinkingCollectionsB2CCompositePageCollectionOrder || {});
var CardsSectionOrder = /* @__PURE__ */ ((CardsSectionOrder2) => {
  CardsSectionOrder2["DisplayTypeAsc"] = "displayType_ASC";
  CardsSectionOrder2["DisplayTypeDesc"] = "displayType_DESC";
  CardsSectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  CardsSectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  CardsSectionOrder2["OverlineAsc"] = "overline_ASC";
  CardsSectionOrder2["OverlineDesc"] = "overline_DESC";
  CardsSectionOrder2["SectionBackgroundAndCardColorAsc"] = "sectionBackgroundAndCardColor_ASC";
  CardsSectionOrder2["SectionBackgroundAndCardColorDesc"] = "sectionBackgroundAndCardColor_DESC";
  CardsSectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  CardsSectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  CardsSectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CardsSectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CardsSectionOrder2["SysIdAsc"] = "sys_id_ASC";
  CardsSectionOrder2["SysIdDesc"] = "sys_id_DESC";
  CardsSectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CardsSectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CardsSectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CardsSectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CardsSectionOrder2;
})(CardsSectionOrder || {});
var ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder = /* @__PURE__ */ ((ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder2) => {
  ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder2["ErrorMessageAsc"] = "errorMessage_ASC";
  ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder2["ErrorMessageDesc"] = "errorMessage_DESC";
  ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder2["NameAsc"] = "name_ASC";
  ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder2["NameDesc"] = "name_DESC";
  ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder2;
})(ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder || {});
var ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder = /* @__PURE__ */ ((ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder2) => {
  ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder2["ErrorMessageAsc"] = "errorMessage_ASC";
  ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder2["ErrorMessageDesc"] = "errorMessage_DESC";
  ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder2["NameAsc"] = "name_ASC";
  ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder2["NameDesc"] = "name_DESC";
  ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder2;
})(ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder || {});
var ConsentTextOrder = /* @__PURE__ */ ((ConsentTextOrder2) => {
  ConsentTextOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ConsentTextOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ConsentTextOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ConsentTextOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ConsentTextOrder2["SysIdAsc"] = "sys_id_ASC";
  ConsentTextOrder2["SysIdDesc"] = "sys_id_DESC";
  ConsentTextOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ConsentTextOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ConsentTextOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ConsentTextOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ConsentTextOrder2;
})(ConsentTextOrder || {});
var ContentBlockCtasCollectionOrder = /* @__PURE__ */ ((ContentBlockCtasCollectionOrder2) => {
  ContentBlockCtasCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  ContentBlockCtasCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  ContentBlockCtasCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ContentBlockCtasCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ContentBlockCtasCollectionOrder2["LinkTypeAsc"] = "linkType_ASC";
  ContentBlockCtasCollectionOrder2["LinkTypeDesc"] = "linkType_DESC";
  ContentBlockCtasCollectionOrder2["OpenInNewWindowAsc"] = "openInNewWindow_ASC";
  ContentBlockCtasCollectionOrder2["OpenInNewWindowDesc"] = "openInNewWindow_DESC";
  ContentBlockCtasCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ContentBlockCtasCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ContentBlockCtasCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ContentBlockCtasCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ContentBlockCtasCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ContentBlockCtasCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ContentBlockCtasCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ContentBlockCtasCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  ContentBlockCtasCollectionOrder2["TooltipAsc"] = "tooltip_ASC";
  ContentBlockCtasCollectionOrder2["TooltipDesc"] = "tooltip_DESC";
  return ContentBlockCtasCollectionOrder2;
})(ContentBlockCtasCollectionOrder || {});
var ContentBlockLinkingCollectionsAppSectionCollectionOrder = /* @__PURE__ */ ((ContentBlockLinkingCollectionsAppSectionCollectionOrder2) => {
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["AppTypeAsc"] = "appType_ASC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["AppTypeDesc"] = "appType_DESC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["HideBackgroundImageOnMobileAsc"] = "hideBackgroundImageOnMobile_ASC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["HideBackgroundImageOnMobileDesc"] = "hideBackgroundImageOnMobile_DESC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["SectionDescriptionAsc"] = "sectionDescription_ASC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["SectionDescriptionDesc"] = "sectionDescription_DESC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ContentBlockLinkingCollectionsAppSectionCollectionOrder2;
})(ContentBlockLinkingCollectionsAppSectionCollectionOrder || {});
var ContentBlockLinkingCollectionsArticlePageCollectionOrder = /* @__PURE__ */ ((ContentBlockLinkingCollectionsArticlePageCollectionOrder2) => {
  ContentBlockLinkingCollectionsArticlePageCollectionOrder2["CategoryAsc"] = "category_ASC";
  ContentBlockLinkingCollectionsArticlePageCollectionOrder2["CategoryDesc"] = "category_DESC";
  ContentBlockLinkingCollectionsArticlePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ContentBlockLinkingCollectionsArticlePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ContentBlockLinkingCollectionsArticlePageCollectionOrder2["PublishedDateAsc"] = "publishedDate_ASC";
  ContentBlockLinkingCollectionsArticlePageCollectionOrder2["PublishedDateDesc"] = "publishedDate_DESC";
  ContentBlockLinkingCollectionsArticlePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ContentBlockLinkingCollectionsArticlePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ContentBlockLinkingCollectionsArticlePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ContentBlockLinkingCollectionsArticlePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ContentBlockLinkingCollectionsArticlePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ContentBlockLinkingCollectionsArticlePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ContentBlockLinkingCollectionsArticlePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ContentBlockLinkingCollectionsArticlePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ContentBlockLinkingCollectionsArticlePageCollectionOrder2;
})(ContentBlockLinkingCollectionsArticlePageCollectionOrder || {});
var ContentBlockLinkingCollectionsCampaignBlockCollectionOrder = /* @__PURE__ */ ((ContentBlockLinkingCollectionsCampaignBlockCollectionOrder2) => {
  ContentBlockLinkingCollectionsCampaignBlockCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ContentBlockLinkingCollectionsCampaignBlockCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ContentBlockLinkingCollectionsCampaignBlockCollectionOrder2["PromotionCodeAsc"] = "promotionCode_ASC";
  ContentBlockLinkingCollectionsCampaignBlockCollectionOrder2["PromotionCodeDesc"] = "promotionCode_DESC";
  ContentBlockLinkingCollectionsCampaignBlockCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ContentBlockLinkingCollectionsCampaignBlockCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ContentBlockLinkingCollectionsCampaignBlockCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ContentBlockLinkingCollectionsCampaignBlockCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ContentBlockLinkingCollectionsCampaignBlockCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ContentBlockLinkingCollectionsCampaignBlockCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ContentBlockLinkingCollectionsCampaignBlockCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ContentBlockLinkingCollectionsCampaignBlockCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ContentBlockLinkingCollectionsCampaignBlockCollectionOrder2;
})(ContentBlockLinkingCollectionsCampaignBlockCollectionOrder || {});
var ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder = /* @__PURE__ */ ((ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2) => {
  ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2["PageMetaDescriptionAsc"] = "pageMetaDescription_ASC";
  ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2["PageMetaDescriptionDesc"] = "pageMetaDescription_DESC";
  ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2["PageTitleAsc"] = "pageTitle_ASC";
  ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2["PageTitleDesc"] = "pageTitle_DESC";
  ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2["RobotsMetaAsc"] = "robotsMeta_ASC";
  ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2["RobotsMetaDesc"] = "robotsMeta_DESC";
  ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2;
})(ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder || {});
var ContentBlockLinkingCollectionsNavigationCollectionOrder = /* @__PURE__ */ ((ContentBlockLinkingCollectionsNavigationCollectionOrder2) => {
  ContentBlockLinkingCollectionsNavigationCollectionOrder2["BusinessAreaAsc"] = "businessArea_ASC";
  ContentBlockLinkingCollectionsNavigationCollectionOrder2["BusinessAreaDesc"] = "businessArea_DESC";
  ContentBlockLinkingCollectionsNavigationCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  ContentBlockLinkingCollectionsNavigationCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  ContentBlockLinkingCollectionsNavigationCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ContentBlockLinkingCollectionsNavigationCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ContentBlockLinkingCollectionsNavigationCollectionOrder2["OrderAsc"] = "order_ASC";
  ContentBlockLinkingCollectionsNavigationCollectionOrder2["OrderDesc"] = "order_DESC";
  ContentBlockLinkingCollectionsNavigationCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ContentBlockLinkingCollectionsNavigationCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ContentBlockLinkingCollectionsNavigationCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ContentBlockLinkingCollectionsNavigationCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ContentBlockLinkingCollectionsNavigationCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ContentBlockLinkingCollectionsNavigationCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ContentBlockLinkingCollectionsNavigationCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ContentBlockLinkingCollectionsNavigationCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ContentBlockLinkingCollectionsNavigationCollectionOrder2;
})(ContentBlockLinkingCollectionsNavigationCollectionOrder || {});
var ContentBlockLinkingCollectionsPageSectionCollectionOrder = /* @__PURE__ */ ((ContentBlockLinkingCollectionsPageSectionCollectionOrder2) => {
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["ColumnsAsc"] = "columns_ASC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["ColumnsDesc"] = "columns_DESC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["DisplayOptionAsc"] = "displayOption_ASC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["DisplayOptionDesc"] = "displayOption_DESC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["HideBackgroundImageOnMobileAsc"] = "hideBackgroundImageOnMobile_ASC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["HideBackgroundImageOnMobileDesc"] = "hideBackgroundImageOnMobile_DESC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["SectionDescriptionAsc"] = "sectionDescription_ASC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["SectionDescriptionDesc"] = "sectionDescription_DESC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ContentBlockLinkingCollectionsPageSectionCollectionOrder2;
})(ContentBlockLinkingCollectionsPageSectionCollectionOrder || {});
var ContentBlockOrder = /* @__PURE__ */ ((ContentBlockOrder2) => {
  ContentBlockOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ContentBlockOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ContentBlockOrder2["ImageDisplayOptionsAsc"] = "imageDisplayOptions_ASC";
  ContentBlockOrder2["ImageDisplayOptionsDesc"] = "imageDisplayOptions_DESC";
  ContentBlockOrder2["MediaTypeAsc"] = "mediaType_ASC";
  ContentBlockOrder2["MediaTypeDesc"] = "mediaType_DESC";
  ContentBlockOrder2["PrimaryTextAsc"] = "primaryText_ASC";
  ContentBlockOrder2["PrimaryTextDesc"] = "primaryText_DESC";
  ContentBlockOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ContentBlockOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ContentBlockOrder2["SysIdAsc"] = "sys_id_ASC";
  ContentBlockOrder2["SysIdDesc"] = "sys_id_DESC";
  ContentBlockOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ContentBlockOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ContentBlockOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ContentBlockOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  ContentBlockOrder2["TertiaryTextAsc"] = "tertiaryText_ASC";
  ContentBlockOrder2["TertiaryTextDesc"] = "tertiaryText_DESC";
  ContentBlockOrder2["VideoLinkAsc"] = "videoLink_ASC";
  ContentBlockOrder2["VideoLinkDesc"] = "videoLink_DESC";
  return ContentBlockOrder2;
})(ContentBlockOrder || {});
var DfdsAppSimpleStringOrder = /* @__PURE__ */ ((DfdsAppSimpleStringOrder2) => {
  DfdsAppSimpleStringOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  DfdsAppSimpleStringOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  DfdsAppSimpleStringOrder2["KeyAsc"] = "key_ASC";
  DfdsAppSimpleStringOrder2["KeyDesc"] = "key_DESC";
  DfdsAppSimpleStringOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  DfdsAppSimpleStringOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  DfdsAppSimpleStringOrder2["SysIdAsc"] = "sys_id_ASC";
  DfdsAppSimpleStringOrder2["SysIdDesc"] = "sys_id_DESC";
  DfdsAppSimpleStringOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  DfdsAppSimpleStringOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  DfdsAppSimpleStringOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  DfdsAppSimpleStringOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return DfdsAppSimpleStringOrder2;
})(DfdsAppSimpleStringOrder || {});
var EntryOrder = /* @__PURE__ */ ((EntryOrder2) => {
  EntryOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  EntryOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  EntryOrder2["SysIdAsc"] = "sys_id_ASC";
  EntryOrder2["SysIdDesc"] = "sys_id_DESC";
  EntryOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  EntryOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  EntryOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  EntryOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return EntryOrder2;
})(EntryOrder || {});
var EventLinkingCollectionsFerryCollectionOrder = /* @__PURE__ */ ((EventLinkingCollectionsFerryCollectionOrder2) => {
  EventLinkingCollectionsFerryCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  EventLinkingCollectionsFerryCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  EventLinkingCollectionsFerryCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  EventLinkingCollectionsFerryCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  EventLinkingCollectionsFerryCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  EventLinkingCollectionsFerryCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  EventLinkingCollectionsFerryCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  EventLinkingCollectionsFerryCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  EventLinkingCollectionsFerryCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  EventLinkingCollectionsFerryCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return EventLinkingCollectionsFerryCollectionOrder2;
})(EventLinkingCollectionsFerryCollectionOrder || {});
var EventOrder = /* @__PURE__ */ ((EventOrder2) => {
  EventOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  EventOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  EventOrder2["EventNameAsc"] = "eventName_ASC";
  EventOrder2["EventNameDesc"] = "eventName_DESC";
  EventOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  EventOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  EventOrder2["SysIdAsc"] = "sys_id_ASC";
  EventOrder2["SysIdDesc"] = "sys_id_DESC";
  EventOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  EventOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  EventOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  EventOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return EventOrder2;
})(EventOrder || {});
var FaresTiersTncOrder = /* @__PURE__ */ ((FaresTiersTncOrder2) => {
  FaresTiersTncOrder2["AmendableRowAsc"] = "amendableRow_ASC";
  FaresTiersTncOrder2["AmendableRowDesc"] = "amendableRow_DESC";
  FaresTiersTncOrder2["MealRowAsc"] = "mealRow_ASC";
  FaresTiersTncOrder2["MealRowDesc"] = "mealRow_DESC";
  FaresTiersTncOrder2["PortFlexibilityRowAsc"] = "portFlexibilityRow_ASC";
  FaresTiersTncOrder2["PortFlexibilityRowDesc"] = "portFlexibilityRow_DESC";
  FaresTiersTncOrder2["PremiumLoungeRowAsc"] = "premiumLoungeRow_ASC";
  FaresTiersTncOrder2["PremiumLoungeRowDesc"] = "premiumLoungeRow_DESC";
  FaresTiersTncOrder2["PriorityBoardingRowAsc"] = "priorityBoardingRow_ASC";
  FaresTiersTncOrder2["PriorityBoardingRowDesc"] = "priorityBoardingRow_DESC";
  FaresTiersTncOrder2["RefundableRowAsc"] = "refundableRow_ASC";
  FaresTiersTncOrder2["RefundableRowDesc"] = "refundableRow_DESC";
  FaresTiersTncOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FaresTiersTncOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FaresTiersTncOrder2["SysIdAsc"] = "sys_id_ASC";
  FaresTiersTncOrder2["SysIdDesc"] = "sys_id_DESC";
  FaresTiersTncOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FaresTiersTncOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FaresTiersTncOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FaresTiersTncOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FaresTiersTncOrder2["Tier1AmendableAsc"] = "tier1Amendable_ASC";
  FaresTiersTncOrder2["Tier1AmendableDesc"] = "tier1Amendable_DESC";
  FaresTiersTncOrder2["Tier1MealAsc"] = "tier1Meal_ASC";
  FaresTiersTncOrder2["Tier1MealDesc"] = "tier1Meal_DESC";
  FaresTiersTncOrder2["Tier1NameAsc"] = "tier1Name_ASC";
  FaresTiersTncOrder2["Tier1NameDesc"] = "tier1Name_DESC";
  FaresTiersTncOrder2["Tier1PortFlexibilityAsc"] = "tier1PortFlexibility_ASC";
  FaresTiersTncOrder2["Tier1PortFlexibilityDesc"] = "tier1PortFlexibility_DESC";
  FaresTiersTncOrder2["Tier1PremiumLoungeAsc"] = "tier1PremiumLounge_ASC";
  FaresTiersTncOrder2["Tier1PremiumLoungeDesc"] = "tier1PremiumLounge_DESC";
  FaresTiersTncOrder2["Tier1PriorityBoardingAsc"] = "tier1PriorityBoarding_ASC";
  FaresTiersTncOrder2["Tier1PriorityBoardingDesc"] = "tier1PriorityBoarding_DESC";
  FaresTiersTncOrder2["Tier1RefundableAsc"] = "tier1Refundable_ASC";
  FaresTiersTncOrder2["Tier1RefundableDesc"] = "tier1Refundable_DESC";
  FaresTiersTncOrder2["Tier1WifiAsc"] = "tier1Wifi_ASC";
  FaresTiersTncOrder2["Tier1WifiDesc"] = "tier1Wifi_DESC";
  FaresTiersTncOrder2["Tier2AmendableAsc"] = "tier2Amendable_ASC";
  FaresTiersTncOrder2["Tier2AmendableDesc"] = "tier2Amendable_DESC";
  FaresTiersTncOrder2["Tier2MealAsc"] = "tier2Meal_ASC";
  FaresTiersTncOrder2["Tier2MealDesc"] = "tier2Meal_DESC";
  FaresTiersTncOrder2["Tier2NameAsc"] = "tier2Name_ASC";
  FaresTiersTncOrder2["Tier2NameDesc"] = "tier2Name_DESC";
  FaresTiersTncOrder2["Tier2PortFlexibilityAsc"] = "tier2PortFlexibility_ASC";
  FaresTiersTncOrder2["Tier2PortFlexibilityDesc"] = "tier2PortFlexibility_DESC";
  FaresTiersTncOrder2["Tier2PremiumLoungeAsc"] = "tier2PremiumLounge_ASC";
  FaresTiersTncOrder2["Tier2PremiumLoungeDesc"] = "tier2PremiumLounge_DESC";
  FaresTiersTncOrder2["Tier2PriorityBoardingAsc"] = "tier2PriorityBoarding_ASC";
  FaresTiersTncOrder2["Tier2PriorityBoardingDesc"] = "tier2PriorityBoarding_DESC";
  FaresTiersTncOrder2["Tier2RefundableAsc"] = "tier2Refundable_ASC";
  FaresTiersTncOrder2["Tier2RefundableDesc"] = "tier2Refundable_DESC";
  FaresTiersTncOrder2["Tier2WifiAsc"] = "tier2Wifi_ASC";
  FaresTiersTncOrder2["Tier2WifiDesc"] = "tier2Wifi_DESC";
  FaresTiersTncOrder2["Tier3AmendableAsc"] = "tier3Amendable_ASC";
  FaresTiersTncOrder2["Tier3AmendableDesc"] = "tier3Amendable_DESC";
  FaresTiersTncOrder2["Tier3MealAsc"] = "tier3Meal_ASC";
  FaresTiersTncOrder2["Tier3MealDesc"] = "tier3Meal_DESC";
  FaresTiersTncOrder2["Tier3NameAsc"] = "tier3Name_ASC";
  FaresTiersTncOrder2["Tier3NameDesc"] = "tier3Name_DESC";
  FaresTiersTncOrder2["Tier3PortFlexibilityAsc"] = "tier3PortFlexibility_ASC";
  FaresTiersTncOrder2["Tier3PortFlexibilityDesc"] = "tier3PortFlexibility_DESC";
  FaresTiersTncOrder2["Tier3PremiumLoungeAsc"] = "tier3PremiumLounge_ASC";
  FaresTiersTncOrder2["Tier3PremiumLoungeDesc"] = "tier3PremiumLounge_DESC";
  FaresTiersTncOrder2["Tier3PriorityBoardingAsc"] = "tier3PriorityBoarding_ASC";
  FaresTiersTncOrder2["Tier3PriorityBoardingDesc"] = "tier3PriorityBoarding_DESC";
  FaresTiersTncOrder2["Tier3RefundableAsc"] = "tier3Refundable_ASC";
  FaresTiersTncOrder2["Tier3RefundableDesc"] = "tier3Refundable_DESC";
  FaresTiersTncOrder2["Tier3WifiAsc"] = "tier3Wifi_ASC";
  FaresTiersTncOrder2["Tier3WifiDesc"] = "tier3Wifi_DESC";
  FaresTiersTncOrder2["TitleDesktopAsc"] = "titleDesktop_ASC";
  FaresTiersTncOrder2["TitleDesktopDesc"] = "titleDesktop_DESC";
  FaresTiersTncOrder2["TitleMobileAsc"] = "titleMobile_ASC";
  FaresTiersTncOrder2["TitleMobileDesc"] = "titleMobile_DESC";
  FaresTiersTncOrder2["WifiRowAsc"] = "wifiRow_ASC";
  FaresTiersTncOrder2["WifiRowDesc"] = "wifiRow_DESC";
  return FaresTiersTncOrder2;
})(FaresTiersTncOrder || {});
var FerryCabinsCollectionOrder = /* @__PURE__ */ ((FerryCabinsCollectionOrder2) => {
  FerryCabinsCollectionOrder2["CabinTitleAsc"] = "cabinTitle_ASC";
  FerryCabinsCollectionOrder2["CabinTitleDesc"] = "cabinTitle_DESC";
  FerryCabinsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FerryCabinsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FerryCabinsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FerryCabinsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FerryCabinsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FerryCabinsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FerryCabinsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FerryCabinsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FerryCabinsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FerryCabinsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FerryCabinsCollectionOrder2;
})(FerryCabinsCollectionOrder || {});
var FerryEventsCollectionOrder = /* @__PURE__ */ ((FerryEventsCollectionOrder2) => {
  FerryEventsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FerryEventsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FerryEventsCollectionOrder2["EventNameAsc"] = "eventName_ASC";
  FerryEventsCollectionOrder2["EventNameDesc"] = "eventName_DESC";
  FerryEventsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FerryEventsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FerryEventsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FerryEventsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FerryEventsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FerryEventsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FerryEventsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FerryEventsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FerryEventsCollectionOrder2;
})(FerryEventsCollectionOrder || {});
var FerryFacilitiesCollectionOrder = /* @__PURE__ */ ((FerryFacilitiesCollectionOrder2) => {
  FerryFacilitiesCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FerryFacilitiesCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FerryFacilitiesCollectionOrder2["FacilityTypeAsc"] = "facilityType_ASC";
  FerryFacilitiesCollectionOrder2["FacilityTypeDesc"] = "facilityType_DESC";
  FerryFacilitiesCollectionOrder2["IdAsc"] = "id_ASC";
  FerryFacilitiesCollectionOrder2["IdDesc"] = "id_DESC";
  FerryFacilitiesCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FerryFacilitiesCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FerryFacilitiesCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FerryFacilitiesCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FerryFacilitiesCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FerryFacilitiesCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FerryFacilitiesCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FerryFacilitiesCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FerryFacilitiesCollectionOrder2;
})(FerryFacilitiesCollectionOrder || {});
var FerryFacilitiesLinkingCollectionsFerryCollectionOrder = /* @__PURE__ */ ((FerryFacilitiesLinkingCollectionsFerryCollectionOrder2) => {
  FerryFacilitiesLinkingCollectionsFerryCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FerryFacilitiesLinkingCollectionsFerryCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FerryFacilitiesLinkingCollectionsFerryCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FerryFacilitiesLinkingCollectionsFerryCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FerryFacilitiesLinkingCollectionsFerryCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FerryFacilitiesLinkingCollectionsFerryCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FerryFacilitiesLinkingCollectionsFerryCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FerryFacilitiesLinkingCollectionsFerryCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FerryFacilitiesLinkingCollectionsFerryCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FerryFacilitiesLinkingCollectionsFerryCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FerryFacilitiesLinkingCollectionsFerryCollectionOrder2;
})(FerryFacilitiesLinkingCollectionsFerryCollectionOrder || {});
var FerryFacilitiesOrder = /* @__PURE__ */ ((FerryFacilitiesOrder2) => {
  FerryFacilitiesOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FerryFacilitiesOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FerryFacilitiesOrder2["FacilityTypeAsc"] = "facilityType_ASC";
  FerryFacilitiesOrder2["FacilityTypeDesc"] = "facilityType_DESC";
  FerryFacilitiesOrder2["IdAsc"] = "id_ASC";
  FerryFacilitiesOrder2["IdDesc"] = "id_DESC";
  FerryFacilitiesOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FerryFacilitiesOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FerryFacilitiesOrder2["SysIdAsc"] = "sys_id_ASC";
  FerryFacilitiesOrder2["SysIdDesc"] = "sys_id_DESC";
  FerryFacilitiesOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FerryFacilitiesOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FerryFacilitiesOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FerryFacilitiesOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FerryFacilitiesOrder2;
})(FerryFacilitiesOrder || {});
var FerryInstructionAndSignalisationCollectionOrder = /* @__PURE__ */ ((FerryInstructionAndSignalisationCollectionOrder2) => {
  FerryInstructionAndSignalisationCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FerryInstructionAndSignalisationCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FerryInstructionAndSignalisationCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FerryInstructionAndSignalisationCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FerryInstructionAndSignalisationCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FerryInstructionAndSignalisationCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FerryInstructionAndSignalisationCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FerryInstructionAndSignalisationCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FerryInstructionAndSignalisationCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FerryInstructionAndSignalisationCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FerryInstructionAndSignalisationCollectionOrder2["TypeAsc"] = "type_ASC";
  FerryInstructionAndSignalisationCollectionOrder2["TypeDesc"] = "type_DESC";
  return FerryInstructionAndSignalisationCollectionOrder2;
})(FerryInstructionAndSignalisationCollectionOrder || {});
var FerryLinkingCollectionsPaxRouteCollectionOrder = /* @__PURE__ */ ((FerryLinkingCollectionsPaxRouteCollectionOrder2) => {
  FerryLinkingCollectionsPaxRouteCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FerryLinkingCollectionsPaxRouteCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FerryLinkingCollectionsPaxRouteCollectionOrder2["NameAsc"] = "name_ASC";
  FerryLinkingCollectionsPaxRouteCollectionOrder2["NameDesc"] = "name_DESC";
  FerryLinkingCollectionsPaxRouteCollectionOrder2["PaxScheduleApiCodeIdAsc"] = "paxScheduleApiCodeId_ASC";
  FerryLinkingCollectionsPaxRouteCollectionOrder2["PaxScheduleApiCodeIdDesc"] = "paxScheduleApiCodeId_DESC";
  FerryLinkingCollectionsPaxRouteCollectionOrder2["RouteMarketingTitleAsc"] = "routeMarketingTitle_ASC";
  FerryLinkingCollectionsPaxRouteCollectionOrder2["RouteMarketingTitleDesc"] = "routeMarketingTitle_DESC";
  FerryLinkingCollectionsPaxRouteCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FerryLinkingCollectionsPaxRouteCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FerryLinkingCollectionsPaxRouteCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FerryLinkingCollectionsPaxRouteCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FerryLinkingCollectionsPaxRouteCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FerryLinkingCollectionsPaxRouteCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FerryLinkingCollectionsPaxRouteCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FerryLinkingCollectionsPaxRouteCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FerryLinkingCollectionsPaxRouteCollectionOrder2;
})(FerryLinkingCollectionsPaxRouteCollectionOrder || {});
var FerryOrder = /* @__PURE__ */ ((FerryOrder2) => {
  FerryOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FerryOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FerryOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FerryOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FerryOrder2["SysIdAsc"] = "sys_id_ASC";
  FerryOrder2["SysIdDesc"] = "sys_id_DESC";
  FerryOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FerryOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FerryOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FerryOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FerryOrder2;
})(FerryOrder || {});
var FerryPetsInfoCollectionOrder = /* @__PURE__ */ ((FerryPetsInfoCollectionOrder2) => {
  FerryPetsInfoCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FerryPetsInfoCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FerryPetsInfoCollectionOrder2["IdAsc"] = "id_ASC";
  FerryPetsInfoCollectionOrder2["IdDesc"] = "id_DESC";
  FerryPetsInfoCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FerryPetsInfoCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FerryPetsInfoCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FerryPetsInfoCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FerryPetsInfoCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FerryPetsInfoCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FerryPetsInfoCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FerryPetsInfoCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FerryPetsInfoCollectionOrder2["TypeAsc"] = "type_ASC";
  FerryPetsInfoCollectionOrder2["TypeDesc"] = "type_DESC";
  return FerryPetsInfoCollectionOrder2;
})(FerryPetsInfoCollectionOrder || {});
var FerryRestaurantsCollectionOrder = /* @__PURE__ */ ((FerryRestaurantsCollectionOrder2) => {
  FerryRestaurantsCollectionOrder2["BannerLine1Asc"] = "bannerLine1_ASC";
  FerryRestaurantsCollectionOrder2["BannerLine1Desc"] = "bannerLine1_DESC";
  FerryRestaurantsCollectionOrder2["BannerLine2LargeAsc"] = "bannerLine2Large_ASC";
  FerryRestaurantsCollectionOrder2["BannerLine2LargeDesc"] = "bannerLine2Large_DESC";
  FerryRestaurantsCollectionOrder2["BannerLine2SmallAsc"] = "bannerLine2Small_ASC";
  FerryRestaurantsCollectionOrder2["BannerLine2SmallDesc"] = "bannerLine2Small_DESC";
  FerryRestaurantsCollectionOrder2["BannerLine3Asc"] = "bannerLine3_ASC";
  FerryRestaurantsCollectionOrder2["BannerLine3Desc"] = "bannerLine3_DESC";
  FerryRestaurantsCollectionOrder2["CloseButtonLightThemeAsc"] = "closeButtonLightTheme_ASC";
  FerryRestaurantsCollectionOrder2["CloseButtonLightThemeDesc"] = "closeButtonLightTheme_DESC";
  FerryRestaurantsCollectionOrder2["DefaultSeatingTimeAsc"] = "defaultSeatingTime_ASC";
  FerryRestaurantsCollectionOrder2["DefaultSeatingTimeDesc"] = "defaultSeatingTime_DESC";
  FerryRestaurantsCollectionOrder2["HeadlineAsc"] = "headline_ASC";
  FerryRestaurantsCollectionOrder2["HeadlineDesc"] = "headline_DESC";
  FerryRestaurantsCollectionOrder2["HighlightedAsc"] = "highlighted_ASC";
  FerryRestaurantsCollectionOrder2["HighlightedDesc"] = "highlighted_DESC";
  FerryRestaurantsCollectionOrder2["MenuBeveragesHeadlineAsc"] = "menuBeveragesHeadline_ASC";
  FerryRestaurantsCollectionOrder2["MenuBeveragesHeadlineDesc"] = "menuBeveragesHeadline_DESC";
  FerryRestaurantsCollectionOrder2["MenuCardForChildrenTitleAsc"] = "menuCardForChildrenTitle_ASC";
  FerryRestaurantsCollectionOrder2["MenuCardForChildrenTitleDesc"] = "menuCardForChildrenTitle_DESC";
  FerryRestaurantsCollectionOrder2["MenuCardTitleAsc"] = "menuCardTitle_ASC";
  FerryRestaurantsCollectionOrder2["MenuCardTitleDesc"] = "menuCardTitle_DESC";
  FerryRestaurantsCollectionOrder2["MenuDessertsHeadlineAsc"] = "menuDessertsHeadline_ASC";
  FerryRestaurantsCollectionOrder2["MenuDessertsHeadlineDesc"] = "menuDessertsHeadline_DESC";
  FerryRestaurantsCollectionOrder2["MenuForChildrenHeadlineAsc"] = "menuForChildrenHeadline_ASC";
  FerryRestaurantsCollectionOrder2["MenuForChildrenHeadlineDesc"] = "menuForChildrenHeadline_DESC";
  FerryRestaurantsCollectionOrder2["MenuMainCourseExtrasHeadlineAsc"] = "menuMainCourseExtrasHeadline_ASC";
  FerryRestaurantsCollectionOrder2["MenuMainCourseExtrasHeadlineDesc"] = "menuMainCourseExtrasHeadline_DESC";
  FerryRestaurantsCollectionOrder2["MenuMainCoursesExpandedAsc"] = "menuMainCoursesExpanded_ASC";
  FerryRestaurantsCollectionOrder2["MenuMainCoursesExpandedDesc"] = "menuMainCoursesExpanded_DESC";
  FerryRestaurantsCollectionOrder2["MenuMainCoursesHeadlineAsc"] = "menuMainCoursesHeadline_ASC";
  FerryRestaurantsCollectionOrder2["MenuMainCoursesHeadlineDesc"] = "menuMainCoursesHeadline_DESC";
  FerryRestaurantsCollectionOrder2["MenuSectionsNoCollapseAsc"] = "menuSectionsNoCollapse_ASC";
  FerryRestaurantsCollectionOrder2["MenuSectionsNoCollapseDesc"] = "menuSectionsNoCollapse_DESC";
  FerryRestaurantsCollectionOrder2["MenuStartersExpandedAsc"] = "menuStartersExpanded_ASC";
  FerryRestaurantsCollectionOrder2["MenuStartersExpandedDesc"] = "menuStartersExpanded_DESC";
  FerryRestaurantsCollectionOrder2["MenuStartersHeadlineAsc"] = "menuStartersHeadline_ASC";
  FerryRestaurantsCollectionOrder2["MenuStartersHeadlineDesc"] = "menuStartersHeadline_DESC";
  FerryRestaurantsCollectionOrder2["RestaurantCodeAsc"] = "restaurantCode_ASC";
  FerryRestaurantsCollectionOrder2["RestaurantCodeDesc"] = "restaurantCode_DESC";
  FerryRestaurantsCollectionOrder2["RestaurantNameAsc"] = "restaurantName_ASC";
  FerryRestaurantsCollectionOrder2["RestaurantNameDesc"] = "restaurantName_DESC";
  FerryRestaurantsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FerryRestaurantsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FerryRestaurantsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FerryRestaurantsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FerryRestaurantsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FerryRestaurantsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FerryRestaurantsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FerryRestaurantsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FerryRestaurantsCollectionOrder2;
})(FerryRestaurantsCollectionOrder || {});
var FieldControllerLinkingCollectionsFormRowCollectionOrder = /* @__PURE__ */ ((FieldControllerLinkingCollectionsFormRowCollectionOrder2) => {
  FieldControllerLinkingCollectionsFormRowCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FieldControllerLinkingCollectionsFormRowCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FieldControllerLinkingCollectionsFormRowCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FieldControllerLinkingCollectionsFormRowCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FieldControllerLinkingCollectionsFormRowCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FieldControllerLinkingCollectionsFormRowCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FieldControllerLinkingCollectionsFormRowCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FieldControllerLinkingCollectionsFormRowCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FieldControllerLinkingCollectionsFormRowCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FieldControllerLinkingCollectionsFormRowCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FieldControllerLinkingCollectionsFormRowCollectionOrder2;
})(FieldControllerLinkingCollectionsFormRowCollectionOrder || {});
var FieldControllerOrder = /* @__PURE__ */ ((FieldControllerOrder2) => {
  FieldControllerOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FieldControllerOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FieldControllerOrder2["QuestionAsc"] = "question_ASC";
  FieldControllerOrder2["QuestionDesc"] = "question_DESC";
  FieldControllerOrder2["RequiredAsc"] = "required_ASC";
  FieldControllerOrder2["RequiredDesc"] = "required_DESC";
  FieldControllerOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FieldControllerOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FieldControllerOrder2["SysIdAsc"] = "sys_id_ASC";
  FieldControllerOrder2["SysIdDesc"] = "sys_id_DESC";
  FieldControllerOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FieldControllerOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FieldControllerOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FieldControllerOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FieldControllerOrder2;
})(FieldControllerOrder || {});
var FieldLinkingCollectionsFieldControllerCollectionOrder = /* @__PURE__ */ ((FieldLinkingCollectionsFieldControllerCollectionOrder2) => {
  FieldLinkingCollectionsFieldControllerCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FieldLinkingCollectionsFieldControllerCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FieldLinkingCollectionsFieldControllerCollectionOrder2["QuestionAsc"] = "question_ASC";
  FieldLinkingCollectionsFieldControllerCollectionOrder2["QuestionDesc"] = "question_DESC";
  FieldLinkingCollectionsFieldControllerCollectionOrder2["RequiredAsc"] = "required_ASC";
  FieldLinkingCollectionsFieldControllerCollectionOrder2["RequiredDesc"] = "required_DESC";
  FieldLinkingCollectionsFieldControllerCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FieldLinkingCollectionsFieldControllerCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FieldLinkingCollectionsFieldControllerCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FieldLinkingCollectionsFieldControllerCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FieldLinkingCollectionsFieldControllerCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FieldLinkingCollectionsFieldControllerCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FieldLinkingCollectionsFieldControllerCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FieldLinkingCollectionsFieldControllerCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FieldLinkingCollectionsFieldControllerCollectionOrder2;
})(FieldLinkingCollectionsFieldControllerCollectionOrder || {});
var FieldOptionsCollectionOrder = /* @__PURE__ */ ((FieldOptionsCollectionOrder2) => {
  FieldOptionsCollectionOrder2["DisplayValueAsc"] = "displayValue_ASC";
  FieldOptionsCollectionOrder2["DisplayValueDesc"] = "displayValue_DESC";
  FieldOptionsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FieldOptionsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FieldOptionsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FieldOptionsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FieldOptionsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FieldOptionsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FieldOptionsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FieldOptionsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FieldOptionsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FieldOptionsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FieldOptionsCollectionOrder2["ValueAsc"] = "value_ASC";
  FieldOptionsCollectionOrder2["ValueDesc"] = "value_DESC";
  return FieldOptionsCollectionOrder2;
})(FieldOptionsCollectionOrder || {});
var FieldOrder = /* @__PURE__ */ ((FieldOrder2) => {
  FieldOrder2["AssistiveTextAsc"] = "assistiveText_ASC";
  FieldOrder2["AssistiveTextDesc"] = "assistiveText_DESC";
  FieldOrder2["CounterAsc"] = "counter_ASC";
  FieldOrder2["CounterDesc"] = "counter_DESC";
  FieldOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FieldOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FieldOrder2["ErrorMessageAsc"] = "errorMessage_ASC";
  FieldOrder2["ErrorMessageDesc"] = "errorMessage_DESC";
  FieldOrder2["IdAsc"] = "id_ASC";
  FieldOrder2["IdDesc"] = "id_DESC";
  FieldOrder2["InputTypeAsc"] = "inputType_ASC";
  FieldOrder2["InputTypeDesc"] = "inputType_DESC";
  FieldOrder2["PlaceholderAsc"] = "placeholder_ASC";
  FieldOrder2["PlaceholderDesc"] = "placeholder_DESC";
  FieldOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FieldOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FieldOrder2["SysIdAsc"] = "sys_id_ASC";
  FieldOrder2["SysIdDesc"] = "sys_id_DESC";
  FieldOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FieldOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FieldOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FieldOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FieldOrder2;
})(FieldOrder || {});
var FlowCabinFaresOrder = /* @__PURE__ */ ((FlowCabinFaresOrder2) => {
  FlowCabinFaresOrder2["DepartureDateAsc"] = "departureDate_ASC";
  FlowCabinFaresOrder2["DepartureDateDesc"] = "departureDate_DESC";
  FlowCabinFaresOrder2["HeadlineAsc"] = "headline_ASC";
  FlowCabinFaresOrder2["HeadlineDesc"] = "headline_DESC";
  FlowCabinFaresOrder2["MoreThanOneCabinSelectedPopupContinueButtonAsc"] = "moreThanOneCabinSelectedPopupContinueButton_ASC";
  FlowCabinFaresOrder2["MoreThanOneCabinSelectedPopupContinueButtonDesc"] = "moreThanOneCabinSelectedPopupContinueButton_DESC";
  FlowCabinFaresOrder2["MoreThanOneCabinSelectedPopupStayButtonAsc"] = "moreThanOneCabinSelectedPopupStayButton_ASC";
  FlowCabinFaresOrder2["MoreThanOneCabinSelectedPopupStayButtonDesc"] = "moreThanOneCabinSelectedPopupStayButton_DESC";
  FlowCabinFaresOrder2["MoreThanOneCabinSelectedPopupTitleAsc"] = "moreThanOneCabinSelectedPopupTitle_ASC";
  FlowCabinFaresOrder2["MoreThanOneCabinSelectedPopupTitleDesc"] = "moreThanOneCabinSelectedPopupTitle_DESC";
  FlowCabinFaresOrder2["NavigationDateFormatAsc"] = "navigationDateFormat_ASC";
  FlowCabinFaresOrder2["NavigationDateFormatDesc"] = "navigationDateFormat_DESC";
  FlowCabinFaresOrder2["NoDeparturesAsc"] = "noDepartures_ASC";
  FlowCabinFaresOrder2["NoDeparturesDesc"] = "noDepartures_DESC";
  FlowCabinFaresOrder2["NotAvailablePopupHeadingAsc"] = "notAvailablePopupHeading_ASC";
  FlowCabinFaresOrder2["NotAvailablePopupHeadingDesc"] = "notAvailablePopupHeading_DESC";
  FlowCabinFaresOrder2["NotAvailablePopupReloadAsc"] = "notAvailablePopupReload_ASC";
  FlowCabinFaresOrder2["NotAvailablePopupReloadDesc"] = "notAvailablePopupReload_DESC";
  FlowCabinFaresOrder2["ReturnDateAsc"] = "returnDate_ASC";
  FlowCabinFaresOrder2["ReturnDateDesc"] = "returnDate_DESC";
  FlowCabinFaresOrder2["SelectDateAsc"] = "selectDate_ASC";
  FlowCabinFaresOrder2["SelectDateDesc"] = "selectDate_DESC";
  FlowCabinFaresOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FlowCabinFaresOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FlowCabinFaresOrder2["SysIdAsc"] = "sys_id_ASC";
  FlowCabinFaresOrder2["SysIdDesc"] = "sys_id_DESC";
  FlowCabinFaresOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FlowCabinFaresOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FlowCabinFaresOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FlowCabinFaresOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FlowCabinFaresOrder2["TitleAsc"] = "title_ASC";
  FlowCabinFaresOrder2["TitleDesc"] = "title_DESC";
  return FlowCabinFaresOrder2;
})(FlowCabinFaresOrder || {});
var FlowCabinOrder = /* @__PURE__ */ ((FlowCabinOrder2) => {
  FlowCabinOrder2["NoCabinsAvailableAsc"] = "noCabinsAvailable_ASC";
  FlowCabinOrder2["NoCabinsAvailableDesc"] = "noCabinsAvailable_DESC";
  FlowCabinOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FlowCabinOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FlowCabinOrder2["SysIdAsc"] = "sys_id_ASC";
  FlowCabinOrder2["SysIdDesc"] = "sys_id_DESC";
  FlowCabinOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FlowCabinOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FlowCabinOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FlowCabinOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FlowCabinOrder2;
})(FlowCabinOrder || {});
var FlowFaresOrder = /* @__PURE__ */ ((FlowFaresOrder2) => {
  FlowFaresOrder2["AcceptAndContinueAsc"] = "acceptAndContinue_ASC";
  FlowFaresOrder2["AcceptAndContinueDesc"] = "acceptAndContinue_DESC";
  FlowFaresOrder2["DepartureDateAsc"] = "departureDate_ASC";
  FlowFaresOrder2["DepartureDateDesc"] = "departureDate_DESC";
  FlowFaresOrder2["ReturnDateAsc"] = "returnDate_ASC";
  FlowFaresOrder2["ReturnDateDesc"] = "returnDate_DESC";
  FlowFaresOrder2["SelectDateAsc"] = "selectDate_ASC";
  FlowFaresOrder2["SelectDateDesc"] = "selectDate_DESC";
  FlowFaresOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FlowFaresOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FlowFaresOrder2["SysIdAsc"] = "sys_id_ASC";
  FlowFaresOrder2["SysIdDesc"] = "sys_id_DESC";
  FlowFaresOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FlowFaresOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FlowFaresOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FlowFaresOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FlowFaresOrder2["Tier3CategoryChangedHeaderAsc"] = "tier3CategoryChangedHeader_ASC";
  FlowFaresOrder2["Tier3CategoryChangedHeaderDesc"] = "tier3CategoryChangedHeader_DESC";
  FlowFaresOrder2["Tier3CategoryChangedAsc"] = "tier3CategoryChanged_ASC";
  FlowFaresOrder2["Tier3CategoryChangedDesc"] = "tier3CategoryChanged_DESC";
  FlowFaresOrder2["Tier3WhatIsIncludedAsc"] = "tier3WhatIsIncluded_ASC";
  FlowFaresOrder2["Tier3WhatIsIncludedDesc"] = "tier3WhatIsIncluded_DESC";
  return FlowFaresOrder2;
})(FlowFaresOrder || {});
var FlowMealsOrder = /* @__PURE__ */ ((FlowMealsOrder2) => {
  FlowMealsOrder2["NoMealsAvailableAsc"] = "noMealsAvailable_ASC";
  FlowMealsOrder2["NoMealsAvailableDesc"] = "noMealsAvailable_DESC";
  FlowMealsOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FlowMealsOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FlowMealsOrder2["SysIdAsc"] = "sys_id_ASC";
  FlowMealsOrder2["SysIdDesc"] = "sys_id_DESC";
  FlowMealsOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FlowMealsOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FlowMealsOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FlowMealsOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FlowMealsOrder2;
})(FlowMealsOrder || {});
var FlowTravelOrder = /* @__PURE__ */ ((FlowTravelOrder2) => {
  FlowTravelOrder2["OnewayAsc"] = "oneway_ASC";
  FlowTravelOrder2["OnewayDesc"] = "oneway_DESC";
  FlowTravelOrder2["PetParameterRequiresVehicleAsc"] = "petParameterRequiresVehicle_ASC";
  FlowTravelOrder2["PetParameterRequiresVehicleDesc"] = "petParameterRequiresVehicle_DESC";
  FlowTravelOrder2["ReturnAsc"] = "return_ASC";
  FlowTravelOrder2["ReturnDesc"] = "return_DESC";
  FlowTravelOrder2["SelectDateAsc"] = "selectDate_ASC";
  FlowTravelOrder2["SelectDateDesc"] = "selectDate_DESC";
  FlowTravelOrder2["SelectedDateNotAvailableAsc"] = "selectedDateNotAvailable_ASC";
  FlowTravelOrder2["SelectedDateNotAvailableDesc"] = "selectedDateNotAvailable_DESC";
  FlowTravelOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FlowTravelOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FlowTravelOrder2["SysIdAsc"] = "sys_id_ASC";
  FlowTravelOrder2["SysIdDesc"] = "sys_id_DESC";
  FlowTravelOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FlowTravelOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FlowTravelOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FlowTravelOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FlowTravelOrder2["VehicleParameterRequiresTrailerTypeAsc"] = "vehicleParameterRequiresTrailerType_ASC";
  FlowTravelOrder2["VehicleParameterRequiresTrailerTypeDesc"] = "vehicleParameterRequiresTrailerType_DESC";
  return FlowTravelOrder2;
})(FlowTravelOrder || {});
var FooterColumnsCollectionOrder = /* @__PURE__ */ ((FooterColumnsCollectionOrder2) => {
  FooterColumnsCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  FooterColumnsCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  FooterColumnsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FooterColumnsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FooterColumnsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FooterColumnsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FooterColumnsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FooterColumnsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FooterColumnsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FooterColumnsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FooterColumnsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FooterColumnsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FooterColumnsCollectionOrder2["TooltipAsc"] = "tooltip_ASC";
  FooterColumnsCollectionOrder2["TooltipDesc"] = "tooltip_DESC";
  return FooterColumnsCollectionOrder2;
})(FooterColumnsCollectionOrder || {});
var FooterOrder = /* @__PURE__ */ ((FooterOrder2) => {
  FooterOrder2["BusinessUnitAsc"] = "businessUnit_ASC";
  FooterOrder2["BusinessUnitDesc"] = "businessUnit_DESC";
  FooterOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FooterOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FooterOrder2["LocaleSelectorLabelAsc"] = "localeSelectorLabel_ASC";
  FooterOrder2["LocaleSelectorLabelDesc"] = "localeSelectorLabel_DESC";
  FooterOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FooterOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FooterOrder2["SysIdAsc"] = "sys_id_ASC";
  FooterOrder2["SysIdDesc"] = "sys_id_DESC";
  FooterOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FooterOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FooterOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FooterOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FooterOrder2;
})(FooterOrder || {});
var FormCheckboxFieldOrder = /* @__PURE__ */ ((FormCheckboxFieldOrder2) => {
  FormCheckboxFieldOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormCheckboxFieldOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormCheckboxFieldOrder2["RequiredAsc"] = "required_ASC";
  FormCheckboxFieldOrder2["RequiredDesc"] = "required_DESC";
  FormCheckboxFieldOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormCheckboxFieldOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormCheckboxFieldOrder2["SysIdAsc"] = "sys_id_ASC";
  FormCheckboxFieldOrder2["SysIdDesc"] = "sys_id_DESC";
  FormCheckboxFieldOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormCheckboxFieldOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormCheckboxFieldOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormCheckboxFieldOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FormCheckboxFieldOrder2["TitleAsc"] = "title_ASC";
  FormCheckboxFieldOrder2["TitleDesc"] = "title_DESC";
  return FormCheckboxFieldOrder2;
})(FormCheckboxFieldOrder || {});
var FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder = /* @__PURE__ */ ((FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2) => {
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["CommercialOwnerAsc"] = "commercialOwner_ASC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["CommercialOwnerDesc"] = "commercialOwner_DESC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["TrackingConversionPointAsc"] = "trackingConversionPoint_ASC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["TrackingConversionPointDesc"] = "trackingConversionPoint_DESC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["TrackingConversionTypeAsc"] = "trackingConversionType_ASC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["TrackingConversionTypeDesc"] = "trackingConversionType_DESC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["TrackingNameAsc"] = "trackingName_ASC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["TrackingNameDesc"] = "trackingName_DESC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["TrackingStageAsc"] = "trackingStage_ASC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["TrackingStageDesc"] = "trackingStage_DESC";
  return FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2;
})(FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder || {});
var FormConsentCheckboxFieldOrder = /* @__PURE__ */ ((FormConsentCheckboxFieldOrder2) => {
  FormConsentCheckboxFieldOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormConsentCheckboxFieldOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormConsentCheckboxFieldOrder2["ErrorMessageAsc"] = "errorMessage_ASC";
  FormConsentCheckboxFieldOrder2["ErrorMessageDesc"] = "errorMessage_DESC";
  FormConsentCheckboxFieldOrder2["NameAsc"] = "name_ASC";
  FormConsentCheckboxFieldOrder2["NameDesc"] = "name_DESC";
  FormConsentCheckboxFieldOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormConsentCheckboxFieldOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormConsentCheckboxFieldOrder2["SysIdAsc"] = "sys_id_ASC";
  FormConsentCheckboxFieldOrder2["SysIdDesc"] = "sys_id_DESC";
  FormConsentCheckboxFieldOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormConsentCheckboxFieldOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormConsentCheckboxFieldOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormConsentCheckboxFieldOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FormConsentCheckboxFieldOrder2;
})(FormConsentCheckboxFieldOrder || {});
var FormInputFieldOrder = /* @__PURE__ */ ((FormInputFieldOrder2) => {
  FormInputFieldOrder2["AssistiveTextAsc"] = "assistiveText_ASC";
  FormInputFieldOrder2["AssistiveTextDesc"] = "assistiveText_DESC";
  FormInputFieldOrder2["DefaultValueAsc"] = "defaultValue_ASC";
  FormInputFieldOrder2["DefaultValueDesc"] = "defaultValue_DESC";
  FormInputFieldOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormInputFieldOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormInputFieldOrder2["ErrorMessageAsc"] = "errorMessage_ASC";
  FormInputFieldOrder2["ErrorMessageDesc"] = "errorMessage_DESC";
  FormInputFieldOrder2["HintTextAsc"] = "hintText_ASC";
  FormInputFieldOrder2["HintTextDesc"] = "hintText_DESC";
  FormInputFieldOrder2["KeyAsc"] = "key_ASC";
  FormInputFieldOrder2["KeyDesc"] = "key_DESC";
  FormInputFieldOrder2["LabelAsc"] = "label_ASC";
  FormInputFieldOrder2["LabelDesc"] = "label_DESC";
  FormInputFieldOrder2["NameAsc"] = "name_ASC";
  FormInputFieldOrder2["NameDesc"] = "name_DESC";
  FormInputFieldOrder2["RequiredAsc"] = "required_ASC";
  FormInputFieldOrder2["RequiredDesc"] = "required_DESC";
  FormInputFieldOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormInputFieldOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormInputFieldOrder2["SysIdAsc"] = "sys_id_ASC";
  FormInputFieldOrder2["SysIdDesc"] = "sys_id_DESC";
  FormInputFieldOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormInputFieldOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormInputFieldOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormInputFieldOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FormInputFieldOrder2["TypeAsc"] = "type_ASC";
  FormInputFieldOrder2["TypeDesc"] = "type_DESC";
  return FormInputFieldOrder2;
})(FormInputFieldOrder || {});
var FormLinkingCollectionsAppSectionCollectionOrder = /* @__PURE__ */ ((FormLinkingCollectionsAppSectionCollectionOrder2) => {
  FormLinkingCollectionsAppSectionCollectionOrder2["AppTypeAsc"] = "appType_ASC";
  FormLinkingCollectionsAppSectionCollectionOrder2["AppTypeDesc"] = "appType_DESC";
  FormLinkingCollectionsAppSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormLinkingCollectionsAppSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormLinkingCollectionsAppSectionCollectionOrder2["HideBackgroundImageOnMobileAsc"] = "hideBackgroundImageOnMobile_ASC";
  FormLinkingCollectionsAppSectionCollectionOrder2["HideBackgroundImageOnMobileDesc"] = "hideBackgroundImageOnMobile_DESC";
  FormLinkingCollectionsAppSectionCollectionOrder2["SectionDescriptionAsc"] = "sectionDescription_ASC";
  FormLinkingCollectionsAppSectionCollectionOrder2["SectionDescriptionDesc"] = "sectionDescription_DESC";
  FormLinkingCollectionsAppSectionCollectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  FormLinkingCollectionsAppSectionCollectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  FormLinkingCollectionsAppSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormLinkingCollectionsAppSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormLinkingCollectionsAppSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FormLinkingCollectionsAppSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FormLinkingCollectionsAppSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormLinkingCollectionsAppSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormLinkingCollectionsAppSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormLinkingCollectionsAppSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FormLinkingCollectionsAppSectionCollectionOrder2;
})(FormLinkingCollectionsAppSectionCollectionOrder || {});
var FormMarkdownFieldLinkingCollectionsFormCollectionOrder = /* @__PURE__ */ ((FormMarkdownFieldLinkingCollectionsFormCollectionOrder2) => {
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["CommercialOwnerAsc"] = "commercialOwner_ASC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["CommercialOwnerDesc"] = "commercialOwner_DESC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["TrackingConversionPointAsc"] = "trackingConversionPoint_ASC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["TrackingConversionPointDesc"] = "trackingConversionPoint_DESC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["TrackingConversionTypeAsc"] = "trackingConversionType_ASC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["TrackingConversionTypeDesc"] = "trackingConversionType_DESC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["TrackingNameAsc"] = "trackingName_ASC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["TrackingNameDesc"] = "trackingName_DESC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["TrackingStageAsc"] = "trackingStage_ASC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["TrackingStageDesc"] = "trackingStage_DESC";
  return FormMarkdownFieldLinkingCollectionsFormCollectionOrder2;
})(FormMarkdownFieldLinkingCollectionsFormCollectionOrder || {});
var FormMarkdownFieldLinkingCollectionsFormRowCollectionOrder = /* @__PURE__ */ ((FormMarkdownFieldLinkingCollectionsFormRowCollectionOrder2) => {
  FormMarkdownFieldLinkingCollectionsFormRowCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormMarkdownFieldLinkingCollectionsFormRowCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormMarkdownFieldLinkingCollectionsFormRowCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormMarkdownFieldLinkingCollectionsFormRowCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormMarkdownFieldLinkingCollectionsFormRowCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FormMarkdownFieldLinkingCollectionsFormRowCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FormMarkdownFieldLinkingCollectionsFormRowCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormMarkdownFieldLinkingCollectionsFormRowCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormMarkdownFieldLinkingCollectionsFormRowCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormMarkdownFieldLinkingCollectionsFormRowCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FormMarkdownFieldLinkingCollectionsFormRowCollectionOrder2;
})(FormMarkdownFieldLinkingCollectionsFormRowCollectionOrder || {});
var FormMarkdownFieldOrder = /* @__PURE__ */ ((FormMarkdownFieldOrder2) => {
  FormMarkdownFieldOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormMarkdownFieldOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormMarkdownFieldOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormMarkdownFieldOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormMarkdownFieldOrder2["SysIdAsc"] = "sys_id_ASC";
  FormMarkdownFieldOrder2["SysIdDesc"] = "sys_id_DESC";
  FormMarkdownFieldOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormMarkdownFieldOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormMarkdownFieldOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormMarkdownFieldOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FormMarkdownFieldOrder2;
})(FormMarkdownFieldOrder || {});
var FormMessageLinkingCollectionsFormCollectionOrder = /* @__PURE__ */ ((FormMessageLinkingCollectionsFormCollectionOrder2) => {
  FormMessageLinkingCollectionsFormCollectionOrder2["CommercialOwnerAsc"] = "commercialOwner_ASC";
  FormMessageLinkingCollectionsFormCollectionOrder2["CommercialOwnerDesc"] = "commercialOwner_DESC";
  FormMessageLinkingCollectionsFormCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormMessageLinkingCollectionsFormCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormMessageLinkingCollectionsFormCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormMessageLinkingCollectionsFormCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormMessageLinkingCollectionsFormCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FormMessageLinkingCollectionsFormCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FormMessageLinkingCollectionsFormCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormMessageLinkingCollectionsFormCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormMessageLinkingCollectionsFormCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormMessageLinkingCollectionsFormCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FormMessageLinkingCollectionsFormCollectionOrder2["TrackingConversionPointAsc"] = "trackingConversionPoint_ASC";
  FormMessageLinkingCollectionsFormCollectionOrder2["TrackingConversionPointDesc"] = "trackingConversionPoint_DESC";
  FormMessageLinkingCollectionsFormCollectionOrder2["TrackingConversionTypeAsc"] = "trackingConversionType_ASC";
  FormMessageLinkingCollectionsFormCollectionOrder2["TrackingConversionTypeDesc"] = "trackingConversionType_DESC";
  FormMessageLinkingCollectionsFormCollectionOrder2["TrackingNameAsc"] = "trackingName_ASC";
  FormMessageLinkingCollectionsFormCollectionOrder2["TrackingNameDesc"] = "trackingName_DESC";
  FormMessageLinkingCollectionsFormCollectionOrder2["TrackingStageAsc"] = "trackingStage_ASC";
  FormMessageLinkingCollectionsFormCollectionOrder2["TrackingStageDesc"] = "trackingStage_DESC";
  return FormMessageLinkingCollectionsFormCollectionOrder2;
})(FormMessageLinkingCollectionsFormCollectionOrder || {});
var FormMessageOrder = /* @__PURE__ */ ((FormMessageOrder2) => {
  FormMessageOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormMessageOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormMessageOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormMessageOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormMessageOrder2["SysIdAsc"] = "sys_id_ASC";
  FormMessageOrder2["SysIdDesc"] = "sys_id_DESC";
  FormMessageOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormMessageOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormMessageOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormMessageOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FormMessageOrder2;
})(FormMessageOrder || {});
var FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder = /* @__PURE__ */ ((FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2) => {
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["CommercialOwnerAsc"] = "commercialOwner_ASC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["CommercialOwnerDesc"] = "commercialOwner_DESC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["TrackingConversionPointAsc"] = "trackingConversionPoint_ASC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["TrackingConversionPointDesc"] = "trackingConversionPoint_DESC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["TrackingConversionTypeAsc"] = "trackingConversionType_ASC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["TrackingConversionTypeDesc"] = "trackingConversionType_DESC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["TrackingNameAsc"] = "trackingName_ASC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["TrackingNameDesc"] = "trackingName_DESC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["TrackingStageAsc"] = "trackingStage_ASC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["TrackingStageDesc"] = "trackingStage_DESC";
  return FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2;
})(FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder || {});
var FormOptionalConsentCheckboxFieldOrder = /* @__PURE__ */ ((FormOptionalConsentCheckboxFieldOrder2) => {
  FormOptionalConsentCheckboxFieldOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormOptionalConsentCheckboxFieldOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormOptionalConsentCheckboxFieldOrder2["ErrorMessageAsc"] = "errorMessage_ASC";
  FormOptionalConsentCheckboxFieldOrder2["ErrorMessageDesc"] = "errorMessage_DESC";
  FormOptionalConsentCheckboxFieldOrder2["NameAsc"] = "name_ASC";
  FormOptionalConsentCheckboxFieldOrder2["NameDesc"] = "name_DESC";
  FormOptionalConsentCheckboxFieldOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormOptionalConsentCheckboxFieldOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormOptionalConsentCheckboxFieldOrder2["SysIdAsc"] = "sys_id_ASC";
  FormOptionalConsentCheckboxFieldOrder2["SysIdDesc"] = "sys_id_DESC";
  FormOptionalConsentCheckboxFieldOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormOptionalConsentCheckboxFieldOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormOptionalConsentCheckboxFieldOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormOptionalConsentCheckboxFieldOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FormOptionalConsentCheckboxFieldOrder2;
})(FormOptionalConsentCheckboxFieldOrder || {});
var FormOrder = /* @__PURE__ */ ((FormOrder2) => {
  FormOrder2["CommercialOwnerAsc"] = "commercialOwner_ASC";
  FormOrder2["CommercialOwnerDesc"] = "commercialOwner_DESC";
  FormOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormOrder2["SysIdAsc"] = "sys_id_ASC";
  FormOrder2["SysIdDesc"] = "sys_id_DESC";
  FormOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FormOrder2["TrackingConversionPointAsc"] = "trackingConversionPoint_ASC";
  FormOrder2["TrackingConversionPointDesc"] = "trackingConversionPoint_DESC";
  FormOrder2["TrackingConversionTypeAsc"] = "trackingConversionType_ASC";
  FormOrder2["TrackingConversionTypeDesc"] = "trackingConversionType_DESC";
  FormOrder2["TrackingNameAsc"] = "trackingName_ASC";
  FormOrder2["TrackingNameDesc"] = "trackingName_DESC";
  FormOrder2["TrackingStageAsc"] = "trackingStage_ASC";
  FormOrder2["TrackingStageDesc"] = "trackingStage_DESC";
  return FormOrder2;
})(FormOrder || {});
var FormRatingFieldOrder = /* @__PURE__ */ ((FormRatingFieldOrder2) => {
  FormRatingFieldOrder2["AssistiveTextAsc"] = "assistiveText_ASC";
  FormRatingFieldOrder2["AssistiveTextDesc"] = "assistiveText_DESC";
  FormRatingFieldOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormRatingFieldOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormRatingFieldOrder2["ErrorMessageAsc"] = "errorMessage_ASC";
  FormRatingFieldOrder2["ErrorMessageDesc"] = "errorMessage_DESC";
  FormRatingFieldOrder2["LabelAsc"] = "label_ASC";
  FormRatingFieldOrder2["LabelDesc"] = "label_DESC";
  FormRatingFieldOrder2["NameAsc"] = "name_ASC";
  FormRatingFieldOrder2["NameDesc"] = "name_DESC";
  FormRatingFieldOrder2["RatingCountAsc"] = "ratingCount_ASC";
  FormRatingFieldOrder2["RatingCountDesc"] = "ratingCount_DESC";
  FormRatingFieldOrder2["RequiredAsc"] = "required_ASC";
  FormRatingFieldOrder2["RequiredDesc"] = "required_DESC";
  FormRatingFieldOrder2["ShowScaleLabelsAsc"] = "showScaleLabels_ASC";
  FormRatingFieldOrder2["ShowScaleLabelsDesc"] = "showScaleLabels_DESC";
  FormRatingFieldOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormRatingFieldOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormRatingFieldOrder2["SysIdAsc"] = "sys_id_ASC";
  FormRatingFieldOrder2["SysIdDesc"] = "sys_id_DESC";
  FormRatingFieldOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormRatingFieldOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormRatingFieldOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormRatingFieldOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FormRatingFieldOrder2["TypeAsc"] = "type_ASC";
  FormRatingFieldOrder2["TypeDesc"] = "type_DESC";
  return FormRatingFieldOrder2;
})(FormRatingFieldOrder || {});
var FormRowLinkingCollectionsFormCollectionOrder = /* @__PURE__ */ ((FormRowLinkingCollectionsFormCollectionOrder2) => {
  FormRowLinkingCollectionsFormCollectionOrder2["CommercialOwnerAsc"] = "commercialOwner_ASC";
  FormRowLinkingCollectionsFormCollectionOrder2["CommercialOwnerDesc"] = "commercialOwner_DESC";
  FormRowLinkingCollectionsFormCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormRowLinkingCollectionsFormCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormRowLinkingCollectionsFormCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormRowLinkingCollectionsFormCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormRowLinkingCollectionsFormCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FormRowLinkingCollectionsFormCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FormRowLinkingCollectionsFormCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormRowLinkingCollectionsFormCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormRowLinkingCollectionsFormCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormRowLinkingCollectionsFormCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FormRowLinkingCollectionsFormCollectionOrder2["TrackingConversionPointAsc"] = "trackingConversionPoint_ASC";
  FormRowLinkingCollectionsFormCollectionOrder2["TrackingConversionPointDesc"] = "trackingConversionPoint_DESC";
  FormRowLinkingCollectionsFormCollectionOrder2["TrackingConversionTypeAsc"] = "trackingConversionType_ASC";
  FormRowLinkingCollectionsFormCollectionOrder2["TrackingConversionTypeDesc"] = "trackingConversionType_DESC";
  FormRowLinkingCollectionsFormCollectionOrder2["TrackingNameAsc"] = "trackingName_ASC";
  FormRowLinkingCollectionsFormCollectionOrder2["TrackingNameDesc"] = "trackingName_DESC";
  FormRowLinkingCollectionsFormCollectionOrder2["TrackingStageAsc"] = "trackingStage_ASC";
  FormRowLinkingCollectionsFormCollectionOrder2["TrackingStageDesc"] = "trackingStage_DESC";
  return FormRowLinkingCollectionsFormCollectionOrder2;
})(FormRowLinkingCollectionsFormCollectionOrder || {});
var FormRowOrder = /* @__PURE__ */ ((FormRowOrder2) => {
  FormRowOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormRowOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormRowOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormRowOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormRowOrder2["SysIdAsc"] = "sys_id_ASC";
  FormRowOrder2["SysIdDesc"] = "sys_id_DESC";
  FormRowOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormRowOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormRowOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormRowOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FormRowOrder2;
})(FormRowOrder || {});
var FormSelectFieldOptionsCollectionOrder = /* @__PURE__ */ ((FormSelectFieldOptionsCollectionOrder2) => {
  FormSelectFieldOptionsCollectionOrder2["DisplayValueAsc"] = "displayValue_ASC";
  FormSelectFieldOptionsCollectionOrder2["DisplayValueDesc"] = "displayValue_DESC";
  FormSelectFieldOptionsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormSelectFieldOptionsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormSelectFieldOptionsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormSelectFieldOptionsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormSelectFieldOptionsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FormSelectFieldOptionsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FormSelectFieldOptionsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormSelectFieldOptionsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormSelectFieldOptionsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormSelectFieldOptionsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FormSelectFieldOptionsCollectionOrder2["ValueAsc"] = "value_ASC";
  FormSelectFieldOptionsCollectionOrder2["ValueDesc"] = "value_DESC";
  return FormSelectFieldOptionsCollectionOrder2;
})(FormSelectFieldOptionsCollectionOrder || {});
var FormSelectFieldOrder = /* @__PURE__ */ ((FormSelectFieldOrder2) => {
  FormSelectFieldOrder2["AssistiveTextAsc"] = "assistiveText_ASC";
  FormSelectFieldOrder2["AssistiveTextDesc"] = "assistiveText_DESC";
  FormSelectFieldOrder2["DefaultValueAsc"] = "defaultValue_ASC";
  FormSelectFieldOrder2["DefaultValueDesc"] = "defaultValue_DESC";
  FormSelectFieldOrder2["DisabledAsc"] = "disabled_ASC";
  FormSelectFieldOrder2["DisabledDesc"] = "disabled_DESC";
  FormSelectFieldOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormSelectFieldOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormSelectFieldOrder2["ErrorMessageAsc"] = "errorMessage_ASC";
  FormSelectFieldOrder2["ErrorMessageDesc"] = "errorMessage_DESC";
  FormSelectFieldOrder2["KeyAsc"] = "key_ASC";
  FormSelectFieldOrder2["KeyDesc"] = "key_DESC";
  FormSelectFieldOrder2["LabelAsc"] = "label_ASC";
  FormSelectFieldOrder2["LabelDesc"] = "label_DESC";
  FormSelectFieldOrder2["RequiredAsc"] = "required_ASC";
  FormSelectFieldOrder2["RequiredDesc"] = "required_DESC";
  FormSelectFieldOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormSelectFieldOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormSelectFieldOrder2["SysIdAsc"] = "sys_id_ASC";
  FormSelectFieldOrder2["SysIdDesc"] = "sys_id_DESC";
  FormSelectFieldOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormSelectFieldOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormSelectFieldOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormSelectFieldOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FormSelectFieldOrder2["TypeAsc"] = "type_ASC";
  FormSelectFieldOrder2["TypeDesc"] = "type_DESC";
  return FormSelectFieldOrder2;
})(FormSelectFieldOrder || {});
var FormSelectOptionLinkingCollectionsFieldCollectionOrder = /* @__PURE__ */ ((FormSelectOptionLinkingCollectionsFieldCollectionOrder2) => {
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["AssistiveTextAsc"] = "assistiveText_ASC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["AssistiveTextDesc"] = "assistiveText_DESC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["CounterAsc"] = "counter_ASC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["CounterDesc"] = "counter_DESC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["ErrorMessageAsc"] = "errorMessage_ASC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["ErrorMessageDesc"] = "errorMessage_DESC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["IdAsc"] = "id_ASC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["IdDesc"] = "id_DESC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["InputTypeAsc"] = "inputType_ASC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["InputTypeDesc"] = "inputType_DESC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["PlaceholderAsc"] = "placeholder_ASC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["PlaceholderDesc"] = "placeholder_DESC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FormSelectOptionLinkingCollectionsFieldCollectionOrder2;
})(FormSelectOptionLinkingCollectionsFieldCollectionOrder || {});
var FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder = /* @__PURE__ */ ((FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2) => {
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["AssistiveTextAsc"] = "assistiveText_ASC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["AssistiveTextDesc"] = "assistiveText_DESC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["DefaultValueAsc"] = "defaultValue_ASC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["DefaultValueDesc"] = "defaultValue_DESC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["DisabledAsc"] = "disabled_ASC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["DisabledDesc"] = "disabled_DESC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["ErrorMessageAsc"] = "errorMessage_ASC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["ErrorMessageDesc"] = "errorMessage_DESC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["KeyAsc"] = "key_ASC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["KeyDesc"] = "key_DESC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["LabelAsc"] = "label_ASC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["LabelDesc"] = "label_DESC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["RequiredAsc"] = "required_ASC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["RequiredDesc"] = "required_DESC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["TypeAsc"] = "type_ASC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["TypeDesc"] = "type_DESC";
  return FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2;
})(FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder || {});
var FormSelectOptionOrder = /* @__PURE__ */ ((FormSelectOptionOrder2) => {
  FormSelectOptionOrder2["DisplayValueAsc"] = "displayValue_ASC";
  FormSelectOptionOrder2["DisplayValueDesc"] = "displayValue_DESC";
  FormSelectOptionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormSelectOptionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormSelectOptionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormSelectOptionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormSelectOptionOrder2["SysIdAsc"] = "sys_id_ASC";
  FormSelectOptionOrder2["SysIdDesc"] = "sys_id_DESC";
  FormSelectOptionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormSelectOptionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormSelectOptionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormSelectOptionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FormSelectOptionOrder2["ValueAsc"] = "value_ASC";
  FormSelectOptionOrder2["ValueDesc"] = "value_DESC";
  return FormSelectOptionOrder2;
})(FormSelectOptionOrder || {});
var FormSubmitButtonLinkingCollectionsFormCollectionOrder = /* @__PURE__ */ ((FormSubmitButtonLinkingCollectionsFormCollectionOrder2) => {
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["CommercialOwnerAsc"] = "commercialOwner_ASC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["CommercialOwnerDesc"] = "commercialOwner_DESC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["TrackingConversionPointAsc"] = "trackingConversionPoint_ASC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["TrackingConversionPointDesc"] = "trackingConversionPoint_DESC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["TrackingConversionTypeAsc"] = "trackingConversionType_ASC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["TrackingConversionTypeDesc"] = "trackingConversionType_DESC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["TrackingNameAsc"] = "trackingName_ASC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["TrackingNameDesc"] = "trackingName_DESC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["TrackingStageAsc"] = "trackingStage_ASC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["TrackingStageDesc"] = "trackingStage_DESC";
  return FormSubmitButtonLinkingCollectionsFormCollectionOrder2;
})(FormSubmitButtonLinkingCollectionsFormCollectionOrder || {});
var FormSubmitButtonOrder = /* @__PURE__ */ ((FormSubmitButtonOrder2) => {
  FormSubmitButtonOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormSubmitButtonOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormSubmitButtonOrder2["LabelAsc"] = "label_ASC";
  FormSubmitButtonOrder2["LabelDesc"] = "label_DESC";
  FormSubmitButtonOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormSubmitButtonOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormSubmitButtonOrder2["SysIdAsc"] = "sys_id_ASC";
  FormSubmitButtonOrder2["SysIdDesc"] = "sys_id_DESC";
  FormSubmitButtonOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormSubmitButtonOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormSubmitButtonOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormSubmitButtonOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FormSubmitButtonOrder2;
})(FormSubmitButtonOrder || {});
var FreightScheduleLinkingCollectionsB2BRouteCollectionOrder = /* @__PURE__ */ ((FreightScheduleLinkingCollectionsB2BRouteCollectionOrder2) => {
  FreightScheduleLinkingCollectionsB2BRouteCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FreightScheduleLinkingCollectionsB2BRouteCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FreightScheduleLinkingCollectionsB2BRouteCollectionOrder2["NameAsc"] = "name_ASC";
  FreightScheduleLinkingCollectionsB2BRouteCollectionOrder2["NameDesc"] = "name_DESC";
  FreightScheduleLinkingCollectionsB2BRouteCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FreightScheduleLinkingCollectionsB2BRouteCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FreightScheduleLinkingCollectionsB2BRouteCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FreightScheduleLinkingCollectionsB2BRouteCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FreightScheduleLinkingCollectionsB2BRouteCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FreightScheduleLinkingCollectionsB2BRouteCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FreightScheduleLinkingCollectionsB2BRouteCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FreightScheduleLinkingCollectionsB2BRouteCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FreightScheduleLinkingCollectionsB2BRouteCollectionOrder2;
})(FreightScheduleLinkingCollectionsB2BRouteCollectionOrder || {});
var FreightScheduleOrder = /* @__PURE__ */ ((FreightScheduleOrder2) => {
  FreightScheduleOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FreightScheduleOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FreightScheduleOrder2["IdAsc"] = "id_ASC";
  FreightScheduleOrder2["IdDesc"] = "id_DESC";
  FreightScheduleOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FreightScheduleOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FreightScheduleOrder2["SysIdAsc"] = "sys_id_ASC";
  FreightScheduleOrder2["SysIdDesc"] = "sys_id_DESC";
  FreightScheduleOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FreightScheduleOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FreightScheduleOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FreightScheduleOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FreightScheduleOrder2;
})(FreightScheduleOrder || {});
var FreightTerminalLinkingCollectionsB2BRouteCollectionOrder = /* @__PURE__ */ ((FreightTerminalLinkingCollectionsB2BRouteCollectionOrder2) => {
  FreightTerminalLinkingCollectionsB2BRouteCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FreightTerminalLinkingCollectionsB2BRouteCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FreightTerminalLinkingCollectionsB2BRouteCollectionOrder2["NameAsc"] = "name_ASC";
  FreightTerminalLinkingCollectionsB2BRouteCollectionOrder2["NameDesc"] = "name_DESC";
  FreightTerminalLinkingCollectionsB2BRouteCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FreightTerminalLinkingCollectionsB2BRouteCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FreightTerminalLinkingCollectionsB2BRouteCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FreightTerminalLinkingCollectionsB2BRouteCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FreightTerminalLinkingCollectionsB2BRouteCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FreightTerminalLinkingCollectionsB2BRouteCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FreightTerminalLinkingCollectionsB2BRouteCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FreightTerminalLinkingCollectionsB2BRouteCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FreightTerminalLinkingCollectionsB2BRouteCollectionOrder2;
})(FreightTerminalLinkingCollectionsB2BRouteCollectionOrder || {});
var FreightTerminalOrder = /* @__PURE__ */ ((FreightTerminalOrder2) => {
  FreightTerminalOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FreightTerminalOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FreightTerminalOrder2["NameAsc"] = "name_ASC";
  FreightTerminalOrder2["NameDesc"] = "name_DESC";
  FreightTerminalOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FreightTerminalOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FreightTerminalOrder2["SysIdAsc"] = "sys_id_ASC";
  FreightTerminalOrder2["SysIdDesc"] = "sys_id_DESC";
  FreightTerminalOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FreightTerminalOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FreightTerminalOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FreightTerminalOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FreightTerminalOrder2["TerminalIdAsc"] = "terminalId_ASC";
  FreightTerminalOrder2["TerminalIdDesc"] = "terminalId_DESC";
  return FreightTerminalOrder2;
})(FreightTerminalOrder || {});
var GdprSettingsOrder = /* @__PURE__ */ ((GdprSettingsOrder2) => {
  GdprSettingsOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  GdprSettingsOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  GdprSettingsOrder2["FormCheckboxLabelAsc"] = "formCheckboxLabel_ASC";
  GdprSettingsOrder2["FormCheckboxLabelDesc"] = "formCheckboxLabel_DESC";
  GdprSettingsOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  GdprSettingsOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  GdprSettingsOrder2["SysIdAsc"] = "sys_id_ASC";
  GdprSettingsOrder2["SysIdDesc"] = "sys_id_DESC";
  GdprSettingsOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  GdprSettingsOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  GdprSettingsOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  GdprSettingsOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return GdprSettingsOrder2;
})(GdprSettingsOrder || {});
var GenericRouteOrder = /* @__PURE__ */ ((GenericRouteOrder2) => {
  GenericRouteOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  GenericRouteOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  GenericRouteOrder2["RouteCodeAsc"] = "routeCode_ASC";
  GenericRouteOrder2["RouteCodeDesc"] = "routeCode_DESC";
  GenericRouteOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  GenericRouteOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  GenericRouteOrder2["SysIdAsc"] = "sys_id_ASC";
  GenericRouteOrder2["SysIdDesc"] = "sys_id_DESC";
  GenericRouteOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  GenericRouteOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  GenericRouteOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  GenericRouteOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return GenericRouteOrder2;
})(GenericRouteOrder || {});
var HazardousLoadLinkingCollectionsB2BRouteCollectionOrder = /* @__PURE__ */ ((HazardousLoadLinkingCollectionsB2BRouteCollectionOrder2) => {
  HazardousLoadLinkingCollectionsB2BRouteCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  HazardousLoadLinkingCollectionsB2BRouteCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  HazardousLoadLinkingCollectionsB2BRouteCollectionOrder2["NameAsc"] = "name_ASC";
  HazardousLoadLinkingCollectionsB2BRouteCollectionOrder2["NameDesc"] = "name_DESC";
  HazardousLoadLinkingCollectionsB2BRouteCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  HazardousLoadLinkingCollectionsB2BRouteCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  HazardousLoadLinkingCollectionsB2BRouteCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  HazardousLoadLinkingCollectionsB2BRouteCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  HazardousLoadLinkingCollectionsB2BRouteCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  HazardousLoadLinkingCollectionsB2BRouteCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  HazardousLoadLinkingCollectionsB2BRouteCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  HazardousLoadLinkingCollectionsB2BRouteCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return HazardousLoadLinkingCollectionsB2BRouteCollectionOrder2;
})(HazardousLoadLinkingCollectionsB2BRouteCollectionOrder || {});
var HazardousLoadOrder = /* @__PURE__ */ ((HazardousLoadOrder2) => {
  HazardousLoadOrder2["ClassificationAsc"] = "classification_ASC";
  HazardousLoadOrder2["ClassificationDesc"] = "classification_DESC";
  HazardousLoadOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  HazardousLoadOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  HazardousLoadOrder2["IdAsc"] = "id_ASC";
  HazardousLoadOrder2["IdDesc"] = "id_DESC";
  HazardousLoadOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  HazardousLoadOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  HazardousLoadOrder2["SysIdAsc"] = "sys_id_ASC";
  HazardousLoadOrder2["SysIdDesc"] = "sys_id_DESC";
  HazardousLoadOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  HazardousLoadOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  HazardousLoadOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  HazardousLoadOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return HazardousLoadOrder2;
})(HazardousLoadOrder || {});
var HeroPromotionalSectionLinkingCollectionsB2CCompositePageCollectionOrder = /* @__PURE__ */ ((HeroPromotionalSectionLinkingCollectionsB2CCompositePageCollectionOrder2) => {
  HeroPromotionalSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  HeroPromotionalSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  HeroPromotionalSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  HeroPromotionalSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  HeroPromotionalSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  HeroPromotionalSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  HeroPromotionalSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  HeroPromotionalSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  HeroPromotionalSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  HeroPromotionalSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return HeroPromotionalSectionLinkingCollectionsB2CCompositePageCollectionOrder2;
})(HeroPromotionalSectionLinkingCollectionsB2CCompositePageCollectionOrder || {});
var HeroPromotionalSectionOrder = /* @__PURE__ */ ((HeroPromotionalSectionOrder2) => {
  HeroPromotionalSectionOrder2["BadgeAsc"] = "badge_ASC";
  HeroPromotionalSectionOrder2["BadgeDesc"] = "badge_DESC";
  HeroPromotionalSectionOrder2["CurrencyAsc"] = "currency_ASC";
  HeroPromotionalSectionOrder2["CurrencyDesc"] = "currency_DESC";
  HeroPromotionalSectionOrder2["DiscountAsc"] = "discount_ASC";
  HeroPromotionalSectionOrder2["DiscountDesc"] = "discount_DESC";
  HeroPromotionalSectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  HeroPromotionalSectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  HeroPromotionalSectionOrder2["EyebrowAsc"] = "eyebrow_ASC";
  HeroPromotionalSectionOrder2["EyebrowDesc"] = "eyebrow_DESC";
  HeroPromotionalSectionOrder2["PriceAsc"] = "price_ASC";
  HeroPromotionalSectionOrder2["PriceDesc"] = "price_DESC";
  HeroPromotionalSectionOrder2["SuffixAsc"] = "suffix_ASC";
  HeroPromotionalSectionOrder2["SuffixDesc"] = "suffix_DESC";
  HeroPromotionalSectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  HeroPromotionalSectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  HeroPromotionalSectionOrder2["SysIdAsc"] = "sys_id_ASC";
  HeroPromotionalSectionOrder2["SysIdDesc"] = "sys_id_DESC";
  HeroPromotionalSectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  HeroPromotionalSectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  HeroPromotionalSectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  HeroPromotionalSectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  HeroPromotionalSectionOrder2["TitleAsc"] = "title_ASC";
  HeroPromotionalSectionOrder2["TitleDesc"] = "title_DESC";
  return HeroPromotionalSectionOrder2;
})(HeroPromotionalSectionOrder || {});
var HeroSectionLinkingCollectionsB2BCompositePageCollectionOrder = /* @__PURE__ */ ((HeroSectionLinkingCollectionsB2BCompositePageCollectionOrder2) => {
  HeroSectionLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  HeroSectionLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  HeroSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  HeroSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  HeroSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  HeroSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  HeroSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  HeroSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  HeroSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  HeroSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return HeroSectionLinkingCollectionsB2BCompositePageCollectionOrder2;
})(HeroSectionLinkingCollectionsB2BCompositePageCollectionOrder || {});
var HeroSectionLinkingCollectionsB2CCompositePageCollectionOrder = /* @__PURE__ */ ((HeroSectionLinkingCollectionsB2CCompositePageCollectionOrder2) => {
  HeroSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  HeroSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  HeroSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  HeroSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  HeroSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  HeroSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  HeroSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  HeroSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  HeroSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  HeroSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return HeroSectionLinkingCollectionsB2CCompositePageCollectionOrder2;
})(HeroSectionLinkingCollectionsB2CCompositePageCollectionOrder || {});
var HeroSectionLinksCollectionOrder = /* @__PURE__ */ ((HeroSectionLinksCollectionOrder2) => {
  HeroSectionLinksCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  HeroSectionLinksCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  HeroSectionLinksCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  HeroSectionLinksCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  HeroSectionLinksCollectionOrder2["LinkTypeAsc"] = "linkType_ASC";
  HeroSectionLinksCollectionOrder2["LinkTypeDesc"] = "linkType_DESC";
  HeroSectionLinksCollectionOrder2["OpenInNewWindowAsc"] = "openInNewWindow_ASC";
  HeroSectionLinksCollectionOrder2["OpenInNewWindowDesc"] = "openInNewWindow_DESC";
  HeroSectionLinksCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  HeroSectionLinksCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  HeroSectionLinksCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  HeroSectionLinksCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  HeroSectionLinksCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  HeroSectionLinksCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  HeroSectionLinksCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  HeroSectionLinksCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  HeroSectionLinksCollectionOrder2["TooltipAsc"] = "tooltip_ASC";
  HeroSectionLinksCollectionOrder2["TooltipDesc"] = "tooltip_DESC";
  return HeroSectionLinksCollectionOrder2;
})(HeroSectionLinksCollectionOrder || {});
var HeroSectionOrder = /* @__PURE__ */ ((HeroSectionOrder2) => {
  HeroSectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  HeroSectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  HeroSectionOrder2["EyebrowAsc"] = "eyebrow_ASC";
  HeroSectionOrder2["EyebrowDesc"] = "eyebrow_DESC";
  HeroSectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  HeroSectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  HeroSectionOrder2["SysIdAsc"] = "sys_id_ASC";
  HeroSectionOrder2["SysIdDesc"] = "sys_id_DESC";
  HeroSectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  HeroSectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  HeroSectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  HeroSectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  HeroSectionOrder2["TitleAsc"] = "title_ASC";
  HeroSectionOrder2["TitleDesc"] = "title_DESC";
  return HeroSectionOrder2;
})(HeroSectionOrder || {});
var ImageFormat = /* @__PURE__ */ ((ImageFormat2) => {
  ImageFormat2["Avif"] = "AVIF";
  ImageFormat2["Jpg"] = "JPG";
  ImageFormat2["JpgProgressive"] = "JPG_PROGRESSIVE";
  ImageFormat2["Png"] = "PNG";
  ImageFormat2["Png8"] = "PNG8";
  ImageFormat2["Webp"] = "WEBP";
  return ImageFormat2;
})(ImageFormat || {});
var ImageResizeFocus = /* @__PURE__ */ ((ImageResizeFocus2) => {
  ImageResizeFocus2["Bottom"] = "BOTTOM";
  ImageResizeFocus2["BottomLeft"] = "BOTTOM_LEFT";
  ImageResizeFocus2["BottomRight"] = "BOTTOM_RIGHT";
  ImageResizeFocus2["Center"] = "CENTER";
  ImageResizeFocus2["Face"] = "FACE";
  ImageResizeFocus2["Faces"] = "FACES";
  ImageResizeFocus2["Left"] = "LEFT";
  ImageResizeFocus2["Right"] = "RIGHT";
  ImageResizeFocus2["Top"] = "TOP";
  ImageResizeFocus2["TopLeft"] = "TOP_LEFT";
  ImageResizeFocus2["TopRight"] = "TOP_RIGHT";
  return ImageResizeFocus2;
})(ImageResizeFocus || {});
var ImageResizeStrategy = /* @__PURE__ */ ((ImageResizeStrategy2) => {
  ImageResizeStrategy2["Crop"] = "CROP";
  ImageResizeStrategy2["Fill"] = "FILL";
  ImageResizeStrategy2["Fit"] = "FIT";
  ImageResizeStrategy2["Pad"] = "PAD";
  ImageResizeStrategy2["Scale"] = "SCALE";
  ImageResizeStrategy2["Thumb"] = "THUMB";
  return ImageResizeStrategy2;
})(ImageResizeStrategy || {});
var InstructionAndSignalisationLinkingCollectionsFerryCollectionOrder = /* @__PURE__ */ ((InstructionAndSignalisationLinkingCollectionsFerryCollectionOrder2) => {
  InstructionAndSignalisationLinkingCollectionsFerryCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  InstructionAndSignalisationLinkingCollectionsFerryCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  InstructionAndSignalisationLinkingCollectionsFerryCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  InstructionAndSignalisationLinkingCollectionsFerryCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  InstructionAndSignalisationLinkingCollectionsFerryCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  InstructionAndSignalisationLinkingCollectionsFerryCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  InstructionAndSignalisationLinkingCollectionsFerryCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  InstructionAndSignalisationLinkingCollectionsFerryCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  InstructionAndSignalisationLinkingCollectionsFerryCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  InstructionAndSignalisationLinkingCollectionsFerryCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return InstructionAndSignalisationLinkingCollectionsFerryCollectionOrder2;
})(InstructionAndSignalisationLinkingCollectionsFerryCollectionOrder || {});
var InstructionAndSignalisationOrder = /* @__PURE__ */ ((InstructionAndSignalisationOrder2) => {
  InstructionAndSignalisationOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  InstructionAndSignalisationOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  InstructionAndSignalisationOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  InstructionAndSignalisationOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  InstructionAndSignalisationOrder2["SysIdAsc"] = "sys_id_ASC";
  InstructionAndSignalisationOrder2["SysIdDesc"] = "sys_id_DESC";
  InstructionAndSignalisationOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  InstructionAndSignalisationOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  InstructionAndSignalisationOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  InstructionAndSignalisationOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  InstructionAndSignalisationOrder2["TypeAsc"] = "type_ASC";
  InstructionAndSignalisationOrder2["TypeDesc"] = "type_DESC";
  return InstructionAndSignalisationOrder2;
})(InstructionAndSignalisationOrder || {});
var KeyValuePairCollectionItemsCollectionOrder = /* @__PURE__ */ ((KeyValuePairCollectionItemsCollectionOrder2) => {
  KeyValuePairCollectionItemsCollectionOrder2["KeyAsc"] = "key_ASC";
  KeyValuePairCollectionItemsCollectionOrder2["KeyDesc"] = "key_DESC";
  KeyValuePairCollectionItemsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  KeyValuePairCollectionItemsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  KeyValuePairCollectionItemsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  KeyValuePairCollectionItemsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  KeyValuePairCollectionItemsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  KeyValuePairCollectionItemsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  KeyValuePairCollectionItemsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  KeyValuePairCollectionItemsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  KeyValuePairCollectionItemsCollectionOrder2["ValueAsc"] = "value_ASC";
  KeyValuePairCollectionItemsCollectionOrder2["ValueDesc"] = "value_DESC";
  return KeyValuePairCollectionItemsCollectionOrder2;
})(KeyValuePairCollectionItemsCollectionOrder || {});
var KeyValuePairCollectionOrder = /* @__PURE__ */ ((KeyValuePairCollectionOrder2) => {
  KeyValuePairCollectionOrder2["CollectionNameAsc"] = "collectionName_ASC";
  KeyValuePairCollectionOrder2["CollectionNameDesc"] = "collectionName_DESC";
  KeyValuePairCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  KeyValuePairCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  KeyValuePairCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  KeyValuePairCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  KeyValuePairCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  KeyValuePairCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  KeyValuePairCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  KeyValuePairCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return KeyValuePairCollectionOrder2;
})(KeyValuePairCollectionOrder || {});
var KeyValuePairLinkingCollectionsKeyValuePairCollectionCollectionOrder = /* @__PURE__ */ ((KeyValuePairLinkingCollectionsKeyValuePairCollectionCollectionOrder2) => {
  KeyValuePairLinkingCollectionsKeyValuePairCollectionCollectionOrder2["CollectionNameAsc"] = "collectionName_ASC";
  KeyValuePairLinkingCollectionsKeyValuePairCollectionCollectionOrder2["CollectionNameDesc"] = "collectionName_DESC";
  KeyValuePairLinkingCollectionsKeyValuePairCollectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  KeyValuePairLinkingCollectionsKeyValuePairCollectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  KeyValuePairLinkingCollectionsKeyValuePairCollectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  KeyValuePairLinkingCollectionsKeyValuePairCollectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  KeyValuePairLinkingCollectionsKeyValuePairCollectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  KeyValuePairLinkingCollectionsKeyValuePairCollectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  KeyValuePairLinkingCollectionsKeyValuePairCollectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  KeyValuePairLinkingCollectionsKeyValuePairCollectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return KeyValuePairLinkingCollectionsKeyValuePairCollectionCollectionOrder2;
})(KeyValuePairLinkingCollectionsKeyValuePairCollectionCollectionOrder || {});
var LinkLinkingCollectionsBannerCollectionOrder = /* @__PURE__ */ ((LinkLinkingCollectionsBannerCollectionOrder2) => {
  LinkLinkingCollectionsBannerCollectionOrder2["EnabledAsc"] = "enabled_ASC";
  LinkLinkingCollectionsBannerCollectionOrder2["EnabledDesc"] = "enabled_DESC";
  LinkLinkingCollectionsBannerCollectionOrder2["EntityNameAsc"] = "entityName_ASC";
  LinkLinkingCollectionsBannerCollectionOrder2["EntityNameDesc"] = "entityName_DESC";
  LinkLinkingCollectionsBannerCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinkLinkingCollectionsBannerCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinkLinkingCollectionsBannerCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinkLinkingCollectionsBannerCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinkLinkingCollectionsBannerCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinkLinkingCollectionsBannerCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinkLinkingCollectionsBannerCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinkLinkingCollectionsBannerCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  LinkLinkingCollectionsBannerCollectionOrder2["TextAsc"] = "text_ASC";
  LinkLinkingCollectionsBannerCollectionOrder2["TextDesc"] = "text_DESC";
  return LinkLinkingCollectionsBannerCollectionOrder2;
})(LinkLinkingCollectionsBannerCollectionOrder || {});
var LinkLinkingCollectionsContentBlockCollectionOrder = /* @__PURE__ */ ((LinkLinkingCollectionsContentBlockCollectionOrder2) => {
  LinkLinkingCollectionsContentBlockCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["ImageDisplayOptionsAsc"] = "imageDisplayOptions_ASC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["ImageDisplayOptionsDesc"] = "imageDisplayOptions_DESC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["MediaTypeAsc"] = "mediaType_ASC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["MediaTypeDesc"] = "mediaType_DESC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["PrimaryTextAsc"] = "primaryText_ASC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["PrimaryTextDesc"] = "primaryText_DESC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["TertiaryTextAsc"] = "tertiaryText_ASC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["TertiaryTextDesc"] = "tertiaryText_DESC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["VideoLinkAsc"] = "videoLink_ASC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["VideoLinkDesc"] = "videoLink_DESC";
  return LinkLinkingCollectionsContentBlockCollectionOrder2;
})(LinkLinkingCollectionsContentBlockCollectionOrder || {});
var LinkLinkingCollectionsFooterCollectionOrder = /* @__PURE__ */ ((LinkLinkingCollectionsFooterCollectionOrder2) => {
  LinkLinkingCollectionsFooterCollectionOrder2["BusinessUnitAsc"] = "businessUnit_ASC";
  LinkLinkingCollectionsFooterCollectionOrder2["BusinessUnitDesc"] = "businessUnit_DESC";
  LinkLinkingCollectionsFooterCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LinkLinkingCollectionsFooterCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LinkLinkingCollectionsFooterCollectionOrder2["LocaleSelectorLabelAsc"] = "localeSelectorLabel_ASC";
  LinkLinkingCollectionsFooterCollectionOrder2["LocaleSelectorLabelDesc"] = "localeSelectorLabel_DESC";
  LinkLinkingCollectionsFooterCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinkLinkingCollectionsFooterCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinkLinkingCollectionsFooterCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinkLinkingCollectionsFooterCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinkLinkingCollectionsFooterCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinkLinkingCollectionsFooterCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinkLinkingCollectionsFooterCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinkLinkingCollectionsFooterCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LinkLinkingCollectionsFooterCollectionOrder2;
})(LinkLinkingCollectionsFooterCollectionOrder || {});
var LinkLinkingCollectionsGdprSettingsCollectionOrder = /* @__PURE__ */ ((LinkLinkingCollectionsGdprSettingsCollectionOrder2) => {
  LinkLinkingCollectionsGdprSettingsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LinkLinkingCollectionsGdprSettingsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LinkLinkingCollectionsGdprSettingsCollectionOrder2["FormCheckboxLabelAsc"] = "formCheckboxLabel_ASC";
  LinkLinkingCollectionsGdprSettingsCollectionOrder2["FormCheckboxLabelDesc"] = "formCheckboxLabel_DESC";
  LinkLinkingCollectionsGdprSettingsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinkLinkingCollectionsGdprSettingsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinkLinkingCollectionsGdprSettingsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinkLinkingCollectionsGdprSettingsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinkLinkingCollectionsGdprSettingsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinkLinkingCollectionsGdprSettingsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinkLinkingCollectionsGdprSettingsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinkLinkingCollectionsGdprSettingsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LinkLinkingCollectionsGdprSettingsCollectionOrder2;
})(LinkLinkingCollectionsGdprSettingsCollectionOrder || {});
var LinkLinkingCollectionsHeroSectionCollectionOrder = /* @__PURE__ */ ((LinkLinkingCollectionsHeroSectionCollectionOrder2) => {
  LinkLinkingCollectionsHeroSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LinkLinkingCollectionsHeroSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LinkLinkingCollectionsHeroSectionCollectionOrder2["EyebrowAsc"] = "eyebrow_ASC";
  LinkLinkingCollectionsHeroSectionCollectionOrder2["EyebrowDesc"] = "eyebrow_DESC";
  LinkLinkingCollectionsHeroSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinkLinkingCollectionsHeroSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinkLinkingCollectionsHeroSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinkLinkingCollectionsHeroSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinkLinkingCollectionsHeroSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinkLinkingCollectionsHeroSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinkLinkingCollectionsHeroSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinkLinkingCollectionsHeroSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  LinkLinkingCollectionsHeroSectionCollectionOrder2["TitleAsc"] = "title_ASC";
  LinkLinkingCollectionsHeroSectionCollectionOrder2["TitleDesc"] = "title_DESC";
  return LinkLinkingCollectionsHeroSectionCollectionOrder2;
})(LinkLinkingCollectionsHeroSectionCollectionOrder || {});
var LinkLinkingCollectionsLinksListCollectionOrder = /* @__PURE__ */ ((LinkLinkingCollectionsLinksListCollectionOrder2) => {
  LinkLinkingCollectionsLinksListCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LinkLinkingCollectionsLinksListCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LinkLinkingCollectionsLinksListCollectionOrder2["LinksListTitleAsc"] = "linksListTitle_ASC";
  LinkLinkingCollectionsLinksListCollectionOrder2["LinksListTitleDesc"] = "linksListTitle_DESC";
  LinkLinkingCollectionsLinksListCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinkLinkingCollectionsLinksListCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinkLinkingCollectionsLinksListCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinkLinkingCollectionsLinksListCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinkLinkingCollectionsLinksListCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinkLinkingCollectionsLinksListCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinkLinkingCollectionsLinksListCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinkLinkingCollectionsLinksListCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LinkLinkingCollectionsLinksListCollectionOrder2;
})(LinkLinkingCollectionsLinksListCollectionOrder || {});
var LinkLinkingCollectionsMediaCardCollectionOrder = /* @__PURE__ */ ((LinkLinkingCollectionsMediaCardCollectionOrder2) => {
  LinkLinkingCollectionsMediaCardCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LinkLinkingCollectionsMediaCardCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LinkLinkingCollectionsMediaCardCollectionOrder2["HeaderAsc"] = "header_ASC";
  LinkLinkingCollectionsMediaCardCollectionOrder2["HeaderDesc"] = "header_DESC";
  LinkLinkingCollectionsMediaCardCollectionOrder2["PriceDescriptionAsc"] = "priceDescription_ASC";
  LinkLinkingCollectionsMediaCardCollectionOrder2["PriceDescriptionDesc"] = "priceDescription_DESC";
  LinkLinkingCollectionsMediaCardCollectionOrder2["PriceEyebrowAsc"] = "priceEyebrow_ASC";
  LinkLinkingCollectionsMediaCardCollectionOrder2["PriceEyebrowDesc"] = "priceEyebrow_DESC";
  LinkLinkingCollectionsMediaCardCollectionOrder2["PriceAsc"] = "price_ASC";
  LinkLinkingCollectionsMediaCardCollectionOrder2["PriceDesc"] = "price_DESC";
  LinkLinkingCollectionsMediaCardCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinkLinkingCollectionsMediaCardCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinkLinkingCollectionsMediaCardCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinkLinkingCollectionsMediaCardCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinkLinkingCollectionsMediaCardCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinkLinkingCollectionsMediaCardCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinkLinkingCollectionsMediaCardCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinkLinkingCollectionsMediaCardCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LinkLinkingCollectionsMediaCardCollectionOrder2;
})(LinkLinkingCollectionsMediaCardCollectionOrder || {});
var LinkLinkingCollectionsNavigationCollectionOrder = /* @__PURE__ */ ((LinkLinkingCollectionsNavigationCollectionOrder2) => {
  LinkLinkingCollectionsNavigationCollectionOrder2["BusinessAreaAsc"] = "businessArea_ASC";
  LinkLinkingCollectionsNavigationCollectionOrder2["BusinessAreaDesc"] = "businessArea_DESC";
  LinkLinkingCollectionsNavigationCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  LinkLinkingCollectionsNavigationCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  LinkLinkingCollectionsNavigationCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LinkLinkingCollectionsNavigationCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LinkLinkingCollectionsNavigationCollectionOrder2["OrderAsc"] = "order_ASC";
  LinkLinkingCollectionsNavigationCollectionOrder2["OrderDesc"] = "order_DESC";
  LinkLinkingCollectionsNavigationCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinkLinkingCollectionsNavigationCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinkLinkingCollectionsNavigationCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinkLinkingCollectionsNavigationCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinkLinkingCollectionsNavigationCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinkLinkingCollectionsNavigationCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinkLinkingCollectionsNavigationCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinkLinkingCollectionsNavigationCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LinkLinkingCollectionsNavigationCollectionOrder2;
})(LinkLinkingCollectionsNavigationCollectionOrder || {});
var LinkLinkingCollectionsNavigationItemCollectionOrder = /* @__PURE__ */ ((LinkLinkingCollectionsNavigationItemCollectionOrder2) => {
  LinkLinkingCollectionsNavigationItemCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  LinkLinkingCollectionsNavigationItemCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  LinkLinkingCollectionsNavigationItemCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LinkLinkingCollectionsNavigationItemCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LinkLinkingCollectionsNavigationItemCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinkLinkingCollectionsNavigationItemCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinkLinkingCollectionsNavigationItemCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinkLinkingCollectionsNavigationItemCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinkLinkingCollectionsNavigationItemCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinkLinkingCollectionsNavigationItemCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinkLinkingCollectionsNavigationItemCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinkLinkingCollectionsNavigationItemCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  LinkLinkingCollectionsNavigationItemCollectionOrder2["TooltipAsc"] = "tooltip_ASC";
  LinkLinkingCollectionsNavigationItemCollectionOrder2["TooltipDesc"] = "tooltip_DESC";
  return LinkLinkingCollectionsNavigationItemCollectionOrder2;
})(LinkLinkingCollectionsNavigationItemCollectionOrder || {});
var LinkLinkingCollectionsPageSectionCollectionOrder = /* @__PURE__ */ ((LinkLinkingCollectionsPageSectionCollectionOrder2) => {
  LinkLinkingCollectionsPageSectionCollectionOrder2["ColumnsAsc"] = "columns_ASC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["ColumnsDesc"] = "columns_DESC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["DisplayOptionAsc"] = "displayOption_ASC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["DisplayOptionDesc"] = "displayOption_DESC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["HideBackgroundImageOnMobileAsc"] = "hideBackgroundImageOnMobile_ASC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["HideBackgroundImageOnMobileDesc"] = "hideBackgroundImageOnMobile_DESC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["SectionDescriptionAsc"] = "sectionDescription_ASC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["SectionDescriptionDesc"] = "sectionDescription_DESC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LinkLinkingCollectionsPageSectionCollectionOrder2;
})(LinkLinkingCollectionsPageSectionCollectionOrder || {});
var LinkLinkingCollectionsTextAndMediaSectionCollectionOrder = /* @__PURE__ */ ((LinkLinkingCollectionsTextAndMediaSectionCollectionOrder2) => {
  LinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["HeaderAsc"] = "header_ASC";
  LinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["HeaderDesc"] = "header_DESC";
  LinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["SectionBackgroundColorAsc"] = "sectionBackgroundColor_ASC";
  LinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["SectionBackgroundColorDesc"] = "sectionBackgroundColor_DESC";
  LinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  LinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["VariantAsc"] = "variant_ASC";
  LinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["VariantDesc"] = "variant_DESC";
  LinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["VideoLinkAsc"] = "videoLink_ASC";
  LinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["VideoLinkDesc"] = "videoLink_DESC";
  return LinkLinkingCollectionsTextAndMediaSectionCollectionOrder2;
})(LinkLinkingCollectionsTextAndMediaSectionCollectionOrder || {});
var LinkLinkingCollectionsTextCardCollectionOrder = /* @__PURE__ */ ((LinkLinkingCollectionsTextCardCollectionOrder2) => {
  LinkLinkingCollectionsTextCardCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LinkLinkingCollectionsTextCardCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LinkLinkingCollectionsTextCardCollectionOrder2["HeaderAsc"] = "header_ASC";
  LinkLinkingCollectionsTextCardCollectionOrder2["HeaderDesc"] = "header_DESC";
  LinkLinkingCollectionsTextCardCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinkLinkingCollectionsTextCardCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinkLinkingCollectionsTextCardCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinkLinkingCollectionsTextCardCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinkLinkingCollectionsTextCardCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinkLinkingCollectionsTextCardCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinkLinkingCollectionsTextCardCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinkLinkingCollectionsTextCardCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LinkLinkingCollectionsTextCardCollectionOrder2;
})(LinkLinkingCollectionsTextCardCollectionOrder || {});
var LinkOrder = /* @__PURE__ */ ((LinkOrder2) => {
  LinkOrder2["DisplayTextAsc"] = "displayText_ASC";
  LinkOrder2["DisplayTextDesc"] = "displayText_DESC";
  LinkOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LinkOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LinkOrder2["LinkTypeAsc"] = "linkType_ASC";
  LinkOrder2["LinkTypeDesc"] = "linkType_DESC";
  LinkOrder2["OpenInNewWindowAsc"] = "openInNewWindow_ASC";
  LinkOrder2["OpenInNewWindowDesc"] = "openInNewWindow_DESC";
  LinkOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinkOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinkOrder2["SysIdAsc"] = "sys_id_ASC";
  LinkOrder2["SysIdDesc"] = "sys_id_DESC";
  LinkOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinkOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinkOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinkOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  LinkOrder2["TooltipAsc"] = "tooltip_ASC";
  LinkOrder2["TooltipDesc"] = "tooltip_DESC";
  return LinkOrder2;
})(LinkOrder || {});
var LinksListLinkingCollectionsPageSectionCollectionOrder = /* @__PURE__ */ ((LinksListLinkingCollectionsPageSectionCollectionOrder2) => {
  LinksListLinkingCollectionsPageSectionCollectionOrder2["ColumnsAsc"] = "columns_ASC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["ColumnsDesc"] = "columns_DESC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["DisplayOptionAsc"] = "displayOption_ASC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["DisplayOptionDesc"] = "displayOption_DESC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["HideBackgroundImageOnMobileAsc"] = "hideBackgroundImageOnMobile_ASC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["HideBackgroundImageOnMobileDesc"] = "hideBackgroundImageOnMobile_DESC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["SectionDescriptionAsc"] = "sectionDescription_ASC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["SectionDescriptionDesc"] = "sectionDescription_DESC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LinksListLinkingCollectionsPageSectionCollectionOrder2;
})(LinksListLinkingCollectionsPageSectionCollectionOrder || {});
var LinksListLinksListItemsCollectionOrder = /* @__PURE__ */ ((LinksListLinksListItemsCollectionOrder2) => {
  LinksListLinksListItemsCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  LinksListLinksListItemsCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  LinksListLinksListItemsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LinksListLinksListItemsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LinksListLinksListItemsCollectionOrder2["LinkTypeAsc"] = "linkType_ASC";
  LinksListLinksListItemsCollectionOrder2["LinkTypeDesc"] = "linkType_DESC";
  LinksListLinksListItemsCollectionOrder2["OpenInNewWindowAsc"] = "openInNewWindow_ASC";
  LinksListLinksListItemsCollectionOrder2["OpenInNewWindowDesc"] = "openInNewWindow_DESC";
  LinksListLinksListItemsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinksListLinksListItemsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinksListLinksListItemsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinksListLinksListItemsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinksListLinksListItemsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinksListLinksListItemsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinksListLinksListItemsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinksListLinksListItemsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  LinksListLinksListItemsCollectionOrder2["TooltipAsc"] = "tooltip_ASC";
  LinksListLinksListItemsCollectionOrder2["TooltipDesc"] = "tooltip_DESC";
  return LinksListLinksListItemsCollectionOrder2;
})(LinksListLinksListItemsCollectionOrder || {});
var LinksListOrder = /* @__PURE__ */ ((LinksListOrder2) => {
  LinksListOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LinksListOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LinksListOrder2["LinksListTitleAsc"] = "linksListTitle_ASC";
  LinksListOrder2["LinksListTitleDesc"] = "linksListTitle_DESC";
  LinksListOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinksListOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinksListOrder2["SysIdAsc"] = "sys_id_ASC";
  LinksListOrder2["SysIdDesc"] = "sys_id_DESC";
  LinksListOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinksListOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinksListOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinksListOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LinksListOrder2;
})(LinksListOrder || {});
var LongStringLinkingCollectionsArrayOfItemsCollectionOrder = /* @__PURE__ */ ((LongStringLinkingCollectionsArrayOfItemsCollectionOrder2) => {
  LongStringLinkingCollectionsArrayOfItemsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LongStringLinkingCollectionsArrayOfItemsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LongStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LongStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LongStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LongStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LongStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LongStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LongStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LongStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LongStringLinkingCollectionsArrayOfItemsCollectionOrder2;
})(LongStringLinkingCollectionsArrayOfItemsCollectionOrder || {});
var LongStringOrder = /* @__PURE__ */ ((LongStringOrder2) => {
  LongStringOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LongStringOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LongStringOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LongStringOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LongStringOrder2["SysIdAsc"] = "sys_id_ASC";
  LongStringOrder2["SysIdDesc"] = "sys_id_DESC";
  LongStringOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LongStringOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LongStringOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LongStringOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LongStringOrder2;
})(LongStringOrder || {});
var MealsRestaurantLinkingCollectionsFerryCollectionOrder = /* @__PURE__ */ ((MealsRestaurantLinkingCollectionsFerryCollectionOrder2) => {
  MealsRestaurantLinkingCollectionsFerryCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MealsRestaurantLinkingCollectionsFerryCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MealsRestaurantLinkingCollectionsFerryCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MealsRestaurantLinkingCollectionsFerryCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MealsRestaurantLinkingCollectionsFerryCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  MealsRestaurantLinkingCollectionsFerryCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  MealsRestaurantLinkingCollectionsFerryCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MealsRestaurantLinkingCollectionsFerryCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MealsRestaurantLinkingCollectionsFerryCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MealsRestaurantLinkingCollectionsFerryCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MealsRestaurantLinkingCollectionsFerryCollectionOrder2;
})(MealsRestaurantLinkingCollectionsFerryCollectionOrder || {});
var MealsRestaurantOrder = /* @__PURE__ */ ((MealsRestaurantOrder2) => {
  MealsRestaurantOrder2["BannerLine1Asc"] = "bannerLine1_ASC";
  MealsRestaurantOrder2["BannerLine1Desc"] = "bannerLine1_DESC";
  MealsRestaurantOrder2["BannerLine2LargeAsc"] = "bannerLine2Large_ASC";
  MealsRestaurantOrder2["BannerLine2LargeDesc"] = "bannerLine2Large_DESC";
  MealsRestaurantOrder2["BannerLine2SmallAsc"] = "bannerLine2Small_ASC";
  MealsRestaurantOrder2["BannerLine2SmallDesc"] = "bannerLine2Small_DESC";
  MealsRestaurantOrder2["BannerLine3Asc"] = "bannerLine3_ASC";
  MealsRestaurantOrder2["BannerLine3Desc"] = "bannerLine3_DESC";
  MealsRestaurantOrder2["CloseButtonLightThemeAsc"] = "closeButtonLightTheme_ASC";
  MealsRestaurantOrder2["CloseButtonLightThemeDesc"] = "closeButtonLightTheme_DESC";
  MealsRestaurantOrder2["DefaultSeatingTimeAsc"] = "defaultSeatingTime_ASC";
  MealsRestaurantOrder2["DefaultSeatingTimeDesc"] = "defaultSeatingTime_DESC";
  MealsRestaurantOrder2["HeadlineAsc"] = "headline_ASC";
  MealsRestaurantOrder2["HeadlineDesc"] = "headline_DESC";
  MealsRestaurantOrder2["HighlightedAsc"] = "highlighted_ASC";
  MealsRestaurantOrder2["HighlightedDesc"] = "highlighted_DESC";
  MealsRestaurantOrder2["MenuBeveragesHeadlineAsc"] = "menuBeveragesHeadline_ASC";
  MealsRestaurantOrder2["MenuBeveragesHeadlineDesc"] = "menuBeveragesHeadline_DESC";
  MealsRestaurantOrder2["MenuCardForChildrenTitleAsc"] = "menuCardForChildrenTitle_ASC";
  MealsRestaurantOrder2["MenuCardForChildrenTitleDesc"] = "menuCardForChildrenTitle_DESC";
  MealsRestaurantOrder2["MenuCardTitleAsc"] = "menuCardTitle_ASC";
  MealsRestaurantOrder2["MenuCardTitleDesc"] = "menuCardTitle_DESC";
  MealsRestaurantOrder2["MenuDessertsHeadlineAsc"] = "menuDessertsHeadline_ASC";
  MealsRestaurantOrder2["MenuDessertsHeadlineDesc"] = "menuDessertsHeadline_DESC";
  MealsRestaurantOrder2["MenuForChildrenHeadlineAsc"] = "menuForChildrenHeadline_ASC";
  MealsRestaurantOrder2["MenuForChildrenHeadlineDesc"] = "menuForChildrenHeadline_DESC";
  MealsRestaurantOrder2["MenuMainCourseExtrasHeadlineAsc"] = "menuMainCourseExtrasHeadline_ASC";
  MealsRestaurantOrder2["MenuMainCourseExtrasHeadlineDesc"] = "menuMainCourseExtrasHeadline_DESC";
  MealsRestaurantOrder2["MenuMainCoursesExpandedAsc"] = "menuMainCoursesExpanded_ASC";
  MealsRestaurantOrder2["MenuMainCoursesExpandedDesc"] = "menuMainCoursesExpanded_DESC";
  MealsRestaurantOrder2["MenuMainCoursesHeadlineAsc"] = "menuMainCoursesHeadline_ASC";
  MealsRestaurantOrder2["MenuMainCoursesHeadlineDesc"] = "menuMainCoursesHeadline_DESC";
  MealsRestaurantOrder2["MenuSectionsNoCollapseAsc"] = "menuSectionsNoCollapse_ASC";
  MealsRestaurantOrder2["MenuSectionsNoCollapseDesc"] = "menuSectionsNoCollapse_DESC";
  MealsRestaurantOrder2["MenuStartersExpandedAsc"] = "menuStartersExpanded_ASC";
  MealsRestaurantOrder2["MenuStartersExpandedDesc"] = "menuStartersExpanded_DESC";
  MealsRestaurantOrder2["MenuStartersHeadlineAsc"] = "menuStartersHeadline_ASC";
  MealsRestaurantOrder2["MenuStartersHeadlineDesc"] = "menuStartersHeadline_DESC";
  MealsRestaurantOrder2["RestaurantCodeAsc"] = "restaurantCode_ASC";
  MealsRestaurantOrder2["RestaurantCodeDesc"] = "restaurantCode_DESC";
  MealsRestaurantOrder2["RestaurantNameAsc"] = "restaurantName_ASC";
  MealsRestaurantOrder2["RestaurantNameDesc"] = "restaurantName_DESC";
  MealsRestaurantOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MealsRestaurantOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MealsRestaurantOrder2["SysIdAsc"] = "sys_id_ASC";
  MealsRestaurantOrder2["SysIdDesc"] = "sys_id_DESC";
  MealsRestaurantOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MealsRestaurantOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MealsRestaurantOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MealsRestaurantOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MealsRestaurantOrder2;
})(MealsRestaurantOrder || {});
var MediaCardLinkingCollectionsCardsSectionCollectionOrder = /* @__PURE__ */ ((MediaCardLinkingCollectionsCardsSectionCollectionOrder2) => {
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["DisplayTypeAsc"] = "displayType_ASC";
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["DisplayTypeDesc"] = "displayType_DESC";
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["OverlineAsc"] = "overline_ASC";
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["OverlineDesc"] = "overline_DESC";
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["SectionBackgroundAndCardColorAsc"] = "sectionBackgroundAndCardColor_ASC";
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["SectionBackgroundAndCardColorDesc"] = "sectionBackgroundAndCardColor_DESC";
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MediaCardLinkingCollectionsCardsSectionCollectionOrder2;
})(MediaCardLinkingCollectionsCardsSectionCollectionOrder || {});
var MediaCardLinksCollectionOrder = /* @__PURE__ */ ((MediaCardLinksCollectionOrder2) => {
  MediaCardLinksCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  MediaCardLinksCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  MediaCardLinksCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MediaCardLinksCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MediaCardLinksCollectionOrder2["LinkTypeAsc"] = "linkType_ASC";
  MediaCardLinksCollectionOrder2["LinkTypeDesc"] = "linkType_DESC";
  MediaCardLinksCollectionOrder2["OpenInNewWindowAsc"] = "openInNewWindow_ASC";
  MediaCardLinksCollectionOrder2["OpenInNewWindowDesc"] = "openInNewWindow_DESC";
  MediaCardLinksCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MediaCardLinksCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MediaCardLinksCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  MediaCardLinksCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  MediaCardLinksCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MediaCardLinksCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MediaCardLinksCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MediaCardLinksCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  MediaCardLinksCollectionOrder2["TooltipAsc"] = "tooltip_ASC";
  MediaCardLinksCollectionOrder2["TooltipDesc"] = "tooltip_DESC";
  return MediaCardLinksCollectionOrder2;
})(MediaCardLinksCollectionOrder || {});
var MediaCardOrder = /* @__PURE__ */ ((MediaCardOrder2) => {
  MediaCardOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MediaCardOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MediaCardOrder2["HeaderAsc"] = "header_ASC";
  MediaCardOrder2["HeaderDesc"] = "header_DESC";
  MediaCardOrder2["PriceDescriptionAsc"] = "priceDescription_ASC";
  MediaCardOrder2["PriceDescriptionDesc"] = "priceDescription_DESC";
  MediaCardOrder2["PriceEyebrowAsc"] = "priceEyebrow_ASC";
  MediaCardOrder2["PriceEyebrowDesc"] = "priceEyebrow_DESC";
  MediaCardOrder2["PriceAsc"] = "price_ASC";
  MediaCardOrder2["PriceDesc"] = "price_DESC";
  MediaCardOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MediaCardOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MediaCardOrder2["SysIdAsc"] = "sys_id_ASC";
  MediaCardOrder2["SysIdDesc"] = "sys_id_DESC";
  MediaCardOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MediaCardOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MediaCardOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MediaCardOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MediaCardOrder2;
})(MediaCardOrder || {});
var MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder = /* @__PURE__ */ ((MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2) => {
  MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["CategoryAsc"] = "category_ASC";
  MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["CategoryDesc"] = "category_DESC";
  MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2;
})(MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder || {});
var MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder = /* @__PURE__ */ ((MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder2) => {
  MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder2["CategoryAsc"] = "category_ASC";
  MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder2["CategoryDesc"] = "category_DESC";
  MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder2["PublishedDateAsc"] = "publishedDate_ASC";
  MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder2["PublishedDateDesc"] = "publishedDate_DESC";
  MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder2;
})(MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder || {});
var MetaDataAndSeoLinkingCollectionsB2BCompositePageCollectionOrder = /* @__PURE__ */ ((MetaDataAndSeoLinkingCollectionsB2BCompositePageCollectionOrder2) => {
  MetaDataAndSeoLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MetaDataAndSeoLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MetaDataAndSeoLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MetaDataAndSeoLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MetaDataAndSeoLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  MetaDataAndSeoLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  MetaDataAndSeoLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MetaDataAndSeoLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MetaDataAndSeoLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MetaDataAndSeoLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MetaDataAndSeoLinkingCollectionsB2BCompositePageCollectionOrder2;
})(MetaDataAndSeoLinkingCollectionsB2BCompositePageCollectionOrder || {});
var MetaDataAndSeoLinkingCollectionsB2CCompositePageCollectionOrder = /* @__PURE__ */ ((MetaDataAndSeoLinkingCollectionsB2CCompositePageCollectionOrder2) => {
  MetaDataAndSeoLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MetaDataAndSeoLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MetaDataAndSeoLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MetaDataAndSeoLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MetaDataAndSeoLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  MetaDataAndSeoLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  MetaDataAndSeoLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MetaDataAndSeoLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MetaDataAndSeoLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MetaDataAndSeoLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MetaDataAndSeoLinkingCollectionsB2CCompositePageCollectionOrder2;
})(MetaDataAndSeoLinkingCollectionsB2CCompositePageCollectionOrder || {});
var MetaDataAndSeoLinkingCollectionsModularPageCollectionOrder = /* @__PURE__ */ ((MetaDataAndSeoLinkingCollectionsModularPageCollectionOrder2) => {
  MetaDataAndSeoLinkingCollectionsModularPageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MetaDataAndSeoLinkingCollectionsModularPageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MetaDataAndSeoLinkingCollectionsModularPageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MetaDataAndSeoLinkingCollectionsModularPageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MetaDataAndSeoLinkingCollectionsModularPageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  MetaDataAndSeoLinkingCollectionsModularPageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  MetaDataAndSeoLinkingCollectionsModularPageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MetaDataAndSeoLinkingCollectionsModularPageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MetaDataAndSeoLinkingCollectionsModularPageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MetaDataAndSeoLinkingCollectionsModularPageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MetaDataAndSeoLinkingCollectionsModularPageCollectionOrder2;
})(MetaDataAndSeoLinkingCollectionsModularPageCollectionOrder || {});
var MetaDataAndSeoOrder = /* @__PURE__ */ ((MetaDataAndSeoOrder2) => {
  MetaDataAndSeoOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MetaDataAndSeoOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MetaDataAndSeoOrder2["PageMetaDescriptionAsc"] = "pageMetaDescription_ASC";
  MetaDataAndSeoOrder2["PageMetaDescriptionDesc"] = "pageMetaDescription_DESC";
  MetaDataAndSeoOrder2["PageTitleAsc"] = "pageTitle_ASC";
  MetaDataAndSeoOrder2["PageTitleDesc"] = "pageTitle_DESC";
  MetaDataAndSeoOrder2["RobotsMetaAsc"] = "robotsMeta_ASC";
  MetaDataAndSeoOrder2["RobotsMetaDesc"] = "robotsMeta_DESC";
  MetaDataAndSeoOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MetaDataAndSeoOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MetaDataAndSeoOrder2["SysIdAsc"] = "sys_id_ASC";
  MetaDataAndSeoOrder2["SysIdDesc"] = "sys_id_DESC";
  MetaDataAndSeoOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MetaDataAndSeoOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MetaDataAndSeoOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MetaDataAndSeoOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MetaDataAndSeoOrder2;
})(MetaDataAndSeoOrder || {});
var MigrationLogOrder = /* @__PURE__ */ ((MigrationLogOrder2) => {
  MigrationLogOrder2["LatestMigrationAsc"] = "latestMigration_ASC";
  MigrationLogOrder2["LatestMigrationDesc"] = "latestMigration_DESC";
  MigrationLogOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MigrationLogOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MigrationLogOrder2["SysIdAsc"] = "sys_id_ASC";
  MigrationLogOrder2["SysIdDesc"] = "sys_id_DESC";
  MigrationLogOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MigrationLogOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MigrationLogOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MigrationLogOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MigrationLogOrder2;
})(MigrationLogOrder || {});
var MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder = /* @__PURE__ */ ((MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2) => {
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["BusinessTypeAsc"] = "businessType_ASC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["BusinessTypeDesc"] = "businessType_DESC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["IdAsc"] = "id_ASC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["IdDesc"] = "id_DESC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["TitleAsc"] = "title_ASC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["TitleDesc"] = "title_DESC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["TypeAsc"] = "type_ASC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["TypeDesc"] = "type_DESC";
  return MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2;
})(MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder || {});
var MobileContentBlockOrder = /* @__PURE__ */ ((MobileContentBlockOrder2) => {
  MobileContentBlockOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MobileContentBlockOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MobileContentBlockOrder2["PrimaryTextAsc"] = "primaryText_ASC";
  MobileContentBlockOrder2["PrimaryTextDesc"] = "primaryText_DESC";
  MobileContentBlockOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MobileContentBlockOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MobileContentBlockOrder2["SysIdAsc"] = "sys_id_ASC";
  MobileContentBlockOrder2["SysIdDesc"] = "sys_id_DESC";
  MobileContentBlockOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MobileContentBlockOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MobileContentBlockOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MobileContentBlockOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MobileContentBlockOrder2;
})(MobileContentBlockOrder || {});
var MobilePageCampaignBlocksCollectionOrder = /* @__PURE__ */ ((MobilePageCampaignBlocksCollectionOrder2) => {
  MobilePageCampaignBlocksCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MobilePageCampaignBlocksCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MobilePageCampaignBlocksCollectionOrder2["PromotionCodeAsc"] = "promotionCode_ASC";
  MobilePageCampaignBlocksCollectionOrder2["PromotionCodeDesc"] = "promotionCode_DESC";
  MobilePageCampaignBlocksCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MobilePageCampaignBlocksCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MobilePageCampaignBlocksCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  MobilePageCampaignBlocksCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  MobilePageCampaignBlocksCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MobilePageCampaignBlocksCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MobilePageCampaignBlocksCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MobilePageCampaignBlocksCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MobilePageCampaignBlocksCollectionOrder2;
})(MobilePageCampaignBlocksCollectionOrder || {});
var MobilePageOrder = /* @__PURE__ */ ((MobilePageOrder2) => {
  MobilePageOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MobilePageOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MobilePageOrder2["PageTitleAsc"] = "pageTitle_ASC";
  MobilePageOrder2["PageTitleDesc"] = "pageTitle_DESC";
  MobilePageOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MobilePageOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MobilePageOrder2["SysIdAsc"] = "sys_id_ASC";
  MobilePageOrder2["SysIdDesc"] = "sys_id_DESC";
  MobilePageOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MobilePageOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MobilePageOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MobilePageOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MobilePageOrder2;
})(MobilePageOrder || {});
var MobileScreenMobileSectionsCollectionOrder = /* @__PURE__ */ ((MobileScreenMobileSectionsCollectionOrder2) => {
  MobileScreenMobileSectionsCollectionOrder2["BusinessTypeAsc"] = "businessType_ASC";
  MobileScreenMobileSectionsCollectionOrder2["BusinessTypeDesc"] = "businessType_DESC";
  MobileScreenMobileSectionsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MobileScreenMobileSectionsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MobileScreenMobileSectionsCollectionOrder2["IdAsc"] = "id_ASC";
  MobileScreenMobileSectionsCollectionOrder2["IdDesc"] = "id_DESC";
  MobileScreenMobileSectionsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MobileScreenMobileSectionsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MobileScreenMobileSectionsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  MobileScreenMobileSectionsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  MobileScreenMobileSectionsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MobileScreenMobileSectionsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MobileScreenMobileSectionsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MobileScreenMobileSectionsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  MobileScreenMobileSectionsCollectionOrder2["TitleAsc"] = "title_ASC";
  MobileScreenMobileSectionsCollectionOrder2["TitleDesc"] = "title_DESC";
  MobileScreenMobileSectionsCollectionOrder2["TypeAsc"] = "type_ASC";
  MobileScreenMobileSectionsCollectionOrder2["TypeDesc"] = "type_DESC";
  return MobileScreenMobileSectionsCollectionOrder2;
})(MobileScreenMobileSectionsCollectionOrder || {});
var MobileScreenOrder = /* @__PURE__ */ ((MobileScreenOrder2) => {
  MobileScreenOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MobileScreenOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MobileScreenOrder2["IdAsc"] = "id_ASC";
  MobileScreenOrder2["IdDesc"] = "id_DESC";
  MobileScreenOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MobileScreenOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MobileScreenOrder2["SysIdAsc"] = "sys_id_ASC";
  MobileScreenOrder2["SysIdDesc"] = "sys_id_DESC";
  MobileScreenOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MobileScreenOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MobileScreenOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MobileScreenOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  MobileScreenOrder2["TitleAsc"] = "title_ASC";
  MobileScreenOrder2["TitleDesc"] = "title_DESC";
  return MobileScreenOrder2;
})(MobileScreenOrder || {});
var MobileSectionLinkingCollectionsMobileScreenCollectionOrder = /* @__PURE__ */ ((MobileSectionLinkingCollectionsMobileScreenCollectionOrder2) => {
  MobileSectionLinkingCollectionsMobileScreenCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MobileSectionLinkingCollectionsMobileScreenCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MobileSectionLinkingCollectionsMobileScreenCollectionOrder2["IdAsc"] = "id_ASC";
  MobileSectionLinkingCollectionsMobileScreenCollectionOrder2["IdDesc"] = "id_DESC";
  MobileSectionLinkingCollectionsMobileScreenCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MobileSectionLinkingCollectionsMobileScreenCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MobileSectionLinkingCollectionsMobileScreenCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  MobileSectionLinkingCollectionsMobileScreenCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  MobileSectionLinkingCollectionsMobileScreenCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MobileSectionLinkingCollectionsMobileScreenCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MobileSectionLinkingCollectionsMobileScreenCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MobileSectionLinkingCollectionsMobileScreenCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  MobileSectionLinkingCollectionsMobileScreenCollectionOrder2["TitleAsc"] = "title_ASC";
  MobileSectionLinkingCollectionsMobileScreenCollectionOrder2["TitleDesc"] = "title_DESC";
  return MobileSectionLinkingCollectionsMobileScreenCollectionOrder2;
})(MobileSectionLinkingCollectionsMobileScreenCollectionOrder || {});
var MobileSectionOrder = /* @__PURE__ */ ((MobileSectionOrder2) => {
  MobileSectionOrder2["BusinessTypeAsc"] = "businessType_ASC";
  MobileSectionOrder2["BusinessTypeDesc"] = "businessType_DESC";
  MobileSectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MobileSectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MobileSectionOrder2["IdAsc"] = "id_ASC";
  MobileSectionOrder2["IdDesc"] = "id_DESC";
  MobileSectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MobileSectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MobileSectionOrder2["SysIdAsc"] = "sys_id_ASC";
  MobileSectionOrder2["SysIdDesc"] = "sys_id_DESC";
  MobileSectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MobileSectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MobileSectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MobileSectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  MobileSectionOrder2["TitleAsc"] = "title_ASC";
  MobileSectionOrder2["TitleDesc"] = "title_DESC";
  MobileSectionOrder2["TypeAsc"] = "type_ASC";
  MobileSectionOrder2["TypeDesc"] = "type_DESC";
  return MobileSectionOrder2;
})(MobileSectionOrder || {});
var MobileSectionSectionItemsCollectionOrder = /* @__PURE__ */ ((MobileSectionSectionItemsCollectionOrder2) => {
  MobileSectionSectionItemsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MobileSectionSectionItemsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MobileSectionSectionItemsCollectionOrder2["PrimaryTextAsc"] = "primaryText_ASC";
  MobileSectionSectionItemsCollectionOrder2["PrimaryTextDesc"] = "primaryText_DESC";
  MobileSectionSectionItemsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MobileSectionSectionItemsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MobileSectionSectionItemsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  MobileSectionSectionItemsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  MobileSectionSectionItemsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MobileSectionSectionItemsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MobileSectionSectionItemsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MobileSectionSectionItemsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MobileSectionSectionItemsCollectionOrder2;
})(MobileSectionSectionItemsCollectionOrder || {});
var ModularPageOrder = /* @__PURE__ */ ((ModularPageOrder2) => {
  ModularPageOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ModularPageOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ModularPageOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ModularPageOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ModularPageOrder2["SysIdAsc"] = "sys_id_ASC";
  ModularPageOrder2["SysIdDesc"] = "sys_id_DESC";
  ModularPageOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ModularPageOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ModularPageOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ModularPageOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ModularPageOrder2;
})(ModularPageOrder || {});
var NamespaceAndStringLinkingCollectionsArrayOfItemsCollectionOrder = /* @__PURE__ */ ((NamespaceAndStringLinkingCollectionsArrayOfItemsCollectionOrder2) => {
  NamespaceAndStringLinkingCollectionsArrayOfItemsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  NamespaceAndStringLinkingCollectionsArrayOfItemsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  NamespaceAndStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  NamespaceAndStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  NamespaceAndStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  NamespaceAndStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  NamespaceAndStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  NamespaceAndStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  NamespaceAndStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  NamespaceAndStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return NamespaceAndStringLinkingCollectionsArrayOfItemsCollectionOrder2;
})(NamespaceAndStringLinkingCollectionsArrayOfItemsCollectionOrder || {});
var NamespaceAndStringOrder = /* @__PURE__ */ ((NamespaceAndStringOrder2) => {
  NamespaceAndStringOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  NamespaceAndStringOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  NamespaceAndStringOrder2["KeyAsc"] = "key_ASC";
  NamespaceAndStringOrder2["KeyDesc"] = "key_DESC";
  NamespaceAndStringOrder2["NamespaceAsc"] = "namespace_ASC";
  NamespaceAndStringOrder2["NamespaceDesc"] = "namespace_DESC";
  NamespaceAndStringOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  NamespaceAndStringOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  NamespaceAndStringOrder2["SysIdAsc"] = "sys_id_ASC";
  NamespaceAndStringOrder2["SysIdDesc"] = "sys_id_DESC";
  NamespaceAndStringOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  NamespaceAndStringOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  NamespaceAndStringOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  NamespaceAndStringOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return NamespaceAndStringOrder2;
})(NamespaceAndStringOrder || {});
var NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder = /* @__PURE__ */ ((NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2) => {
  NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2["BusinessAreaAsc"] = "businessArea_ASC";
  NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2["BusinessAreaDesc"] = "businessArea_DESC";
  NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2["OrderAsc"] = "order_ASC";
  NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2["OrderDesc"] = "order_DESC";
  NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2;
})(NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder || {});
var NavigationDiscoverSectionOrder = /* @__PURE__ */ ((NavigationDiscoverSectionOrder2) => {
  NavigationDiscoverSectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  NavigationDiscoverSectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  NavigationDiscoverSectionOrder2["SearchAsc"] = "search_ASC";
  NavigationDiscoverSectionOrder2["SearchDesc"] = "search_DESC";
  NavigationDiscoverSectionOrder2["ShowResultsTextAsc"] = "showResultsText_ASC";
  NavigationDiscoverSectionOrder2["ShowResultsTextDesc"] = "showResultsText_DESC";
  NavigationDiscoverSectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  NavigationDiscoverSectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  NavigationDiscoverSectionOrder2["SysIdAsc"] = "sys_id_ASC";
  NavigationDiscoverSectionOrder2["SysIdDesc"] = "sys_id_DESC";
  NavigationDiscoverSectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  NavigationDiscoverSectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  NavigationDiscoverSectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  NavigationDiscoverSectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return NavigationDiscoverSectionOrder2;
})(NavigationDiscoverSectionOrder || {});
var NavigationItemLinkingCollectionsFooterCollectionOrder = /* @__PURE__ */ ((NavigationItemLinkingCollectionsFooterCollectionOrder2) => {
  NavigationItemLinkingCollectionsFooterCollectionOrder2["BusinessUnitAsc"] = "businessUnit_ASC";
  NavigationItemLinkingCollectionsFooterCollectionOrder2["BusinessUnitDesc"] = "businessUnit_DESC";
  NavigationItemLinkingCollectionsFooterCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  NavigationItemLinkingCollectionsFooterCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  NavigationItemLinkingCollectionsFooterCollectionOrder2["LocaleSelectorLabelAsc"] = "localeSelectorLabel_ASC";
  NavigationItemLinkingCollectionsFooterCollectionOrder2["LocaleSelectorLabelDesc"] = "localeSelectorLabel_DESC";
  NavigationItemLinkingCollectionsFooterCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  NavigationItemLinkingCollectionsFooterCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  NavigationItemLinkingCollectionsFooterCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  NavigationItemLinkingCollectionsFooterCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  NavigationItemLinkingCollectionsFooterCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  NavigationItemLinkingCollectionsFooterCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  NavigationItemLinkingCollectionsFooterCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  NavigationItemLinkingCollectionsFooterCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return NavigationItemLinkingCollectionsFooterCollectionOrder2;
})(NavigationItemLinkingCollectionsFooterCollectionOrder || {});
var NavigationItemLinkingCollectionsNavigationCollectionOrder = /* @__PURE__ */ ((NavigationItemLinkingCollectionsNavigationCollectionOrder2) => {
  NavigationItemLinkingCollectionsNavigationCollectionOrder2["BusinessAreaAsc"] = "businessArea_ASC";
  NavigationItemLinkingCollectionsNavigationCollectionOrder2["BusinessAreaDesc"] = "businessArea_DESC";
  NavigationItemLinkingCollectionsNavigationCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  NavigationItemLinkingCollectionsNavigationCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  NavigationItemLinkingCollectionsNavigationCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  NavigationItemLinkingCollectionsNavigationCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  NavigationItemLinkingCollectionsNavigationCollectionOrder2["OrderAsc"] = "order_ASC";
  NavigationItemLinkingCollectionsNavigationCollectionOrder2["OrderDesc"] = "order_DESC";
  NavigationItemLinkingCollectionsNavigationCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  NavigationItemLinkingCollectionsNavigationCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  NavigationItemLinkingCollectionsNavigationCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  NavigationItemLinkingCollectionsNavigationCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  NavigationItemLinkingCollectionsNavigationCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  NavigationItemLinkingCollectionsNavigationCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  NavigationItemLinkingCollectionsNavigationCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  NavigationItemLinkingCollectionsNavigationCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return NavigationItemLinkingCollectionsNavigationCollectionOrder2;
})(NavigationItemLinkingCollectionsNavigationCollectionOrder || {});
var NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder = /* @__PURE__ */ ((NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder2) => {
  NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SearchAsc"] = "search_ASC";
  NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SearchDesc"] = "search_DESC";
  NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["ShowResultsTextAsc"] = "showResultsText_ASC";
  NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["ShowResultsTextDesc"] = "showResultsText_DESC";
  NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder2;
})(NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder || {});
var NavigationItemLinkingCollectionsNavigationItemCollectionOrder = /* @__PURE__ */ ((NavigationItemLinkingCollectionsNavigationItemCollectionOrder2) => {
  NavigationItemLinkingCollectionsNavigationItemCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  NavigationItemLinkingCollectionsNavigationItemCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  NavigationItemLinkingCollectionsNavigationItemCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  NavigationItemLinkingCollectionsNavigationItemCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  NavigationItemLinkingCollectionsNavigationItemCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  NavigationItemLinkingCollectionsNavigationItemCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  NavigationItemLinkingCollectionsNavigationItemCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  NavigationItemLinkingCollectionsNavigationItemCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  NavigationItemLinkingCollectionsNavigationItemCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  NavigationItemLinkingCollectionsNavigationItemCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  NavigationItemLinkingCollectionsNavigationItemCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  NavigationItemLinkingCollectionsNavigationItemCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  NavigationItemLinkingCollectionsNavigationItemCollectionOrder2["TooltipAsc"] = "tooltip_ASC";
  NavigationItemLinkingCollectionsNavigationItemCollectionOrder2["TooltipDesc"] = "tooltip_DESC";
  return NavigationItemLinkingCollectionsNavigationItemCollectionOrder2;
})(NavigationItemLinkingCollectionsNavigationItemCollectionOrder || {});
var NavigationItemOrder = /* @__PURE__ */ ((NavigationItemOrder2) => {
  NavigationItemOrder2["DisplayTextAsc"] = "displayText_ASC";
  NavigationItemOrder2["DisplayTextDesc"] = "displayText_DESC";
  NavigationItemOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  NavigationItemOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  NavigationItemOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  NavigationItemOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  NavigationItemOrder2["SysIdAsc"] = "sys_id_ASC";
  NavigationItemOrder2["SysIdDesc"] = "sys_id_DESC";
  NavigationItemOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  NavigationItemOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  NavigationItemOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  NavigationItemOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  NavigationItemOrder2["TooltipAsc"] = "tooltip_ASC";
  NavigationItemOrder2["TooltipDesc"] = "tooltip_DESC";
  return NavigationItemOrder2;
})(NavigationItemOrder || {});
var NavigationOrder = /* @__PURE__ */ ((NavigationOrder2) => {
  NavigationOrder2["BusinessAreaAsc"] = "businessArea_ASC";
  NavigationOrder2["BusinessAreaDesc"] = "businessArea_DESC";
  NavigationOrder2["DisplayTextAsc"] = "displayText_ASC";
  NavigationOrder2["DisplayTextDesc"] = "displayText_DESC";
  NavigationOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  NavigationOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  NavigationOrder2["OrderAsc"] = "order_ASC";
  NavigationOrder2["OrderDesc"] = "order_DESC";
  NavigationOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  NavigationOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  NavigationOrder2["SysIdAsc"] = "sys_id_ASC";
  NavigationOrder2["SysIdDesc"] = "sys_id_DESC";
  NavigationOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  NavigationOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  NavigationOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  NavigationOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return NavigationOrder2;
})(NavigationOrder || {});
var NavigationPromotionsCollectionOrder = /* @__PURE__ */ ((NavigationPromotionsCollectionOrder2) => {
  NavigationPromotionsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  NavigationPromotionsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  NavigationPromotionsCollectionOrder2["ImageDisplayOptionsAsc"] = "imageDisplayOptions_ASC";
  NavigationPromotionsCollectionOrder2["ImageDisplayOptionsDesc"] = "imageDisplayOptions_DESC";
  NavigationPromotionsCollectionOrder2["MediaTypeAsc"] = "mediaType_ASC";
  NavigationPromotionsCollectionOrder2["MediaTypeDesc"] = "mediaType_DESC";
  NavigationPromotionsCollectionOrder2["PrimaryTextAsc"] = "primaryText_ASC";
  NavigationPromotionsCollectionOrder2["PrimaryTextDesc"] = "primaryText_DESC";
  NavigationPromotionsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  NavigationPromotionsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  NavigationPromotionsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  NavigationPromotionsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  NavigationPromotionsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  NavigationPromotionsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  NavigationPromotionsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  NavigationPromotionsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  NavigationPromotionsCollectionOrder2["TertiaryTextAsc"] = "tertiaryText_ASC";
  NavigationPromotionsCollectionOrder2["TertiaryTextDesc"] = "tertiaryText_DESC";
  NavigationPromotionsCollectionOrder2["VideoLinkAsc"] = "videoLink_ASC";
  NavigationPromotionsCollectionOrder2["VideoLinkDesc"] = "videoLink_DESC";
  return NavigationPromotionsCollectionOrder2;
})(NavigationPromotionsCollectionOrder || {});
var OpenGraphSettingsOrder = /* @__PURE__ */ ((OpenGraphSettingsOrder2) => {
  OpenGraphSettingsOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  OpenGraphSettingsOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  OpenGraphSettingsOrder2["OgFacebookAppIdFreightShippingAsc"] = "ogFacebookAppIdFreightShipping_ASC";
  OpenGraphSettingsOrder2["OgFacebookAppIdFreightShippingDesc"] = "ogFacebookAppIdFreightShipping_DESC";
  OpenGraphSettingsOrder2["OgFacebookAppIdGroupAsc"] = "ogFacebookAppIdGroup_ASC";
  OpenGraphSettingsOrder2["OgFacebookAppIdGroupDesc"] = "ogFacebookAppIdGroup_DESC";
  OpenGraphSettingsOrder2["OgFacebookAppIdLogisticsAsc"] = "ogFacebookAppIdLogistics_ASC";
  OpenGraphSettingsOrder2["OgFacebookAppIdLogisticsDesc"] = "ogFacebookAppIdLogistics_DESC";
  OpenGraphSettingsOrder2["OgFacebookAppIdPaxAsc"] = "ogFacebookAppIdPax_ASC";
  OpenGraphSettingsOrder2["OgFacebookAppIdPaxDesc"] = "ogFacebookAppIdPax_DESC";
  OpenGraphSettingsOrder2["OgSiteNameAsc"] = "ogSiteName_ASC";
  OpenGraphSettingsOrder2["OgSiteNameDesc"] = "ogSiteName_DESC";
  OpenGraphSettingsOrder2["OgTwitterSiteAsc"] = "ogTwitterSite_ASC";
  OpenGraphSettingsOrder2["OgTwitterSiteDesc"] = "ogTwitterSite_DESC";
  OpenGraphSettingsOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  OpenGraphSettingsOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  OpenGraphSettingsOrder2["SysIdAsc"] = "sys_id_ASC";
  OpenGraphSettingsOrder2["SysIdDesc"] = "sys_id_DESC";
  OpenGraphSettingsOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  OpenGraphSettingsOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  OpenGraphSettingsOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  OpenGraphSettingsOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return OpenGraphSettingsOrder2;
})(OpenGraphSettingsOrder || {});
var PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder = /* @__PURE__ */ ((PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2) => {
  PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["CategoryAsc"] = "category_ASC";
  PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["CategoryDesc"] = "category_DESC";
  PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2;
})(PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder || {});
var PageSectionLinkingCollectionsArticlePageCollectionOrder = /* @__PURE__ */ ((PageSectionLinkingCollectionsArticlePageCollectionOrder2) => {
  PageSectionLinkingCollectionsArticlePageCollectionOrder2["CategoryAsc"] = "category_ASC";
  PageSectionLinkingCollectionsArticlePageCollectionOrder2["CategoryDesc"] = "category_DESC";
  PageSectionLinkingCollectionsArticlePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  PageSectionLinkingCollectionsArticlePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  PageSectionLinkingCollectionsArticlePageCollectionOrder2["PublishedDateAsc"] = "publishedDate_ASC";
  PageSectionLinkingCollectionsArticlePageCollectionOrder2["PublishedDateDesc"] = "publishedDate_DESC";
  PageSectionLinkingCollectionsArticlePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PageSectionLinkingCollectionsArticlePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PageSectionLinkingCollectionsArticlePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  PageSectionLinkingCollectionsArticlePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  PageSectionLinkingCollectionsArticlePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PageSectionLinkingCollectionsArticlePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PageSectionLinkingCollectionsArticlePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PageSectionLinkingCollectionsArticlePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return PageSectionLinkingCollectionsArticlePageCollectionOrder2;
})(PageSectionLinkingCollectionsArticlePageCollectionOrder || {});
var PageSectionLinkingCollectionsModularPageCollectionOrder = /* @__PURE__ */ ((PageSectionLinkingCollectionsModularPageCollectionOrder2) => {
  PageSectionLinkingCollectionsModularPageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  PageSectionLinkingCollectionsModularPageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  PageSectionLinkingCollectionsModularPageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PageSectionLinkingCollectionsModularPageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PageSectionLinkingCollectionsModularPageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  PageSectionLinkingCollectionsModularPageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  PageSectionLinkingCollectionsModularPageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PageSectionLinkingCollectionsModularPageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PageSectionLinkingCollectionsModularPageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PageSectionLinkingCollectionsModularPageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return PageSectionLinkingCollectionsModularPageCollectionOrder2;
})(PageSectionLinkingCollectionsModularPageCollectionOrder || {});
var PageSectionOrder = /* @__PURE__ */ ((PageSectionOrder2) => {
  PageSectionOrder2["ColumnsAsc"] = "columns_ASC";
  PageSectionOrder2["ColumnsDesc"] = "columns_DESC";
  PageSectionOrder2["DisplayOptionAsc"] = "displayOption_ASC";
  PageSectionOrder2["DisplayOptionDesc"] = "displayOption_DESC";
  PageSectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  PageSectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  PageSectionOrder2["HideBackgroundImageOnMobileAsc"] = "hideBackgroundImageOnMobile_ASC";
  PageSectionOrder2["HideBackgroundImageOnMobileDesc"] = "hideBackgroundImageOnMobile_DESC";
  PageSectionOrder2["SectionDescriptionAsc"] = "sectionDescription_ASC";
  PageSectionOrder2["SectionDescriptionDesc"] = "sectionDescription_DESC";
  PageSectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  PageSectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  PageSectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PageSectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PageSectionOrder2["SysIdAsc"] = "sys_id_ASC";
  PageSectionOrder2["SysIdDesc"] = "sys_id_DESC";
  PageSectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PageSectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PageSectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PageSectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return PageSectionOrder2;
})(PageSectionOrder || {});
var PaxObCardItemsCollectionOrder = /* @__PURE__ */ ((PaxObCardItemsCollectionOrder2) => {
  PaxObCardItemsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  PaxObCardItemsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  PaxObCardItemsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PaxObCardItemsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PaxObCardItemsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  PaxObCardItemsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  PaxObCardItemsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PaxObCardItemsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PaxObCardItemsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PaxObCardItemsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  PaxObCardItemsCollectionOrder2["TypeAsc"] = "type_ASC";
  PaxObCardItemsCollectionOrder2["TypeDesc"] = "type_DESC";
  return PaxObCardItemsCollectionOrder2;
})(PaxObCardItemsCollectionOrder || {});
var PaxObCardOrder = /* @__PURE__ */ ((PaxObCardOrder2) => {
  PaxObCardOrder2["DescriptionAsc"] = "description_ASC";
  PaxObCardOrder2["DescriptionDesc"] = "description_DESC";
  PaxObCardOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  PaxObCardOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  PaxObCardOrder2["MappingCodeAsc"] = "mappingCode_ASC";
  PaxObCardOrder2["MappingCodeDesc"] = "mappingCode_DESC";
  PaxObCardOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PaxObCardOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PaxObCardOrder2["SysIdAsc"] = "sys_id_ASC";
  PaxObCardOrder2["SysIdDesc"] = "sys_id_DESC";
  PaxObCardOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PaxObCardOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PaxObCardOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PaxObCardOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  PaxObCardOrder2["TitleAsc"] = "title_ASC";
  PaxObCardOrder2["TitleDesc"] = "title_DESC";
  PaxObCardOrder2["TypeAsc"] = "type_ASC";
  PaxObCardOrder2["TypeDesc"] = "type_DESC";
  return PaxObCardOrder2;
})(PaxObCardOrder || {});
var PaxObItemLinkingCollectionsPaxObCardCollectionOrder = /* @__PURE__ */ ((PaxObItemLinkingCollectionsPaxObCardCollectionOrder2) => {
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["DescriptionAsc"] = "description_ASC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["DescriptionDesc"] = "description_DESC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["MappingCodeAsc"] = "mappingCode_ASC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["MappingCodeDesc"] = "mappingCode_DESC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["TitleAsc"] = "title_ASC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["TitleDesc"] = "title_DESC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["TypeAsc"] = "type_ASC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["TypeDesc"] = "type_DESC";
  return PaxObItemLinkingCollectionsPaxObCardCollectionOrder2;
})(PaxObItemLinkingCollectionsPaxObCardCollectionOrder || {});
var PaxObItemOrder = /* @__PURE__ */ ((PaxObItemOrder2) => {
  PaxObItemOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  PaxObItemOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  PaxObItemOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PaxObItemOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PaxObItemOrder2["SysIdAsc"] = "sys_id_ASC";
  PaxObItemOrder2["SysIdDesc"] = "sys_id_DESC";
  PaxObItemOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PaxObItemOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PaxObItemOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PaxObItemOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  PaxObItemOrder2["TypeAsc"] = "type_ASC";
  PaxObItemOrder2["TypeDesc"] = "type_DESC";
  return PaxObItemOrder2;
})(PaxObItemOrder || {});
var PaxObResourceOrder = /* @__PURE__ */ ((PaxObResourceOrder2) => {
  PaxObResourceOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  PaxObResourceOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  PaxObResourceOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PaxObResourceOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PaxObResourceOrder2["SysIdAsc"] = "sys_id_ASC";
  PaxObResourceOrder2["SysIdDesc"] = "sys_id_DESC";
  PaxObResourceOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PaxObResourceOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PaxObResourceOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PaxObResourceOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return PaxObResourceOrder2;
})(PaxObResourceOrder || {});
var PaxRouteFerriesCollectionOrder = /* @__PURE__ */ ((PaxRouteFerriesCollectionOrder2) => {
  PaxRouteFerriesCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  PaxRouteFerriesCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  PaxRouteFerriesCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PaxRouteFerriesCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PaxRouteFerriesCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  PaxRouteFerriesCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  PaxRouteFerriesCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PaxRouteFerriesCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PaxRouteFerriesCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PaxRouteFerriesCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return PaxRouteFerriesCollectionOrder2;
})(PaxRouteFerriesCollectionOrder || {});
var PaxRouteOrder = /* @__PURE__ */ ((PaxRouteOrder2) => {
  PaxRouteOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  PaxRouteOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  PaxRouteOrder2["NameAsc"] = "name_ASC";
  PaxRouteOrder2["NameDesc"] = "name_DESC";
  PaxRouteOrder2["PaxScheduleApiCodeIdAsc"] = "paxScheduleApiCodeId_ASC";
  PaxRouteOrder2["PaxScheduleApiCodeIdDesc"] = "paxScheduleApiCodeId_DESC";
  PaxRouteOrder2["RouteMarketingTitleAsc"] = "routeMarketingTitle_ASC";
  PaxRouteOrder2["RouteMarketingTitleDesc"] = "routeMarketingTitle_DESC";
  PaxRouteOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PaxRouteOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PaxRouteOrder2["SysIdAsc"] = "sys_id_ASC";
  PaxRouteOrder2["SysIdDesc"] = "sys_id_DESC";
  PaxRouteOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PaxRouteOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PaxRouteOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PaxRouteOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return PaxRouteOrder2;
})(PaxRouteOrder || {});
var PetsLinkingCollectionsFerryCollectionOrder = /* @__PURE__ */ ((PetsLinkingCollectionsFerryCollectionOrder2) => {
  PetsLinkingCollectionsFerryCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  PetsLinkingCollectionsFerryCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  PetsLinkingCollectionsFerryCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PetsLinkingCollectionsFerryCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PetsLinkingCollectionsFerryCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  PetsLinkingCollectionsFerryCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  PetsLinkingCollectionsFerryCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PetsLinkingCollectionsFerryCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PetsLinkingCollectionsFerryCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PetsLinkingCollectionsFerryCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return PetsLinkingCollectionsFerryCollectionOrder2;
})(PetsLinkingCollectionsFerryCollectionOrder || {});
var PetsOrder = /* @__PURE__ */ ((PetsOrder2) => {
  PetsOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  PetsOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  PetsOrder2["IdAsc"] = "id_ASC";
  PetsOrder2["IdDesc"] = "id_DESC";
  PetsOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PetsOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PetsOrder2["SysIdAsc"] = "sys_id_ASC";
  PetsOrder2["SysIdDesc"] = "sys_id_DESC";
  PetsOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PetsOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PetsOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PetsOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  PetsOrder2["TypeAsc"] = "type_ASC";
  PetsOrder2["TypeDesc"] = "type_DESC";
  return PetsOrder2;
})(PetsOrder || {});
var PluralStringLinkingCollectionsArrayOfItemsCollectionOrder = /* @__PURE__ */ ((PluralStringLinkingCollectionsArrayOfItemsCollectionOrder2) => {
  PluralStringLinkingCollectionsArrayOfItemsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  PluralStringLinkingCollectionsArrayOfItemsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  PluralStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PluralStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PluralStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  PluralStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  PluralStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PluralStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PluralStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PluralStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return PluralStringLinkingCollectionsArrayOfItemsCollectionOrder2;
})(PluralStringLinkingCollectionsArrayOfItemsCollectionOrder || {});
var PluralStringOrder = /* @__PURE__ */ ((PluralStringOrder2) => {
  PluralStringOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  PluralStringOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  PluralStringOrder2["Key_0Asc"] = "key_0_ASC";
  PluralStringOrder2["Key_0Desc"] = "key_0_DESC";
  PluralStringOrder2["Key_1Asc"] = "key_1_ASC";
  PluralStringOrder2["Key_1Desc"] = "key_1_DESC";
  PluralStringOrder2["Key_2Asc"] = "key_2_ASC";
  PluralStringOrder2["Key_2Desc"] = "key_2_DESC";
  PluralStringOrder2["Key_3Asc"] = "key_3_ASC";
  PluralStringOrder2["Key_3Desc"] = "key_3_DESC";
  PluralStringOrder2["Key_4Asc"] = "key_4_ASC";
  PluralStringOrder2["Key_4Desc"] = "key_4_DESC";
  PluralStringOrder2["Key_5Asc"] = "key_5_ASC";
  PluralStringOrder2["Key_5Desc"] = "key_5_DESC";
  PluralStringOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PluralStringOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PluralStringOrder2["SysIdAsc"] = "sys_id_ASC";
  PluralStringOrder2["SysIdDesc"] = "sys_id_DESC";
  PluralStringOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PluralStringOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PluralStringOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PluralStringOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return PluralStringOrder2;
})(PluralStringOrder || {});
var PriceChangedPopupOrder = /* @__PURE__ */ ((PriceChangedPopupOrder2) => {
  PriceChangedPopupOrder2["AcceptNewPriceAsc"] = "acceptNewPrice_ASC";
  PriceChangedPopupOrder2["AcceptNewPriceDesc"] = "acceptNewPrice_DESC";
  PriceChangedPopupOrder2["GoBackAsc"] = "goBack_ASC";
  PriceChangedPopupOrder2["GoBackDesc"] = "goBack_DESC";
  PriceChangedPopupOrder2["HeaderAsc"] = "header_ASC";
  PriceChangedPopupOrder2["HeaderDesc"] = "header_DESC";
  PriceChangedPopupOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PriceChangedPopupOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PriceChangedPopupOrder2["SysIdAsc"] = "sys_id_ASC";
  PriceChangedPopupOrder2["SysIdDesc"] = "sys_id_DESC";
  PriceChangedPopupOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PriceChangedPopupOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PriceChangedPopupOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PriceChangedPopupOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return PriceChangedPopupOrder2;
})(PriceChangedPopupOrder || {});
var ReleaseNotesOrder = /* @__PURE__ */ ((ReleaseNotesOrder2) => {
  ReleaseNotesOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ReleaseNotesOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ReleaseNotesOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ReleaseNotesOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ReleaseNotesOrder2["SysIdAsc"] = "sys_id_ASC";
  ReleaseNotesOrder2["SysIdDesc"] = "sys_id_DESC";
  ReleaseNotesOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ReleaseNotesOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ReleaseNotesOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ReleaseNotesOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  ReleaseNotesOrder2["VersionNumberAsc"] = "versionNumber_ASC";
  ReleaseNotesOrder2["VersionNumberDesc"] = "versionNumber_DESC";
  return ReleaseNotesOrder2;
})(ReleaseNotesOrder || {});
var ResourceOrder = /* @__PURE__ */ ((ResourceOrder2) => {
  ResourceOrder2["ComponentAsc"] = "component_ASC";
  ResourceOrder2["ComponentDesc"] = "component_DESC";
  ResourceOrder2["ContentTypeAsc"] = "contentType_ASC";
  ResourceOrder2["ContentTypeDesc"] = "contentType_DESC";
  ResourceOrder2["DontUseFallbackAsc"] = "dontUseFallback_ASC";
  ResourceOrder2["DontUseFallbackDesc"] = "dontUseFallback_DESC";
  ResourceOrder2["KeyAsc"] = "key_ASC";
  ResourceOrder2["KeyDesc"] = "key_DESC";
  ResourceOrder2["RouteAsc"] = "route_ASC";
  ResourceOrder2["RouteDesc"] = "route_DESC";
  ResourceOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ResourceOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ResourceOrder2["SysIdAsc"] = "sys_id_ASC";
  ResourceOrder2["SysIdDesc"] = "sys_id_DESC";
  ResourceOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ResourceOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ResourceOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ResourceOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ResourceOrder2;
})(ResourceOrder || {});
var RichTextStringLinkingCollectionsArrayOfItemsCollectionOrder = /* @__PURE__ */ ((RichTextStringLinkingCollectionsArrayOfItemsCollectionOrder2) => {
  RichTextStringLinkingCollectionsArrayOfItemsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  RichTextStringLinkingCollectionsArrayOfItemsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  RichTextStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  RichTextStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  RichTextStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  RichTextStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  RichTextStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  RichTextStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  RichTextStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  RichTextStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return RichTextStringLinkingCollectionsArrayOfItemsCollectionOrder2;
})(RichTextStringLinkingCollectionsArrayOfItemsCollectionOrder || {});
var RichTextStringOrder = /* @__PURE__ */ ((RichTextStringOrder2) => {
  RichTextStringOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  RichTextStringOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  RichTextStringOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  RichTextStringOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  RichTextStringOrder2["SysIdAsc"] = "sys_id_ASC";
  RichTextStringOrder2["SysIdDesc"] = "sys_id_DESC";
  RichTextStringOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  RichTextStringOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  RichTextStringOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  RichTextStringOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return RichTextStringOrder2;
})(RichTextStringOrder || {});
var RouteLinkingCollectionsCabinDetailsCollectionOrder = /* @__PURE__ */ ((RouteLinkingCollectionsCabinDetailsCollectionOrder2) => {
  RouteLinkingCollectionsCabinDetailsCollectionOrder2["CabinTypeCodeAsc"] = "cabinTypeCode_ASC";
  RouteLinkingCollectionsCabinDetailsCollectionOrder2["CabinTypeCodeDesc"] = "cabinTypeCode_DESC";
  RouteLinkingCollectionsCabinDetailsCollectionOrder2["HeadlineAsc"] = "headline_ASC";
  RouteLinkingCollectionsCabinDetailsCollectionOrder2["HeadlineDesc"] = "headline_DESC";
  RouteLinkingCollectionsCabinDetailsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  RouteLinkingCollectionsCabinDetailsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  RouteLinkingCollectionsCabinDetailsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  RouteLinkingCollectionsCabinDetailsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  RouteLinkingCollectionsCabinDetailsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  RouteLinkingCollectionsCabinDetailsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  RouteLinkingCollectionsCabinDetailsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  RouteLinkingCollectionsCabinDetailsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return RouteLinkingCollectionsCabinDetailsCollectionOrder2;
})(RouteLinkingCollectionsCabinDetailsCollectionOrder || {});
var RouteLinkingCollectionsCabinGroupCollectionOrder = /* @__PURE__ */ ((RouteLinkingCollectionsCabinGroupCollectionOrder2) => {
  RouteLinkingCollectionsCabinGroupCollectionOrder2["CabinGroupCodeAsc"] = "cabinGroupCode_ASC";
  RouteLinkingCollectionsCabinGroupCollectionOrder2["CabinGroupCodeDesc"] = "cabinGroupCode_DESC";
  RouteLinkingCollectionsCabinGroupCollectionOrder2["EditorDescriptionAsc"] = "editorDescription_ASC";
  RouteLinkingCollectionsCabinGroupCollectionOrder2["EditorDescriptionDesc"] = "editorDescription_DESC";
  RouteLinkingCollectionsCabinGroupCollectionOrder2["HeadlineAsc"] = "headline_ASC";
  RouteLinkingCollectionsCabinGroupCollectionOrder2["HeadlineDesc"] = "headline_DESC";
  RouteLinkingCollectionsCabinGroupCollectionOrder2["NoteAsc"] = "note_ASC";
  RouteLinkingCollectionsCabinGroupCollectionOrder2["NoteDesc"] = "note_DESC";
  RouteLinkingCollectionsCabinGroupCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  RouteLinkingCollectionsCabinGroupCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  RouteLinkingCollectionsCabinGroupCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  RouteLinkingCollectionsCabinGroupCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  RouteLinkingCollectionsCabinGroupCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  RouteLinkingCollectionsCabinGroupCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  RouteLinkingCollectionsCabinGroupCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  RouteLinkingCollectionsCabinGroupCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return RouteLinkingCollectionsCabinGroupCollectionOrder2;
})(RouteLinkingCollectionsCabinGroupCollectionOrder || {});
var RouteLinkingCollectionsFlowCabinFaresCollectionOrder = /* @__PURE__ */ ((RouteLinkingCollectionsFlowCabinFaresCollectionOrder2) => {
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["DepartureDateAsc"] = "departureDate_ASC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["DepartureDateDesc"] = "departureDate_DESC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["HeadlineAsc"] = "headline_ASC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["HeadlineDesc"] = "headline_DESC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["MoreThanOneCabinSelectedPopupContinueButtonAsc"] = "moreThanOneCabinSelectedPopupContinueButton_ASC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["MoreThanOneCabinSelectedPopupContinueButtonDesc"] = "moreThanOneCabinSelectedPopupContinueButton_DESC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["MoreThanOneCabinSelectedPopupStayButtonAsc"] = "moreThanOneCabinSelectedPopupStayButton_ASC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["MoreThanOneCabinSelectedPopupStayButtonDesc"] = "moreThanOneCabinSelectedPopupStayButton_DESC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["MoreThanOneCabinSelectedPopupTitleAsc"] = "moreThanOneCabinSelectedPopupTitle_ASC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["MoreThanOneCabinSelectedPopupTitleDesc"] = "moreThanOneCabinSelectedPopupTitle_DESC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["NavigationDateFormatAsc"] = "navigationDateFormat_ASC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["NavigationDateFormatDesc"] = "navigationDateFormat_DESC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["NoDeparturesAsc"] = "noDepartures_ASC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["NoDeparturesDesc"] = "noDepartures_DESC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["NotAvailablePopupHeadingAsc"] = "notAvailablePopupHeading_ASC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["NotAvailablePopupHeadingDesc"] = "notAvailablePopupHeading_DESC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["NotAvailablePopupReloadAsc"] = "notAvailablePopupReload_ASC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["NotAvailablePopupReloadDesc"] = "notAvailablePopupReload_DESC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["ReturnDateAsc"] = "returnDate_ASC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["ReturnDateDesc"] = "returnDate_DESC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["SelectDateAsc"] = "selectDate_ASC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["SelectDateDesc"] = "selectDate_DESC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["TitleAsc"] = "title_ASC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["TitleDesc"] = "title_DESC";
  return RouteLinkingCollectionsFlowCabinFaresCollectionOrder2;
})(RouteLinkingCollectionsFlowCabinFaresCollectionOrder || {});
var RouteLinkingCollectionsMealsRestaurantCollectionOrder = /* @__PURE__ */ ((RouteLinkingCollectionsMealsRestaurantCollectionOrder2) => {
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["BannerLine1Asc"] = "bannerLine1_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["BannerLine1Desc"] = "bannerLine1_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["BannerLine2LargeAsc"] = "bannerLine2Large_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["BannerLine2LargeDesc"] = "bannerLine2Large_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["BannerLine2SmallAsc"] = "bannerLine2Small_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["BannerLine2SmallDesc"] = "bannerLine2Small_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["BannerLine3Asc"] = "bannerLine3_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["BannerLine3Desc"] = "bannerLine3_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["CloseButtonLightThemeAsc"] = "closeButtonLightTheme_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["CloseButtonLightThemeDesc"] = "closeButtonLightTheme_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["DefaultSeatingTimeAsc"] = "defaultSeatingTime_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["DefaultSeatingTimeDesc"] = "defaultSeatingTime_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["HeadlineAsc"] = "headline_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["HeadlineDesc"] = "headline_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["HighlightedAsc"] = "highlighted_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["HighlightedDesc"] = "highlighted_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuBeveragesHeadlineAsc"] = "menuBeveragesHeadline_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuBeveragesHeadlineDesc"] = "menuBeveragesHeadline_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuCardForChildrenTitleAsc"] = "menuCardForChildrenTitle_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuCardForChildrenTitleDesc"] = "menuCardForChildrenTitle_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuCardTitleAsc"] = "menuCardTitle_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuCardTitleDesc"] = "menuCardTitle_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuDessertsHeadlineAsc"] = "menuDessertsHeadline_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuDessertsHeadlineDesc"] = "menuDessertsHeadline_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuForChildrenHeadlineAsc"] = "menuForChildrenHeadline_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuForChildrenHeadlineDesc"] = "menuForChildrenHeadline_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuMainCourseExtrasHeadlineAsc"] = "menuMainCourseExtrasHeadline_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuMainCourseExtrasHeadlineDesc"] = "menuMainCourseExtrasHeadline_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuMainCoursesExpandedAsc"] = "menuMainCoursesExpanded_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuMainCoursesExpandedDesc"] = "menuMainCoursesExpanded_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuMainCoursesHeadlineAsc"] = "menuMainCoursesHeadline_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuMainCoursesHeadlineDesc"] = "menuMainCoursesHeadline_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuSectionsNoCollapseAsc"] = "menuSectionsNoCollapse_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuSectionsNoCollapseDesc"] = "menuSectionsNoCollapse_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuStartersExpandedAsc"] = "menuStartersExpanded_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuStartersExpandedDesc"] = "menuStartersExpanded_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuStartersHeadlineAsc"] = "menuStartersHeadline_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuStartersHeadlineDesc"] = "menuStartersHeadline_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["RestaurantCodeAsc"] = "restaurantCode_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["RestaurantCodeDesc"] = "restaurantCode_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["RestaurantNameAsc"] = "restaurantName_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["RestaurantNameDesc"] = "restaurantName_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return RouteLinkingCollectionsMealsRestaurantCollectionOrder2;
})(RouteLinkingCollectionsMealsRestaurantCollectionOrder || {});
var RouteOrder = /* @__PURE__ */ ((RouteOrder2) => {
  RouteOrder2["RouteCodeAsc"] = "routeCode_ASC";
  RouteOrder2["RouteCodeDesc"] = "routeCode_DESC";
  RouteOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  RouteOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  RouteOrder2["SysIdAsc"] = "sys_id_ASC";
  RouteOrder2["SysIdDesc"] = "sys_id_DESC";
  RouteOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  RouteOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  RouteOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  RouteOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return RouteOrder2;
})(RouteOrder || {});
var SectionTypeLinkingCollectionsPageSectionCollectionOrder = /* @__PURE__ */ ((SectionTypeLinkingCollectionsPageSectionCollectionOrder2) => {
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["ColumnsAsc"] = "columns_ASC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["ColumnsDesc"] = "columns_DESC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["DisplayOptionAsc"] = "displayOption_ASC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["DisplayOptionDesc"] = "displayOption_DESC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["HideBackgroundImageOnMobileAsc"] = "hideBackgroundImageOnMobile_ASC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["HideBackgroundImageOnMobileDesc"] = "hideBackgroundImageOnMobile_DESC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["SectionDescriptionAsc"] = "sectionDescription_ASC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["SectionDescriptionDesc"] = "sectionDescription_DESC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return SectionTypeLinkingCollectionsPageSectionCollectionOrder2;
})(SectionTypeLinkingCollectionsPageSectionCollectionOrder || {});
var SectionTypeOrder = /* @__PURE__ */ ((SectionTypeOrder2) => {
  SectionTypeOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  SectionTypeOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  SectionTypeOrder2["SectionCodeIdAsc"] = "sectionCodeId_ASC";
  SectionTypeOrder2["SectionCodeIdDesc"] = "sectionCodeId_DESC";
  SectionTypeOrder2["SectionTypeAsc"] = "sectionType_ASC";
  SectionTypeOrder2["SectionTypeDesc"] = "sectionType_DESC";
  SectionTypeOrder2["SectionVariantIdAsc"] = "sectionVariantId_ASC";
  SectionTypeOrder2["SectionVariantIdDesc"] = "sectionVariantId_DESC";
  SectionTypeOrder2["SectionVariantAsc"] = "sectionVariant_ASC";
  SectionTypeOrder2["SectionVariantDesc"] = "sectionVariant_DESC";
  SectionTypeOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SectionTypeOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SectionTypeOrder2["SysIdAsc"] = "sys_id_ASC";
  SectionTypeOrder2["SysIdDesc"] = "sys_id_DESC";
  SectionTypeOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SectionTypeOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SectionTypeOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SectionTypeOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return SectionTypeOrder2;
})(SectionTypeOrder || {});
var SimpleStringLinkingCollectionsArrayOfItemsCollectionOrder = /* @__PURE__ */ ((SimpleStringLinkingCollectionsArrayOfItemsCollectionOrder2) => {
  SimpleStringLinkingCollectionsArrayOfItemsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  SimpleStringLinkingCollectionsArrayOfItemsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  SimpleStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SimpleStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SimpleStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  SimpleStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  SimpleStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SimpleStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SimpleStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SimpleStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return SimpleStringLinkingCollectionsArrayOfItemsCollectionOrder2;
})(SimpleStringLinkingCollectionsArrayOfItemsCollectionOrder || {});
var SimpleStringLinkingCollectionsFooterCollectionOrder = /* @__PURE__ */ ((SimpleStringLinkingCollectionsFooterCollectionOrder2) => {
  SimpleStringLinkingCollectionsFooterCollectionOrder2["BusinessUnitAsc"] = "businessUnit_ASC";
  SimpleStringLinkingCollectionsFooterCollectionOrder2["BusinessUnitDesc"] = "businessUnit_DESC";
  SimpleStringLinkingCollectionsFooterCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  SimpleStringLinkingCollectionsFooterCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  SimpleStringLinkingCollectionsFooterCollectionOrder2["LocaleSelectorLabelAsc"] = "localeSelectorLabel_ASC";
  SimpleStringLinkingCollectionsFooterCollectionOrder2["LocaleSelectorLabelDesc"] = "localeSelectorLabel_DESC";
  SimpleStringLinkingCollectionsFooterCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SimpleStringLinkingCollectionsFooterCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SimpleStringLinkingCollectionsFooterCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  SimpleStringLinkingCollectionsFooterCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  SimpleStringLinkingCollectionsFooterCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SimpleStringLinkingCollectionsFooterCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SimpleStringLinkingCollectionsFooterCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SimpleStringLinkingCollectionsFooterCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return SimpleStringLinkingCollectionsFooterCollectionOrder2;
})(SimpleStringLinkingCollectionsFooterCollectionOrder || {});
var SimpleStringLinkingCollectionsGenericRouteCollectionOrder = /* @__PURE__ */ ((SimpleStringLinkingCollectionsGenericRouteCollectionOrder2) => {
  SimpleStringLinkingCollectionsGenericRouteCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  SimpleStringLinkingCollectionsGenericRouteCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  SimpleStringLinkingCollectionsGenericRouteCollectionOrder2["RouteCodeAsc"] = "routeCode_ASC";
  SimpleStringLinkingCollectionsGenericRouteCollectionOrder2["RouteCodeDesc"] = "routeCode_DESC";
  SimpleStringLinkingCollectionsGenericRouteCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SimpleStringLinkingCollectionsGenericRouteCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SimpleStringLinkingCollectionsGenericRouteCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  SimpleStringLinkingCollectionsGenericRouteCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  SimpleStringLinkingCollectionsGenericRouteCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SimpleStringLinkingCollectionsGenericRouteCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SimpleStringLinkingCollectionsGenericRouteCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SimpleStringLinkingCollectionsGenericRouteCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return SimpleStringLinkingCollectionsGenericRouteCollectionOrder2;
})(SimpleStringLinkingCollectionsGenericRouteCollectionOrder || {});
var SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder = /* @__PURE__ */ ((SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder2) => {
  SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SearchAsc"] = "search_ASC";
  SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SearchDesc"] = "search_DESC";
  SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["ShowResultsTextAsc"] = "showResultsText_ASC";
  SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["ShowResultsTextDesc"] = "showResultsText_DESC";
  SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder2;
})(SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder || {});
var SimpleStringOrder = /* @__PURE__ */ ((SimpleStringOrder2) => {
  SimpleStringOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  SimpleStringOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  SimpleStringOrder2["KeyAsc"] = "key_ASC";
  SimpleStringOrder2["KeyDesc"] = "key_DESC";
  SimpleStringOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SimpleStringOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SimpleStringOrder2["SysIdAsc"] = "sys_id_ASC";
  SimpleStringOrder2["SysIdDesc"] = "sys_id_DESC";
  SimpleStringOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SimpleStringOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SimpleStringOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SimpleStringOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return SimpleStringOrder2;
})(SimpleStringOrder || {});
var SiteSettingsLinkingCollectionsFooterCollectionOrder = /* @__PURE__ */ ((SiteSettingsLinkingCollectionsFooterCollectionOrder2) => {
  SiteSettingsLinkingCollectionsFooterCollectionOrder2["BusinessUnitAsc"] = "businessUnit_ASC";
  SiteSettingsLinkingCollectionsFooterCollectionOrder2["BusinessUnitDesc"] = "businessUnit_DESC";
  SiteSettingsLinkingCollectionsFooterCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  SiteSettingsLinkingCollectionsFooterCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  SiteSettingsLinkingCollectionsFooterCollectionOrder2["LocaleSelectorLabelAsc"] = "localeSelectorLabel_ASC";
  SiteSettingsLinkingCollectionsFooterCollectionOrder2["LocaleSelectorLabelDesc"] = "localeSelectorLabel_DESC";
  SiteSettingsLinkingCollectionsFooterCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SiteSettingsLinkingCollectionsFooterCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SiteSettingsLinkingCollectionsFooterCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  SiteSettingsLinkingCollectionsFooterCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  SiteSettingsLinkingCollectionsFooterCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SiteSettingsLinkingCollectionsFooterCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SiteSettingsLinkingCollectionsFooterCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SiteSettingsLinkingCollectionsFooterCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return SiteSettingsLinkingCollectionsFooterCollectionOrder2;
})(SiteSettingsLinkingCollectionsFooterCollectionOrder || {});
var SiteSettingsLinkingCollectionsNavigationCollectionOrder = /* @__PURE__ */ ((SiteSettingsLinkingCollectionsNavigationCollectionOrder2) => {
  SiteSettingsLinkingCollectionsNavigationCollectionOrder2["BusinessAreaAsc"] = "businessArea_ASC";
  SiteSettingsLinkingCollectionsNavigationCollectionOrder2["BusinessAreaDesc"] = "businessArea_DESC";
  SiteSettingsLinkingCollectionsNavigationCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  SiteSettingsLinkingCollectionsNavigationCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  SiteSettingsLinkingCollectionsNavigationCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  SiteSettingsLinkingCollectionsNavigationCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  SiteSettingsLinkingCollectionsNavigationCollectionOrder2["OrderAsc"] = "order_ASC";
  SiteSettingsLinkingCollectionsNavigationCollectionOrder2["OrderDesc"] = "order_DESC";
  SiteSettingsLinkingCollectionsNavigationCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SiteSettingsLinkingCollectionsNavigationCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SiteSettingsLinkingCollectionsNavigationCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  SiteSettingsLinkingCollectionsNavigationCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  SiteSettingsLinkingCollectionsNavigationCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SiteSettingsLinkingCollectionsNavigationCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SiteSettingsLinkingCollectionsNavigationCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SiteSettingsLinkingCollectionsNavigationCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return SiteSettingsLinkingCollectionsNavigationCollectionOrder2;
})(SiteSettingsLinkingCollectionsNavigationCollectionOrder || {});
var SiteSettingsOrder = /* @__PURE__ */ ((SiteSettingsOrder2) => {
  SiteSettingsOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  SiteSettingsOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  SiteSettingsOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SiteSettingsOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SiteSettingsOrder2["SysIdAsc"] = "sys_id_ASC";
  SiteSettingsOrder2["SysIdDesc"] = "sys_id_DESC";
  SiteSettingsOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SiteSettingsOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SiteSettingsOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SiteSettingsOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return SiteSettingsOrder2;
})(SiteSettingsOrder || {});
var TeamNameLinkingCollectionsArrayOfItemsCollectionOrder = /* @__PURE__ */ ((TeamNameLinkingCollectionsArrayOfItemsCollectionOrder2) => {
  TeamNameLinkingCollectionsArrayOfItemsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TeamNameLinkingCollectionsArrayOfItemsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TeamNameLinkingCollectionsArrayOfItemsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TeamNameLinkingCollectionsArrayOfItemsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TeamNameLinkingCollectionsArrayOfItemsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TeamNameLinkingCollectionsArrayOfItemsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TeamNameLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TeamNameLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TeamNameLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TeamNameLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TeamNameLinkingCollectionsArrayOfItemsCollectionOrder2;
})(TeamNameLinkingCollectionsArrayOfItemsCollectionOrder || {});
var TeamNameLinkingCollectionsLongStringCollectionOrder = /* @__PURE__ */ ((TeamNameLinkingCollectionsLongStringCollectionOrder2) => {
  TeamNameLinkingCollectionsLongStringCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TeamNameLinkingCollectionsLongStringCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TeamNameLinkingCollectionsLongStringCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TeamNameLinkingCollectionsLongStringCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TeamNameLinkingCollectionsLongStringCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TeamNameLinkingCollectionsLongStringCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TeamNameLinkingCollectionsLongStringCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TeamNameLinkingCollectionsLongStringCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TeamNameLinkingCollectionsLongStringCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TeamNameLinkingCollectionsLongStringCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TeamNameLinkingCollectionsLongStringCollectionOrder2;
})(TeamNameLinkingCollectionsLongStringCollectionOrder || {});
var TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder = /* @__PURE__ */ ((TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder2) => {
  TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder2["KeyAsc"] = "key_ASC";
  TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder2["KeyDesc"] = "key_DESC";
  TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder2["NamespaceAsc"] = "namespace_ASC";
  TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder2["NamespaceDesc"] = "namespace_DESC";
  TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder2;
})(TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder || {});
var TeamNameLinkingCollectionsReleaseNotesCollectionOrder = /* @__PURE__ */ ((TeamNameLinkingCollectionsReleaseNotesCollectionOrder2) => {
  TeamNameLinkingCollectionsReleaseNotesCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TeamNameLinkingCollectionsReleaseNotesCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TeamNameLinkingCollectionsReleaseNotesCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TeamNameLinkingCollectionsReleaseNotesCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TeamNameLinkingCollectionsReleaseNotesCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TeamNameLinkingCollectionsReleaseNotesCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TeamNameLinkingCollectionsReleaseNotesCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TeamNameLinkingCollectionsReleaseNotesCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TeamNameLinkingCollectionsReleaseNotesCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TeamNameLinkingCollectionsReleaseNotesCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  TeamNameLinkingCollectionsReleaseNotesCollectionOrder2["VersionNumberAsc"] = "versionNumber_ASC";
  TeamNameLinkingCollectionsReleaseNotesCollectionOrder2["VersionNumberDesc"] = "versionNumber_DESC";
  return TeamNameLinkingCollectionsReleaseNotesCollectionOrder2;
})(TeamNameLinkingCollectionsReleaseNotesCollectionOrder || {});
var TeamNameLinkingCollectionsRichTextStringCollectionOrder = /* @__PURE__ */ ((TeamNameLinkingCollectionsRichTextStringCollectionOrder2) => {
  TeamNameLinkingCollectionsRichTextStringCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TeamNameLinkingCollectionsRichTextStringCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TeamNameLinkingCollectionsRichTextStringCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TeamNameLinkingCollectionsRichTextStringCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TeamNameLinkingCollectionsRichTextStringCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TeamNameLinkingCollectionsRichTextStringCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TeamNameLinkingCollectionsRichTextStringCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TeamNameLinkingCollectionsRichTextStringCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TeamNameLinkingCollectionsRichTextStringCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TeamNameLinkingCollectionsRichTextStringCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TeamNameLinkingCollectionsRichTextStringCollectionOrder2;
})(TeamNameLinkingCollectionsRichTextStringCollectionOrder || {});
var TeamNameLinkingCollectionsSimpleStringCollectionOrder = /* @__PURE__ */ ((TeamNameLinkingCollectionsSimpleStringCollectionOrder2) => {
  TeamNameLinkingCollectionsSimpleStringCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TeamNameLinkingCollectionsSimpleStringCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TeamNameLinkingCollectionsSimpleStringCollectionOrder2["KeyAsc"] = "key_ASC";
  TeamNameLinkingCollectionsSimpleStringCollectionOrder2["KeyDesc"] = "key_DESC";
  TeamNameLinkingCollectionsSimpleStringCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TeamNameLinkingCollectionsSimpleStringCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TeamNameLinkingCollectionsSimpleStringCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TeamNameLinkingCollectionsSimpleStringCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TeamNameLinkingCollectionsSimpleStringCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TeamNameLinkingCollectionsSimpleStringCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TeamNameLinkingCollectionsSimpleStringCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TeamNameLinkingCollectionsSimpleStringCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TeamNameLinkingCollectionsSimpleStringCollectionOrder2;
})(TeamNameLinkingCollectionsSimpleStringCollectionOrder || {});
var TeamNameLinkingCollectionsTitleAndLinkCollectionOrder = /* @__PURE__ */ ((TeamNameLinkingCollectionsTitleAndLinkCollectionOrder2) => {
  TeamNameLinkingCollectionsTitleAndLinkCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TeamNameLinkingCollectionsTitleAndLinkCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TeamNameLinkingCollectionsTitleAndLinkCollectionOrder2["LinkAsc"] = "link_ASC";
  TeamNameLinkingCollectionsTitleAndLinkCollectionOrder2["LinkDesc"] = "link_DESC";
  TeamNameLinkingCollectionsTitleAndLinkCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TeamNameLinkingCollectionsTitleAndLinkCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TeamNameLinkingCollectionsTitleAndLinkCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TeamNameLinkingCollectionsTitleAndLinkCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TeamNameLinkingCollectionsTitleAndLinkCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TeamNameLinkingCollectionsTitleAndLinkCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TeamNameLinkingCollectionsTitleAndLinkCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TeamNameLinkingCollectionsTitleAndLinkCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  TeamNameLinkingCollectionsTitleAndLinkCollectionOrder2["TitleAsc"] = "title_ASC";
  TeamNameLinkingCollectionsTitleAndLinkCollectionOrder2["TitleDesc"] = "title_DESC";
  return TeamNameLinkingCollectionsTitleAndLinkCollectionOrder2;
})(TeamNameLinkingCollectionsTitleAndLinkCollectionOrder || {});
var TeamNameLinkingCollectionsTitleAndMediaCollectionOrder = /* @__PURE__ */ ((TeamNameLinkingCollectionsTitleAndMediaCollectionOrder2) => {
  TeamNameLinkingCollectionsTitleAndMediaCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TeamNameLinkingCollectionsTitleAndMediaCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TeamNameLinkingCollectionsTitleAndMediaCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TeamNameLinkingCollectionsTitleAndMediaCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TeamNameLinkingCollectionsTitleAndMediaCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TeamNameLinkingCollectionsTitleAndMediaCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TeamNameLinkingCollectionsTitleAndMediaCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TeamNameLinkingCollectionsTitleAndMediaCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TeamNameLinkingCollectionsTitleAndMediaCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TeamNameLinkingCollectionsTitleAndMediaCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  TeamNameLinkingCollectionsTitleAndMediaCollectionOrder2["TitleAsc"] = "title_ASC";
  TeamNameLinkingCollectionsTitleAndMediaCollectionOrder2["TitleDesc"] = "title_DESC";
  return TeamNameLinkingCollectionsTitleAndMediaCollectionOrder2;
})(TeamNameLinkingCollectionsTitleAndMediaCollectionOrder || {});
var TeamNameOrder = /* @__PURE__ */ ((TeamNameOrder2) => {
  TeamNameOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TeamNameOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TeamNameOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TeamNameOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TeamNameOrder2["SysIdAsc"] = "sys_id_ASC";
  TeamNameOrder2["SysIdDesc"] = "sys_id_DESC";
  TeamNameOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TeamNameOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TeamNameOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TeamNameOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TeamNameOrder2;
})(TeamNameOrder || {});
var TerminalLinkingCollectionsPaxRouteCollectionOrder = /* @__PURE__ */ ((TerminalLinkingCollectionsPaxRouteCollectionOrder2) => {
  TerminalLinkingCollectionsPaxRouteCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TerminalLinkingCollectionsPaxRouteCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TerminalLinkingCollectionsPaxRouteCollectionOrder2["NameAsc"] = "name_ASC";
  TerminalLinkingCollectionsPaxRouteCollectionOrder2["NameDesc"] = "name_DESC";
  TerminalLinkingCollectionsPaxRouteCollectionOrder2["PaxScheduleApiCodeIdAsc"] = "paxScheduleApiCodeId_ASC";
  TerminalLinkingCollectionsPaxRouteCollectionOrder2["PaxScheduleApiCodeIdDesc"] = "paxScheduleApiCodeId_DESC";
  TerminalLinkingCollectionsPaxRouteCollectionOrder2["RouteMarketingTitleAsc"] = "routeMarketingTitle_ASC";
  TerminalLinkingCollectionsPaxRouteCollectionOrder2["RouteMarketingTitleDesc"] = "routeMarketingTitle_DESC";
  TerminalLinkingCollectionsPaxRouteCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TerminalLinkingCollectionsPaxRouteCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TerminalLinkingCollectionsPaxRouteCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TerminalLinkingCollectionsPaxRouteCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TerminalLinkingCollectionsPaxRouteCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TerminalLinkingCollectionsPaxRouteCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TerminalLinkingCollectionsPaxRouteCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TerminalLinkingCollectionsPaxRouteCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TerminalLinkingCollectionsPaxRouteCollectionOrder2;
})(TerminalLinkingCollectionsPaxRouteCollectionOrder || {});
var TerminalOrder = /* @__PURE__ */ ((TerminalOrder2) => {
  TerminalOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TerminalOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TerminalOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TerminalOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TerminalOrder2["SysIdAsc"] = "sys_id_ASC";
  TerminalOrder2["SysIdDesc"] = "sys_id_DESC";
  TerminalOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TerminalOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TerminalOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TerminalOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  TerminalOrder2["TerminalIdAsc"] = "terminalId_ASC";
  TerminalOrder2["TerminalIdDesc"] = "terminalId_DESC";
  return TerminalOrder2;
})(TerminalOrder || {});
var TestOrder = /* @__PURE__ */ ((TestOrder2) => {
  TestOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TestOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TestOrder2["SysIdAsc"] = "sys_id_ASC";
  TestOrder2["SysIdDesc"] = "sys_id_DESC";
  TestOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TestOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TestOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TestOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TestOrder2;
})(TestOrder || {});
var TextAndMediaSectionLinkingCollectionsB2BCompositePageCollectionOrder = /* @__PURE__ */ ((TextAndMediaSectionLinkingCollectionsB2BCompositePageCollectionOrder2) => {
  TextAndMediaSectionLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TextAndMediaSectionLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TextAndMediaSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TextAndMediaSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TextAndMediaSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TextAndMediaSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TextAndMediaSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TextAndMediaSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TextAndMediaSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TextAndMediaSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TextAndMediaSectionLinkingCollectionsB2BCompositePageCollectionOrder2;
})(TextAndMediaSectionLinkingCollectionsB2BCompositePageCollectionOrder || {});
var TextAndMediaSectionLinkingCollectionsB2CCompositePageCollectionOrder = /* @__PURE__ */ ((TextAndMediaSectionLinkingCollectionsB2CCompositePageCollectionOrder2) => {
  TextAndMediaSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TextAndMediaSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TextAndMediaSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TextAndMediaSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TextAndMediaSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TextAndMediaSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TextAndMediaSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TextAndMediaSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TextAndMediaSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TextAndMediaSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TextAndMediaSectionLinkingCollectionsB2CCompositePageCollectionOrder2;
})(TextAndMediaSectionLinkingCollectionsB2CCompositePageCollectionOrder || {});
var TextAndMediaSectionLinksCollectionOrder = /* @__PURE__ */ ((TextAndMediaSectionLinksCollectionOrder2) => {
  TextAndMediaSectionLinksCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  TextAndMediaSectionLinksCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  TextAndMediaSectionLinksCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TextAndMediaSectionLinksCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TextAndMediaSectionLinksCollectionOrder2["LinkTypeAsc"] = "linkType_ASC";
  TextAndMediaSectionLinksCollectionOrder2["LinkTypeDesc"] = "linkType_DESC";
  TextAndMediaSectionLinksCollectionOrder2["OpenInNewWindowAsc"] = "openInNewWindow_ASC";
  TextAndMediaSectionLinksCollectionOrder2["OpenInNewWindowDesc"] = "openInNewWindow_DESC";
  TextAndMediaSectionLinksCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TextAndMediaSectionLinksCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TextAndMediaSectionLinksCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TextAndMediaSectionLinksCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TextAndMediaSectionLinksCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TextAndMediaSectionLinksCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TextAndMediaSectionLinksCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TextAndMediaSectionLinksCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  TextAndMediaSectionLinksCollectionOrder2["TooltipAsc"] = "tooltip_ASC";
  TextAndMediaSectionLinksCollectionOrder2["TooltipDesc"] = "tooltip_DESC";
  return TextAndMediaSectionLinksCollectionOrder2;
})(TextAndMediaSectionLinksCollectionOrder || {});
var TextAndMediaSectionOrder = /* @__PURE__ */ ((TextAndMediaSectionOrder2) => {
  TextAndMediaSectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TextAndMediaSectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TextAndMediaSectionOrder2["HeaderAsc"] = "header_ASC";
  TextAndMediaSectionOrder2["HeaderDesc"] = "header_DESC";
  TextAndMediaSectionOrder2["SectionBackgroundColorAsc"] = "sectionBackgroundColor_ASC";
  TextAndMediaSectionOrder2["SectionBackgroundColorDesc"] = "sectionBackgroundColor_DESC";
  TextAndMediaSectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TextAndMediaSectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TextAndMediaSectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TextAndMediaSectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TextAndMediaSectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TextAndMediaSectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TextAndMediaSectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TextAndMediaSectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  TextAndMediaSectionOrder2["VariantAsc"] = "variant_ASC";
  TextAndMediaSectionOrder2["VariantDesc"] = "variant_DESC";
  TextAndMediaSectionOrder2["VideoLinkAsc"] = "videoLink_ASC";
  TextAndMediaSectionOrder2["VideoLinkDesc"] = "videoLink_DESC";
  return TextAndMediaSectionOrder2;
})(TextAndMediaSectionOrder || {});
var TextCardLinkingCollectionsCardsSectionCollectionOrder = /* @__PURE__ */ ((TextCardLinkingCollectionsCardsSectionCollectionOrder2) => {
  TextCardLinkingCollectionsCardsSectionCollectionOrder2["DisplayTypeAsc"] = "displayType_ASC";
  TextCardLinkingCollectionsCardsSectionCollectionOrder2["DisplayTypeDesc"] = "displayType_DESC";
  TextCardLinkingCollectionsCardsSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TextCardLinkingCollectionsCardsSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TextCardLinkingCollectionsCardsSectionCollectionOrder2["OverlineAsc"] = "overline_ASC";
  TextCardLinkingCollectionsCardsSectionCollectionOrder2["OverlineDesc"] = "overline_DESC";
  TextCardLinkingCollectionsCardsSectionCollectionOrder2["SectionBackgroundAndCardColorAsc"] = "sectionBackgroundAndCardColor_ASC";
  TextCardLinkingCollectionsCardsSectionCollectionOrder2["SectionBackgroundAndCardColorDesc"] = "sectionBackgroundAndCardColor_DESC";
  TextCardLinkingCollectionsCardsSectionCollectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  TextCardLinkingCollectionsCardsSectionCollectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  TextCardLinkingCollectionsCardsSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TextCardLinkingCollectionsCardsSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TextCardLinkingCollectionsCardsSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TextCardLinkingCollectionsCardsSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TextCardLinkingCollectionsCardsSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TextCardLinkingCollectionsCardsSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TextCardLinkingCollectionsCardsSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TextCardLinkingCollectionsCardsSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TextCardLinkingCollectionsCardsSectionCollectionOrder2;
})(TextCardLinkingCollectionsCardsSectionCollectionOrder || {});
var TextCardLinksCollectionOrder = /* @__PURE__ */ ((TextCardLinksCollectionOrder2) => {
  TextCardLinksCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  TextCardLinksCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  TextCardLinksCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TextCardLinksCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TextCardLinksCollectionOrder2["LinkTypeAsc"] = "linkType_ASC";
  TextCardLinksCollectionOrder2["LinkTypeDesc"] = "linkType_DESC";
  TextCardLinksCollectionOrder2["OpenInNewWindowAsc"] = "openInNewWindow_ASC";
  TextCardLinksCollectionOrder2["OpenInNewWindowDesc"] = "openInNewWindow_DESC";
  TextCardLinksCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TextCardLinksCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TextCardLinksCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TextCardLinksCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TextCardLinksCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TextCardLinksCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TextCardLinksCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TextCardLinksCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  TextCardLinksCollectionOrder2["TooltipAsc"] = "tooltip_ASC";
  TextCardLinksCollectionOrder2["TooltipDesc"] = "tooltip_DESC";
  return TextCardLinksCollectionOrder2;
})(TextCardLinksCollectionOrder || {});
var TextCardOrder = /* @__PURE__ */ ((TextCardOrder2) => {
  TextCardOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TextCardOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TextCardOrder2["HeaderAsc"] = "header_ASC";
  TextCardOrder2["HeaderDesc"] = "header_DESC";
  TextCardOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TextCardOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TextCardOrder2["SysIdAsc"] = "sys_id_ASC";
  TextCardOrder2["SysIdDesc"] = "sys_id_DESC";
  TextCardOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TextCardOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TextCardOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TextCardOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TextCardOrder2;
})(TextCardOrder || {});
var ThemeLinkingCollectionsAppSectionCollectionOrder = /* @__PURE__ */ ((ThemeLinkingCollectionsAppSectionCollectionOrder2) => {
  ThemeLinkingCollectionsAppSectionCollectionOrder2["AppTypeAsc"] = "appType_ASC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["AppTypeDesc"] = "appType_DESC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["HideBackgroundImageOnMobileAsc"] = "hideBackgroundImageOnMobile_ASC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["HideBackgroundImageOnMobileDesc"] = "hideBackgroundImageOnMobile_DESC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["SectionDescriptionAsc"] = "sectionDescription_ASC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["SectionDescriptionDesc"] = "sectionDescription_DESC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ThemeLinkingCollectionsAppSectionCollectionOrder2;
})(ThemeLinkingCollectionsAppSectionCollectionOrder || {});
var ThemeLinkingCollectionsPageSectionCollectionOrder = /* @__PURE__ */ ((ThemeLinkingCollectionsPageSectionCollectionOrder2) => {
  ThemeLinkingCollectionsPageSectionCollectionOrder2["ColumnsAsc"] = "columns_ASC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["ColumnsDesc"] = "columns_DESC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["DisplayOptionAsc"] = "displayOption_ASC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["DisplayOptionDesc"] = "displayOption_DESC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["HideBackgroundImageOnMobileAsc"] = "hideBackgroundImageOnMobile_ASC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["HideBackgroundImageOnMobileDesc"] = "hideBackgroundImageOnMobile_DESC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["SectionDescriptionAsc"] = "sectionDescription_ASC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["SectionDescriptionDesc"] = "sectionDescription_DESC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ThemeLinkingCollectionsPageSectionCollectionOrder2;
})(ThemeLinkingCollectionsPageSectionCollectionOrder || {});
var ThemeOrder = /* @__PURE__ */ ((ThemeOrder2) => {
  ThemeOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ThemeOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ThemeOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ThemeOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ThemeOrder2["SysIdAsc"] = "sys_id_ASC";
  ThemeOrder2["SysIdDesc"] = "sys_id_DESC";
  ThemeOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ThemeOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ThemeOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ThemeOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  ThemeOrder2["ThemeBackgroundColorAsc"] = "themeBackgroundColor_ASC";
  ThemeOrder2["ThemeBackgroundColorDesc"] = "themeBackgroundColor_DESC";
  ThemeOrder2["ThemeNameAsc"] = "themeName_ASC";
  ThemeOrder2["ThemeNameDesc"] = "themeName_DESC";
  ThemeOrder2["ThemeTextColorAsc"] = "themeTextColor_ASC";
  ThemeOrder2["ThemeTextColorDesc"] = "themeTextColor_DESC";
  return ThemeOrder2;
})(ThemeOrder || {});
var TitleAndLinkLinkingCollectionsArrayOfItemsCollectionOrder = /* @__PURE__ */ ((TitleAndLinkLinkingCollectionsArrayOfItemsCollectionOrder2) => {
  TitleAndLinkLinkingCollectionsArrayOfItemsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TitleAndLinkLinkingCollectionsArrayOfItemsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TitleAndLinkLinkingCollectionsArrayOfItemsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TitleAndLinkLinkingCollectionsArrayOfItemsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TitleAndLinkLinkingCollectionsArrayOfItemsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TitleAndLinkLinkingCollectionsArrayOfItemsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TitleAndLinkLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TitleAndLinkLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TitleAndLinkLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TitleAndLinkLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TitleAndLinkLinkingCollectionsArrayOfItemsCollectionOrder2;
})(TitleAndLinkLinkingCollectionsArrayOfItemsCollectionOrder || {});
var TitleAndLinkOrder = /* @__PURE__ */ ((TitleAndLinkOrder2) => {
  TitleAndLinkOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TitleAndLinkOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TitleAndLinkOrder2["LinkAsc"] = "link_ASC";
  TitleAndLinkOrder2["LinkDesc"] = "link_DESC";
  TitleAndLinkOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TitleAndLinkOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TitleAndLinkOrder2["SysIdAsc"] = "sys_id_ASC";
  TitleAndLinkOrder2["SysIdDesc"] = "sys_id_DESC";
  TitleAndLinkOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TitleAndLinkOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TitleAndLinkOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TitleAndLinkOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  TitleAndLinkOrder2["TitleAsc"] = "title_ASC";
  TitleAndLinkOrder2["TitleDesc"] = "title_DESC";
  return TitleAndLinkOrder2;
})(TitleAndLinkOrder || {});
var TitleAndMediaLinkingCollectionsArrayOfItemsCollectionOrder = /* @__PURE__ */ ((TitleAndMediaLinkingCollectionsArrayOfItemsCollectionOrder2) => {
  TitleAndMediaLinkingCollectionsArrayOfItemsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TitleAndMediaLinkingCollectionsArrayOfItemsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TitleAndMediaLinkingCollectionsArrayOfItemsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TitleAndMediaLinkingCollectionsArrayOfItemsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TitleAndMediaLinkingCollectionsArrayOfItemsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TitleAndMediaLinkingCollectionsArrayOfItemsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TitleAndMediaLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TitleAndMediaLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TitleAndMediaLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TitleAndMediaLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TitleAndMediaLinkingCollectionsArrayOfItemsCollectionOrder2;
})(TitleAndMediaLinkingCollectionsArrayOfItemsCollectionOrder || {});
var TitleAndMediaOrder = /* @__PURE__ */ ((TitleAndMediaOrder2) => {
  TitleAndMediaOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TitleAndMediaOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TitleAndMediaOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TitleAndMediaOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TitleAndMediaOrder2["SysIdAsc"] = "sys_id_ASC";
  TitleAndMediaOrder2["SysIdDesc"] = "sys_id_DESC";
  TitleAndMediaOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TitleAndMediaOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TitleAndMediaOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TitleAndMediaOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  TitleAndMediaOrder2["TitleAsc"] = "title_ASC";
  TitleAndMediaOrder2["TitleDesc"] = "title_DESC";
  return TitleAndMediaOrder2;
})(TitleAndMediaOrder || {});
var TrackingAndActivationLinkingCollectionsModularPageCollectionOrder = /* @__PURE__ */ ((TrackingAndActivationLinkingCollectionsModularPageCollectionOrder2) => {
  TrackingAndActivationLinkingCollectionsModularPageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TrackingAndActivationLinkingCollectionsModularPageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TrackingAndActivationLinkingCollectionsModularPageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TrackingAndActivationLinkingCollectionsModularPageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TrackingAndActivationLinkingCollectionsModularPageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TrackingAndActivationLinkingCollectionsModularPageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TrackingAndActivationLinkingCollectionsModularPageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TrackingAndActivationLinkingCollectionsModularPageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TrackingAndActivationLinkingCollectionsModularPageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TrackingAndActivationLinkingCollectionsModularPageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TrackingAndActivationLinkingCollectionsModularPageCollectionOrder2;
})(TrackingAndActivationLinkingCollectionsModularPageCollectionOrder || {});
var TrackingAndActivationOrder = /* @__PURE__ */ ((TrackingAndActivationOrder2) => {
  TrackingAndActivationOrder2["CommercialOwnerAsc"] = "commercialOwner_ASC";
  TrackingAndActivationOrder2["CommercialOwnerDesc"] = "commercialOwner_DESC";
  TrackingAndActivationOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TrackingAndActivationOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TrackingAndActivationOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TrackingAndActivationOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TrackingAndActivationOrder2["SysIdAsc"] = "sys_id_ASC";
  TrackingAndActivationOrder2["SysIdDesc"] = "sys_id_DESC";
  TrackingAndActivationOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TrackingAndActivationOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TrackingAndActivationOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TrackingAndActivationOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  TrackingAndActivationOrder2["TrackingConversionPointAsc"] = "trackingConversionPoint_ASC";
  TrackingAndActivationOrder2["TrackingConversionPointDesc"] = "trackingConversionPoint_DESC";
  TrackingAndActivationOrder2["TrackingNameAsc"] = "trackingName_ASC";
  TrackingAndActivationOrder2["TrackingNameDesc"] = "trackingName_DESC";
  TrackingAndActivationOrder2["TrackingStageAsc"] = "trackingStage_ASC";
  TrackingAndActivationOrder2["TrackingStageDesc"] = "trackingStage_DESC";
  return TrackingAndActivationOrder2;
})(TrackingAndActivationOrder || {});
var UnitTypeLinkingCollectionsB2BRouteCollectionOrder = /* @__PURE__ */ ((UnitTypeLinkingCollectionsB2BRouteCollectionOrder2) => {
  UnitTypeLinkingCollectionsB2BRouteCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  UnitTypeLinkingCollectionsB2BRouteCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  UnitTypeLinkingCollectionsB2BRouteCollectionOrder2["NameAsc"] = "name_ASC";
  UnitTypeLinkingCollectionsB2BRouteCollectionOrder2["NameDesc"] = "name_DESC";
  UnitTypeLinkingCollectionsB2BRouteCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  UnitTypeLinkingCollectionsB2BRouteCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  UnitTypeLinkingCollectionsB2BRouteCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  UnitTypeLinkingCollectionsB2BRouteCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  UnitTypeLinkingCollectionsB2BRouteCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  UnitTypeLinkingCollectionsB2BRouteCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  UnitTypeLinkingCollectionsB2BRouteCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  UnitTypeLinkingCollectionsB2BRouteCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return UnitTypeLinkingCollectionsB2BRouteCollectionOrder2;
})(UnitTypeLinkingCollectionsB2BRouteCollectionOrder || {});
var UnitTypeOrder = /* @__PURE__ */ ((UnitTypeOrder2) => {
  UnitTypeOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  UnitTypeOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  UnitTypeOrder2["IdAsc"] = "id_ASC";
  UnitTypeOrder2["IdDesc"] = "id_DESC";
  UnitTypeOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  UnitTypeOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  UnitTypeOrder2["SysIdAsc"] = "sys_id_ASC";
  UnitTypeOrder2["SysIdDesc"] = "sys_id_DESC";
  UnitTypeOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  UnitTypeOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  UnitTypeOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  UnitTypeOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  UnitTypeOrder2["UnitTypeAsc"] = "unitType_ASC";
  UnitTypeOrder2["UnitTypeDesc"] = "unitType_DESC";
  return UnitTypeOrder2;
})(UnitTypeOrder || {});
var UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder = /* @__PURE__ */ ((UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2) => {
  UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["CategoryAsc"] = "category_ASC";
  UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["CategoryDesc"] = "category_DESC";
  UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2;
})(UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder || {});
var UrlLinkingCollectionsArticlePageCollectionOrder = /* @__PURE__ */ ((UrlLinkingCollectionsArticlePageCollectionOrder2) => {
  UrlLinkingCollectionsArticlePageCollectionOrder2["CategoryAsc"] = "category_ASC";
  UrlLinkingCollectionsArticlePageCollectionOrder2["CategoryDesc"] = "category_DESC";
  UrlLinkingCollectionsArticlePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  UrlLinkingCollectionsArticlePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  UrlLinkingCollectionsArticlePageCollectionOrder2["PublishedDateAsc"] = "publishedDate_ASC";
  UrlLinkingCollectionsArticlePageCollectionOrder2["PublishedDateDesc"] = "publishedDate_DESC";
  UrlLinkingCollectionsArticlePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  UrlLinkingCollectionsArticlePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  UrlLinkingCollectionsArticlePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  UrlLinkingCollectionsArticlePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  UrlLinkingCollectionsArticlePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  UrlLinkingCollectionsArticlePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  UrlLinkingCollectionsArticlePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  UrlLinkingCollectionsArticlePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return UrlLinkingCollectionsArticlePageCollectionOrder2;
})(UrlLinkingCollectionsArticlePageCollectionOrder || {});
var UrlLinkingCollectionsB2BCompositePageCollectionOrder = /* @__PURE__ */ ((UrlLinkingCollectionsB2BCompositePageCollectionOrder2) => {
  UrlLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  UrlLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  UrlLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  UrlLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  UrlLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  UrlLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  UrlLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  UrlLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  UrlLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  UrlLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return UrlLinkingCollectionsB2BCompositePageCollectionOrder2;
})(UrlLinkingCollectionsB2BCompositePageCollectionOrder || {});
var UrlLinkingCollectionsB2CCompositePageCollectionOrder = /* @__PURE__ */ ((UrlLinkingCollectionsB2CCompositePageCollectionOrder2) => {
  UrlLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  UrlLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  UrlLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  UrlLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  UrlLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  UrlLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  UrlLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  UrlLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  UrlLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  UrlLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return UrlLinkingCollectionsB2CCompositePageCollectionOrder2;
})(UrlLinkingCollectionsB2CCompositePageCollectionOrder || {});
var UrlLinkingCollectionsLinkCollectionOrder = /* @__PURE__ */ ((UrlLinkingCollectionsLinkCollectionOrder2) => {
  UrlLinkingCollectionsLinkCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  UrlLinkingCollectionsLinkCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  UrlLinkingCollectionsLinkCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  UrlLinkingCollectionsLinkCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  UrlLinkingCollectionsLinkCollectionOrder2["LinkTypeAsc"] = "linkType_ASC";
  UrlLinkingCollectionsLinkCollectionOrder2["LinkTypeDesc"] = "linkType_DESC";
  UrlLinkingCollectionsLinkCollectionOrder2["OpenInNewWindowAsc"] = "openInNewWindow_ASC";
  UrlLinkingCollectionsLinkCollectionOrder2["OpenInNewWindowDesc"] = "openInNewWindow_DESC";
  UrlLinkingCollectionsLinkCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  UrlLinkingCollectionsLinkCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  UrlLinkingCollectionsLinkCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  UrlLinkingCollectionsLinkCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  UrlLinkingCollectionsLinkCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  UrlLinkingCollectionsLinkCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  UrlLinkingCollectionsLinkCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  UrlLinkingCollectionsLinkCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  UrlLinkingCollectionsLinkCollectionOrder2["TooltipAsc"] = "tooltip_ASC";
  UrlLinkingCollectionsLinkCollectionOrder2["TooltipDesc"] = "tooltip_DESC";
  return UrlLinkingCollectionsLinkCollectionOrder2;
})(UrlLinkingCollectionsLinkCollectionOrder || {});
var UrlLinkingCollectionsModularPageCollectionOrder = /* @__PURE__ */ ((UrlLinkingCollectionsModularPageCollectionOrder2) => {
  UrlLinkingCollectionsModularPageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  UrlLinkingCollectionsModularPageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  UrlLinkingCollectionsModularPageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  UrlLinkingCollectionsModularPageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  UrlLinkingCollectionsModularPageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  UrlLinkingCollectionsModularPageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  UrlLinkingCollectionsModularPageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  UrlLinkingCollectionsModularPageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  UrlLinkingCollectionsModularPageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  UrlLinkingCollectionsModularPageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return UrlLinkingCollectionsModularPageCollectionOrder2;
})(UrlLinkingCollectionsModularPageCollectionOrder || {});
var UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder = /* @__PURE__ */ ((UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder2) => {
  UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SearchAsc"] = "search_ASC";
  UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SearchDesc"] = "search_DESC";
  UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["ShowResultsTextAsc"] = "showResultsText_ASC";
  UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["ShowResultsTextDesc"] = "showResultsText_DESC";
  UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder2;
})(UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder || {});
var UrlLinkingCollectionsUrlRedirectCollectionOrder = /* @__PURE__ */ ((UrlLinkingCollectionsUrlRedirectCollectionOrder2) => {
  UrlLinkingCollectionsUrlRedirectCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  UrlLinkingCollectionsUrlRedirectCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  UrlLinkingCollectionsUrlRedirectCollectionOrder2["PermanentAsc"] = "permanent_ASC";
  UrlLinkingCollectionsUrlRedirectCollectionOrder2["PermanentDesc"] = "permanent_DESC";
  UrlLinkingCollectionsUrlRedirectCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  UrlLinkingCollectionsUrlRedirectCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  UrlLinkingCollectionsUrlRedirectCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  UrlLinkingCollectionsUrlRedirectCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  UrlLinkingCollectionsUrlRedirectCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  UrlLinkingCollectionsUrlRedirectCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  UrlLinkingCollectionsUrlRedirectCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  UrlLinkingCollectionsUrlRedirectCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return UrlLinkingCollectionsUrlRedirectCollectionOrder2;
})(UrlLinkingCollectionsUrlRedirectCollectionOrder || {});
var UrlLinkingCollectionsWebLinkCollectionOrder = /* @__PURE__ */ ((UrlLinkingCollectionsWebLinkCollectionOrder2) => {
  UrlLinkingCollectionsWebLinkCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  UrlLinkingCollectionsWebLinkCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  UrlLinkingCollectionsWebLinkCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  UrlLinkingCollectionsWebLinkCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  UrlLinkingCollectionsWebLinkCollectionOrder2["IconAsc"] = "icon_ASC";
  UrlLinkingCollectionsWebLinkCollectionOrder2["IconDesc"] = "icon_DESC";
  UrlLinkingCollectionsWebLinkCollectionOrder2["LinkTypeAsc"] = "linkType_ASC";
  UrlLinkingCollectionsWebLinkCollectionOrder2["LinkTypeDesc"] = "linkType_DESC";
  UrlLinkingCollectionsWebLinkCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  UrlLinkingCollectionsWebLinkCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  UrlLinkingCollectionsWebLinkCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  UrlLinkingCollectionsWebLinkCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  UrlLinkingCollectionsWebLinkCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  UrlLinkingCollectionsWebLinkCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  UrlLinkingCollectionsWebLinkCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  UrlLinkingCollectionsWebLinkCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return UrlLinkingCollectionsWebLinkCollectionOrder2;
})(UrlLinkingCollectionsWebLinkCollectionOrder || {});
var UrlOrder = /* @__PURE__ */ ((UrlOrder2) => {
  UrlOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  UrlOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  UrlOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  UrlOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  UrlOrder2["SysIdAsc"] = "sys_id_ASC";
  UrlOrder2["SysIdDesc"] = "sys_id_DESC";
  UrlOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  UrlOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  UrlOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  UrlOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  UrlOrder2["UrlTypeAsc"] = "urlType_ASC";
  UrlOrder2["UrlTypeDesc"] = "urlType_DESC";
  UrlOrder2["UrlAsc"] = "url_ASC";
  UrlOrder2["UrlDesc"] = "url_DESC";
  return UrlOrder2;
})(UrlOrder || {});
var UrlRedirectOrder = /* @__PURE__ */ ((UrlRedirectOrder2) => {
  UrlRedirectOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  UrlRedirectOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  UrlRedirectOrder2["PermanentAsc"] = "permanent_ASC";
  UrlRedirectOrder2["PermanentDesc"] = "permanent_DESC";
  UrlRedirectOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  UrlRedirectOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  UrlRedirectOrder2["SysIdAsc"] = "sys_id_ASC";
  UrlRedirectOrder2["SysIdDesc"] = "sys_id_DESC";
  UrlRedirectOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  UrlRedirectOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  UrlRedirectOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  UrlRedirectOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return UrlRedirectOrder2;
})(UrlRedirectOrder || {});
var WebLinkLinkingCollectionsActionCardCollectionOrder = /* @__PURE__ */ ((WebLinkLinkingCollectionsActionCardCollectionOrder2) => {
  WebLinkLinkingCollectionsActionCardCollectionOrder2["BadgeAsc"] = "badge_ASC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["BadgeDesc"] = "badge_DESC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["CurrencyAsc"] = "currency_ASC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["CurrencyDesc"] = "currency_DESC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["DiscountAsc"] = "discount_ASC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["DiscountDesc"] = "discount_DESC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["HeaderAsc"] = "header_ASC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["HeaderDesc"] = "header_DESC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["PriceAsc"] = "price_ASC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["PriceDesc"] = "price_DESC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["SuffixAsc"] = "suffix_ASC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["SuffixDesc"] = "suffix_DESC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return WebLinkLinkingCollectionsActionCardCollectionOrder2;
})(WebLinkLinkingCollectionsActionCardCollectionOrder || {});
var WebLinkOrder = /* @__PURE__ */ ((WebLinkOrder2) => {
  WebLinkOrder2["DisplayTextAsc"] = "displayText_ASC";
  WebLinkOrder2["DisplayTextDesc"] = "displayText_DESC";
  WebLinkOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  WebLinkOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  WebLinkOrder2["IconAsc"] = "icon_ASC";
  WebLinkOrder2["IconDesc"] = "icon_DESC";
  WebLinkOrder2["LinkTypeAsc"] = "linkType_ASC";
  WebLinkOrder2["LinkTypeDesc"] = "linkType_DESC";
  WebLinkOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  WebLinkOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  WebLinkOrder2["SysIdAsc"] = "sys_id_ASC";
  WebLinkOrder2["SysIdDesc"] = "sys_id_DESC";
  WebLinkOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  WebLinkOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  WebLinkOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  WebLinkOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return WebLinkOrder2;
})(WebLinkOrder || {});
var FieldFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Field" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Field" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "inputType" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "optionsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayValue" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "assistiveText" } },
          { kind: "Field", name: { kind: "Name", value: "placeholder" } },
          { kind: "Field", name: { kind: "Name", value: "errorMessage" } },
          { kind: "Field", name: { kind: "Name", value: "counter" } }
        ]
      }
    }
  ]
};
var FieldControllerFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FieldController" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FieldController" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "field" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Field" }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "question" } },
          { kind: "Field", name: { kind: "Name", value: "required" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Field" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Field" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "inputType" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "optionsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayValue" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "assistiveText" } },
          { kind: "Field", name: { kind: "Name", value: "placeholder" } },
          { kind: "Field", name: { kind: "Name", value: "errorMessage" } },
          { kind: "Field", name: { kind: "Name", value: "counter" } }
        ]
      }
    }
  ]
};
var FormRowFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormRow" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormRow" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "columnsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "2" }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Entry" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "FieldController" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Field" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Field" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "inputType" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "optionsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayValue" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "assistiveText" } },
          { kind: "Field", name: { kind: "Name", value: "placeholder" } },
          { kind: "Field", name: { kind: "Name", value: "errorMessage" } },
          { kind: "Field", name: { kind: "Name", value: "counter" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FieldController" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FieldController" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "field" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Field" }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "question" } },
          { kind: "Field", name: { kind: "Name", value: "required" } }
        ]
      }
    }
  ]
};
var FormMarkdownFieldFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormMarkdownField" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormMarkdownField" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "text" } }
        ]
      }
    }
  ]
};
var FormConsentCheckboxFieldFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormConsentCheckboxField" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormConsentCheckboxField" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "spaceId" } },
                { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "publishedVersion" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "firstPublishedAt" }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "errorMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "spaceId" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedAt" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedVersion" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstPublishedAt" }
                      }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "urlSlug" } },
                { kind: "Field", name: { kind: "Name", value: "textBody" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var FormOptionalConsentCheckboxFieldFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormOptionalConsentCheckboxField" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormOptionalConsentCheckboxField" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "spaceId" } },
                { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "publishedVersion" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "firstPublishedAt" }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "errorMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "spaceId" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedAt" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedVersion" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstPublishedAt" }
                      }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "urlSlug" } },
                { kind: "Field", name: { kind: "Name", value: "textBody" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var FormMessageFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormMessage" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormMessage" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "text" } }
        ]
      }
    }
  ]
};
var FormSubmitButtonFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormSubmitButton" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormSubmitButton" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "label" } }]
      }
    }
  ]
};
var DynamicFormFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DynamicForm" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Form" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "commercialOwner" } },
          { kind: "Field", name: { kind: "Name", value: "trackingName" } },
          { kind: "Field", name: { kind: "Name", value: "trackingStage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "trackingConversionPoint" }
          },
          { kind: "Field", name: { kind: "Name", value: "configuration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rowsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "40" }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Entry" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "FormRow" }
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "FormMarkdownField" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentFieldsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Entry" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "FormConsentCheckboxField"
                        }
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "FormOptionalConsentCheckboxField"
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "submitSuccessMessage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FormMessage" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "submitFailureMessage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FormMessage" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "submitButton" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FormSubmitButton" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Field" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Field" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "inputType" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "optionsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayValue" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "assistiveText" } },
          { kind: "Field", name: { kind: "Name", value: "placeholder" } },
          { kind: "Field", name: { kind: "Name", value: "errorMessage" } },
          { kind: "Field", name: { kind: "Name", value: "counter" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FieldController" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FieldController" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "field" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Field" }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "question" } },
          { kind: "Field", name: { kind: "Name", value: "required" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormRow" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormRow" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "columnsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "2" }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Entry" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "FieldController" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormMarkdownField" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormMarkdownField" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "text" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormConsentCheckboxField" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormConsentCheckboxField" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "spaceId" } },
                { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "publishedVersion" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "firstPublishedAt" }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "errorMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "spaceId" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedAt" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedVersion" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstPublishedAt" }
                      }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "urlSlug" } },
                { kind: "Field", name: { kind: "Name", value: "textBody" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormOptionalConsentCheckboxField" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormOptionalConsentCheckboxField" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "spaceId" } },
                { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "publishedVersion" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "firstPublishedAt" }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "errorMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "spaceId" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedAt" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedVersion" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstPublishedAt" }
                      }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "urlSlug" } },
                { kind: "Field", name: { kind: "Name", value: "textBody" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormMessage" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormMessage" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "text" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormSubmitButton" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormSubmitButton" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "label" } }]
      }
    }
  ]
};
var AssetFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    }
  ]
};
var LinkFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    }
  ]
};
var ContentBlockFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentBlock" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentBlock" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "primaryText" } },
          { kind: "Field", name: { kind: "Name", value: "secondaryText" } },
          { kind: "Field", name: { kind: "Name", value: "tertiaryText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "richText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "listOfShortText" } },
          { kind: "Field", name: { kind: "Name", value: "mediaType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assetsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Asset" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageDisplayOptions" }
          },
          { kind: "Field", name: { kind: "Name", value: "videoLink" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ctasCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Link" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "location" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "lat" } },
                { kind: "Field", name: { kind: "Name", value: "lon" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var MetaDataAndSeoFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MetaDataAndSeo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MetaDataAndSeo" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metadataContent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContentBlock" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pageMetaDescription" }
          },
          { kind: "Field", name: { kind: "Name", value: "pageTitle" } },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "socialImage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "width" } },
                { kind: "Field", name: { kind: "Name", value: "height" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "robotsMeta" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentBlock" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentBlock" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "primaryText" } },
          { kind: "Field", name: { kind: "Name", value: "secondaryText" } },
          { kind: "Field", name: { kind: "Name", value: "tertiaryText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "richText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "listOfShortText" } },
          { kind: "Field", name: { kind: "Name", value: "mediaType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assetsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Asset" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageDisplayOptions" }
          },
          { kind: "Field", name: { kind: "Name", value: "videoLink" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ctasCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Link" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "location" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "lat" } },
                { kind: "Field", name: { kind: "Name", value: "lon" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var SectionThemeFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SectionTheme" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Theme" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "themeName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "themeBackgroundColor" }
          }
        ]
      }
    }
  ]
};
var AppSectionFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AppSection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AppSection" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionBackgroundAsset" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionTheme" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SectionTheme" }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "appType" } },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "sectionHeader" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionDescription" }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reference" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "additionalContentBlock" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContentBlock" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SectionTheme" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Theme" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "themeName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "themeBackgroundColor" }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentBlock" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentBlock" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "primaryText" } },
          { kind: "Field", name: { kind: "Name", value: "secondaryText" } },
          { kind: "Field", name: { kind: "Name", value: "tertiaryText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "richText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "listOfShortText" } },
          { kind: "Field", name: { kind: "Name", value: "mediaType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assetsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Asset" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageDisplayOptions" }
          },
          { kind: "Field", name: { kind: "Name", value: "videoLink" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ctasCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Link" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "location" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "lat" } },
                { kind: "Field", name: { kind: "Name", value: "lon" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var AccordionFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Accordion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accordion" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "details" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var AccordionGroupItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccordionGroupItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccordionGroupItem" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "details" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var PageSectionFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PageSection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PageSection" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "sectionHeader" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionDescription" }
          },
          { kind: "Field", name: { kind: "Name", value: "displayOption" } },
          { kind: "Field", name: { kind: "Name", value: "columns" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "sectionType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionCodeId" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionVariant" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionVariantId" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionTheme" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SectionTheme" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionLink" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Link" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionBackgroundAsset" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contentBlocksCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" }
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Accordion" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Accordion" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "AccordionGroup" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "entryTitle" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "accordionItemCollection"
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "items" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "AccordionGroupItem"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "LinksList" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "entryTitle" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "linksListTitle" }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "linksListItemsCollection"
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "items" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "ContentBlock" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContentBlock" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hideBackgroundImageOnMobile" }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SectionTheme" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Theme" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "themeName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "themeBackgroundColor" }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Accordion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accordion" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "details" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccordionGroupItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccordionGroupItem" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "details" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentBlock" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentBlock" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "primaryText" } },
          { kind: "Field", name: { kind: "Name", value: "secondaryText" } },
          { kind: "Field", name: { kind: "Name", value: "tertiaryText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "richText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "listOfShortText" } },
          { kind: "Field", name: { kind: "Name", value: "mediaType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assetsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Asset" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageDisplayOptions" }
          },
          { kind: "Field", name: { kind: "Name", value: "videoLink" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ctasCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Link" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "location" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "lat" } },
                { kind: "Field", name: { kind: "Name", value: "lon" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var MediaCardFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MediaCard" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MediaCard" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "header" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Asset" }
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Asset" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "priceEyebrow" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "priceDescription" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "linksCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Link" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Link" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var WebLinkFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebLink" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WebLink" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "icon" } }
        ]
      }
    }
  ]
};
var ActionCardFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ActionCard" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ActionCard" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "header" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Asset" }
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Asset" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "link" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "WebLink" }
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "WebLink" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "priceNumber" },
            name: { kind: "Name", value: "price" }
          },
          { kind: "Field", name: { kind: "Name", value: "badge" } },
          { kind: "Field", name: { kind: "Name", value: "currency" } },
          { kind: "Field", name: { kind: "Name", value: "discount" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebLink" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WebLink" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "icon" } }
        ]
      }
    }
  ]
};
var TextCardFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TextCard" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TextCard" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "header" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "linksCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Link" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Link" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var ArticlePageDocument = {
  __meta__: { hash: "4980a48fcf090cc92c2f4675a0351742bf933d32" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ArticlePage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "articlePage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "urlSlug" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heroSection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "PageSection" }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "featuresSection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "PageSection" }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "publishedDate" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "articleRichText" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "json" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "links" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "entries" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "block" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "__typename"
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "inline" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "sys" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id"
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "__typename"
                                          }
                                        },
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: {
                                            kind: "NamedType",
                                            name: {
                                              kind: "Name",
                                              value: "Link"
                                            }
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "displayText"
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "linkType"
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "url"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "url"
                                                      }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "hyperlink" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "__typename"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "sys" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id"
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "assets" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "block" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "sys" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id"
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "url" }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "width"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "height"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "description"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "articleSidebar" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ContentBlock" }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "additionalSectionsCollection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "AppSection" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "AppSection" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "PageSection" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "PageSection"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "relatedArticlesSection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "PageSection" }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "author" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "jobTitle" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "authorImage" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Asset" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "metaDataAndSeo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "metadataContent" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContentBlock" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageMetaDescription" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageTitle" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entryTitle" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "socialImage" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "width" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "height" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "robotsMeta" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SectionTheme" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Theme" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "themeName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "themeBackgroundColor" }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Accordion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accordion" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "details" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccordionGroupItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccordionGroupItem" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "details" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentBlock" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentBlock" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "primaryText" } },
          { kind: "Field", name: { kind: "Name", value: "secondaryText" } },
          { kind: "Field", name: { kind: "Name", value: "tertiaryText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "richText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "listOfShortText" } },
          { kind: "Field", name: { kind: "Name", value: "mediaType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assetsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Asset" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageDisplayOptions" }
          },
          { kind: "Field", name: { kind: "Name", value: "videoLink" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ctasCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Link" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "location" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "lat" } },
                { kind: "Field", name: { kind: "Name", value: "lon" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PageSection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PageSection" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "sectionHeader" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionDescription" }
          },
          { kind: "Field", name: { kind: "Name", value: "displayOption" } },
          { kind: "Field", name: { kind: "Name", value: "columns" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "sectionType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionCodeId" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionVariant" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionVariantId" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionTheme" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SectionTheme" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionLink" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Link" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionBackgroundAsset" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contentBlocksCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" }
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Accordion" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Accordion" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "AccordionGroup" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "entryTitle" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "accordionItemCollection"
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "items" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "AccordionGroupItem"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "LinksList" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "entryTitle" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "linksListTitle" }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "linksListItemsCollection"
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "items" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "ContentBlock" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContentBlock" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hideBackgroundImageOnMobile" }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AppSection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AppSection" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionBackgroundAsset" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionTheme" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SectionTheme" }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "appType" } },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "sectionHeader" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionDescription" }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reference" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "additionalContentBlock" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContentBlock" }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var ArticleCategoryOverviewPageByIdDocument = {
  __meta__: { hash: "57048d949fd12ac19ed082daf851ff3689f6fd79" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "articleCategoryOverviewPageById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "articleCategoryOverviewPage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contentfulMetadata" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "concepts" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "urlSlug" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heroSection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "PageSection" }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "metaDataAndSeo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "metadataContent" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContentBlock" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageMetaDescription" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageTitle" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entryTitle" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "socialImage" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "width" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "height" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "robotsMeta" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SectionTheme" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Theme" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "themeName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "themeBackgroundColor" }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Accordion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accordion" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "details" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccordionGroupItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccordionGroupItem" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "details" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentBlock" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentBlock" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "primaryText" } },
          { kind: "Field", name: { kind: "Name", value: "secondaryText" } },
          { kind: "Field", name: { kind: "Name", value: "tertiaryText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "richText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "listOfShortText" } },
          { kind: "Field", name: { kind: "Name", value: "mediaType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assetsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Asset" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageDisplayOptions" }
          },
          { kind: "Field", name: { kind: "Name", value: "videoLink" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ctasCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Link" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "location" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "lat" } },
                { kind: "Field", name: { kind: "Name", value: "lon" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PageSection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PageSection" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "sectionHeader" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionDescription" }
          },
          { kind: "Field", name: { kind: "Name", value: "displayOption" } },
          { kind: "Field", name: { kind: "Name", value: "columns" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "sectionType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionCodeId" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionVariant" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionVariantId" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionTheme" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SectionTheme" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionLink" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Link" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionBackgroundAsset" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contentBlocksCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" }
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Accordion" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Accordion" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "AccordionGroup" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "entryTitle" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "accordionItemCollection"
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "items" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "AccordionGroupItem"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "LinksList" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "entryTitle" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "linksListTitle" }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "linksListItemsCollection"
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "items" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "ContentBlock" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContentBlock" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hideBackgroundImageOnMobile" }
          }
        ]
      }
    }
  ]
};
var ArticlesByCategoryDocument = {
  __meta__: { hash: "667690a9c3b7354f739b476772cf402ef2dd13a8" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ArticlesByCategory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "category" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "taxonomyConcepts" }
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "String" }
              }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "articlePageCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "category" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "category" }
                      }
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "contentfulMetadata" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "concepts" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "descendants" },
                                  value: {
                                    kind: "ObjectValue",
                                    fields: [
                                      {
                                        kind: "ObjectField",
                                        name: {
                                          kind: "Name",
                                          value: "id_contains_all"
                                        },
                                        value: {
                                          kind: "Variable",
                                          name: {
                                            kind: "Name",
                                            value: "taxonomyConcepts"
                                          }
                                        }
                                      }
                                    ]
                                  }
                                }
                              ]
                            }
                          }
                        ]
                      }
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "urlSlug" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "url_exists" },
                            value: { kind: "BooleanValue", value: true }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "70" }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order" },
                value: {
                  kind: "ListValue",
                  values: [{ kind: "EnumValue", value: "publishedDate_DESC" }]
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contentfulMetadata" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "concepts" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entryTitle" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "category" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "urlSlug" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "heroSection" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "contentBlocksCollection"
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "items" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: {
                                            kind: "NamedType",
                                            name: {
                                              kind: "Name",
                                              value: "ContentBlock"
                                            }
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "primaryText"
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "richText"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "json"
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "assetsCollection"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "items"
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "url"
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "title"
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "icon"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "url"
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "title"
                                                      }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var B2BPageDocument = {
  __meta__: { hash: "16f1668ba9d2e8617920a2a0c5e3bb10918fd423" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "B2BPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "b2BCompositePage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "urlSlug" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionsCollection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "HeroSection" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "TextAndMediaSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "CardsSection" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "metaDataAndSeo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "MetaDataAndSeo" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentBlock" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentBlock" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "primaryText" } },
          { kind: "Field", name: { kind: "Name", value: "secondaryText" } },
          { kind: "Field", name: { kind: "Name", value: "tertiaryText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "richText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "listOfShortText" } },
          { kind: "Field", name: { kind: "Name", value: "mediaType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assetsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Asset" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageDisplayOptions" }
          },
          { kind: "Field", name: { kind: "Name", value: "videoLink" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ctasCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Link" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "location" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "lat" } },
                { kind: "Field", name: { kind: "Name", value: "lon" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MetaDataAndSeo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MetaDataAndSeo" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metadataContent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContentBlock" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pageMetaDescription" }
          },
          { kind: "Field", name: { kind: "Name", value: "pageTitle" } },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "socialImage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "width" } },
                { kind: "Field", name: { kind: "Name", value: "height" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "robotsMeta" } }
        ]
      }
    }
  ]
};
var B2CPageDocument = {
  __meta__: { hash: "259b5b08b60cc85f2d647093d7c7219a8ab9469b" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "B2CPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "b2CCompositePage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "urlSlug" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionsCollection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "HeroPromotionalSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "HeroSection" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "TextAndMediaSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "CardsSection" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "metaDataAndSeo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "MetaDataAndSeo" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentBlock" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentBlock" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "primaryText" } },
          { kind: "Field", name: { kind: "Name", value: "secondaryText" } },
          { kind: "Field", name: { kind: "Name", value: "tertiaryText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "richText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "listOfShortText" } },
          { kind: "Field", name: { kind: "Name", value: "mediaType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assetsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Asset" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageDisplayOptions" }
          },
          { kind: "Field", name: { kind: "Name", value: "videoLink" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ctasCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Link" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "location" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "lat" } },
                { kind: "Field", name: { kind: "Name", value: "lon" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MetaDataAndSeo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MetaDataAndSeo" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metadataContent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContentBlock" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pageMetaDescription" }
          },
          { kind: "Field", name: { kind: "Name", value: "pageTitle" } },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "socialImage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "width" } },
                { kind: "Field", name: { kind: "Name", value: "height" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "robotsMeta" } }
        ]
      }
    }
  ]
};
var BannerCollectionDocument = {
  __meta__: { hash: "3c5117f75653850bd72577e71569d20793324cb2" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "bannerCollection" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "businessArea" }
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "bannerCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: {
                        kind: "Name",
                        value: "businessArea_contains_all"
                      },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "businessArea" }
                      }
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "enabled" },
                      value: { kind: "BooleanValue", value: true }
                    }
                  ]
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "2" }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      { kind: "Field", name: { kind: "Name", value: "text" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "infoLink" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "Link" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "Link" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var GenericAppSectionDocument = {
  __meta__: { hash: "823f1f2bd5ee176aa4214d71a26b6a87ab1eb1a5" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GenericAppSection" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "appSection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AppSection" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SectionTheme" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Theme" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "themeName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "themeBackgroundColor" }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentBlock" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentBlock" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "primaryText" } },
          { kind: "Field", name: { kind: "Name", value: "secondaryText" } },
          { kind: "Field", name: { kind: "Name", value: "tertiaryText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "richText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "listOfShortText" } },
          { kind: "Field", name: { kind: "Name", value: "mediaType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assetsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Asset" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageDisplayOptions" }
          },
          { kind: "Field", name: { kind: "Name", value: "videoLink" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ctasCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Link" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "location" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "lat" } },
                { kind: "Field", name: { kind: "Name", value: "lon" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AppSection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AppSection" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionBackgroundAsset" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionTheme" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SectionTheme" }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "appType" } },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "sectionHeader" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionDescription" }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reference" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "additionalContentBlock" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContentBlock" }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var GenericPageSectionDocument = {
  __meta__: { hash: "3ce47cadabd6f65c85217a221d96c3d3717bc347" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GenericPageSection" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "pageSection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PageSection" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SectionTheme" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Theme" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "themeName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "themeBackgroundColor" }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Accordion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accordion" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "details" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccordionGroupItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccordionGroupItem" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "details" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentBlock" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentBlock" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "primaryText" } },
          { kind: "Field", name: { kind: "Name", value: "secondaryText" } },
          { kind: "Field", name: { kind: "Name", value: "tertiaryText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "richText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "listOfShortText" } },
          { kind: "Field", name: { kind: "Name", value: "mediaType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assetsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Asset" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageDisplayOptions" }
          },
          { kind: "Field", name: { kind: "Name", value: "videoLink" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ctasCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Link" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "location" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "lat" } },
                { kind: "Field", name: { kind: "Name", value: "lon" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PageSection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PageSection" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "sectionHeader" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionDescription" }
          },
          { kind: "Field", name: { kind: "Name", value: "displayOption" } },
          { kind: "Field", name: { kind: "Name", value: "columns" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "sectionType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionCodeId" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionVariant" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionVariantId" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionTheme" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SectionTheme" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionLink" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Link" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionBackgroundAsset" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contentBlocksCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" }
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Accordion" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Accordion" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "AccordionGroup" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "entryTitle" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "accordionItemCollection"
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "items" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "AccordionGroupItem"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "LinksList" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "entryTitle" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "linksListTitle" }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "linksListItemsCollection"
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "items" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "ContentBlock" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContentBlock" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hideBackgroundImageOnMobile" }
          }
        ]
      }
    }
  ]
};
var DynamicFormDocument = {
  __meta__: { hash: "f2be2fccc6676dc3eead206392fd575f20f4778a" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DYNAMIC_FORM" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          defaultValue: { kind: "StringValue", value: "en", block: false }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "form" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DynamicForm" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Field" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Field" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "inputType" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "optionsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayValue" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "assistiveText" } },
          { kind: "Field", name: { kind: "Name", value: "placeholder" } },
          { kind: "Field", name: { kind: "Name", value: "errorMessage" } },
          { kind: "Field", name: { kind: "Name", value: "counter" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FieldController" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FieldController" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "field" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Field" }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "question" } },
          { kind: "Field", name: { kind: "Name", value: "required" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormRow" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormRow" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "columnsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "2" }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Entry" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "FieldController" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormMarkdownField" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormMarkdownField" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "text" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormConsentCheckboxField" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormConsentCheckboxField" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "spaceId" } },
                { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "publishedVersion" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "firstPublishedAt" }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "errorMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "spaceId" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedAt" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedVersion" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstPublishedAt" }
                      }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "urlSlug" } },
                { kind: "Field", name: { kind: "Name", value: "textBody" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormOptionalConsentCheckboxField" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormOptionalConsentCheckboxField" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "spaceId" } },
                { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "publishedVersion" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "firstPublishedAt" }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "errorMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "spaceId" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedAt" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedVersion" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstPublishedAt" }
                      }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "urlSlug" } },
                { kind: "Field", name: { kind: "Name", value: "textBody" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormMessage" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormMessage" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "text" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormSubmitButton" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormSubmitButton" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "label" } }]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DynamicForm" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Form" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "commercialOwner" } },
          { kind: "Field", name: { kind: "Name", value: "trackingName" } },
          { kind: "Field", name: { kind: "Name", value: "trackingStage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "trackingConversionPoint" }
          },
          { kind: "Field", name: { kind: "Name", value: "configuration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rowsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "40" }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Entry" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "FormRow" }
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "FormMarkdownField" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentFieldsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Entry" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "FormConsentCheckboxField"
                        }
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "FormOptionalConsentCheckboxField"
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "submitSuccessMessage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FormMessage" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "submitFailureMessage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FormMessage" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "submitButton" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FormSubmitButton" }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var ModularPageSectionByIdDocument = {
  __meta__: { hash: "356236737edbdacf1cb5ee78deddf7fe3c6630a1" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ModularPageSectionById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "modularPage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "urlSlug" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionsCollection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "PageSection" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "sectionType"
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "sectionCodeId"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "AppSection" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "metaDataAndSeo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "metadataContent" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContentBlock" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageMetaDescription" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageTitle" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entryTitle" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "socialImage" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "width" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "height" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "robotsMeta" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentBlock" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentBlock" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "primaryText" } },
          { kind: "Field", name: { kind: "Name", value: "secondaryText" } },
          { kind: "Field", name: { kind: "Name", value: "tertiaryText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "richText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "listOfShortText" } },
          { kind: "Field", name: { kind: "Name", value: "mediaType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assetsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Asset" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageDisplayOptions" }
          },
          { kind: "Field", name: { kind: "Name", value: "videoLink" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ctasCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Link" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "location" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "lat" } },
                { kind: "Field", name: { kind: "Name", value: "lon" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var NavigationDocument = {
  __meta__: { hash: "af66ae7c770417028777e43293f6831989764b0f" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Navigation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "navigationCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "3" }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entryTitle" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayText" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "businessArea" }
                      },
                      { kind: "Field", name: { kind: "Name", value: "order" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "discoverSection" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "NavigationDiscoverSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "search" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "showResultsText"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "searchUrl" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: {
                                            kind: "NamedType",
                                            name: {
                                              kind: "Name",
                                              value: "Url"
                                            }
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "url"
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "contactPagesSection"
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: {
                                            kind: "NamedType",
                                            name: {
                                              kind: "Name",
                                              value: "NavigationItem"
                                            }
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "sys"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "id"
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "displayText"
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "sectionItemsCollection"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "items"
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "InlineFragment",
                                                            typeCondition: {
                                                              kind: "NamedType",
                                                              name: {
                                                                kind: "Name",
                                                                value: "Link"
                                                              }
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "sys"
                                                                  },
                                                                  selectionSet: {
                                                                    kind: "SelectionSet",
                                                                    selections: [
                                                                      {
                                                                        kind: "Field",
                                                                        name: {
                                                                          kind: "Name",
                                                                          value: "id"
                                                                        }
                                                                      }
                                                                    ]
                                                                  }
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "displayText"
                                                                  }
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "url"
                                                                  },
                                                                  selectionSet: {
                                                                    kind: "SelectionSet",
                                                                    selections: [
                                                                      {
                                                                        kind: "Field",
                                                                        name: {
                                                                          kind: "Name",
                                                                          value: "url"
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: "Field",
                                                                        name: {
                                                                          kind: "Name",
                                                                          value: "sys"
                                                                        },
                                                                        selectionSet: {
                                                                          kind: "SelectionSet",
                                                                          selections: [
                                                                            {
                                                                              kind: "Field",
                                                                              name: {
                                                                                kind: "Name",
                                                                                value: "id"
                                                                              }
                                                                            }
                                                                          ]
                                                                        }
                                                                      }
                                                                    ]
                                                                  }
                                                                }
                                                              ]
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "customerPortalsSection"
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: {
                                            kind: "NamedType",
                                            name: {
                                              kind: "Name",
                                              value: "NavigationItem"
                                            }
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "sys"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "id"
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "displayText"
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "sectionItemsCollection"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "items"
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "InlineFragment",
                                                            typeCondition: {
                                                              kind: "NamedType",
                                                              name: {
                                                                kind: "Name",
                                                                value: "Link"
                                                              }
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "sys"
                                                                  },
                                                                  selectionSet: {
                                                                    kind: "SelectionSet",
                                                                    selections: [
                                                                      {
                                                                        kind: "Field",
                                                                        name: {
                                                                          kind: "Name",
                                                                          value: "id"
                                                                        }
                                                                      }
                                                                    ]
                                                                  }
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "displayText"
                                                                  }
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "url"
                                                                  },
                                                                  selectionSet: {
                                                                    kind: "SelectionSet",
                                                                    selections: [
                                                                      {
                                                                        kind: "Field",
                                                                        name: {
                                                                          kind: "Name",
                                                                          value: "url"
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: "Field",
                                                                        name: {
                                                                          kind: "Name",
                                                                          value: "sys"
                                                                        },
                                                                        selectionSet: {
                                                                          kind: "SelectionSet",
                                                                          selections: [
                                                                            {
                                                                              kind: "Field",
                                                                              name: {
                                                                                kind: "Name",
                                                                                value: "id"
                                                                              }
                                                                            }
                                                                          ]
                                                                        }
                                                                      }
                                                                    ]
                                                                  }
                                                                }
                                                              ]
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "localeSelectorHeader"
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "key" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "landingPage" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "Link" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "sys" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id"
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "url" }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "urlType"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "navigationSectionsCollection"
                        },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "limit" },
                            value: { kind: "IntValue", value: "10" }
                          }
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "total" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "items" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "NavigationItem"
                                      }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "sys" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id"
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "entryTitle"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "displayText"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "link" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                  kind: "NamedType",
                                                  name: {
                                                    kind: "Name",
                                                    value: "Link"
                                                  }
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "sys"
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "id"
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "entryTitle"
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "url"
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "sys"
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "id"
                                                                  }
                                                                }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "url"
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "urlType"
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "sectionItemsCollection"
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "items"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "InlineFragment",
                                                      typeCondition: {
                                                        kind: "NamedType",
                                                        name: {
                                                          kind: "Name",
                                                          value: "Link"
                                                        }
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "sys"
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "id"
                                                                  }
                                                                }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "displayText"
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "url"
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "url"
                                                                  }
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "sys"
                                                                  },
                                                                  selectionSet: {
                                                                    kind: "SelectionSet",
                                                                    selections: [
                                                                      {
                                                                        kind: "Field",
                                                                        name: {
                                                                          kind: "Name",
                                                                          value: "id"
                                                                        }
                                                                      }
                                                                    ]
                                                                  }
                                                                }
                                                              ]
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: "InlineFragment",
                                                      typeCondition: {
                                                        kind: "NamedType",
                                                        name: {
                                                          kind: "Name",
                                                          value: "NavigationItem"
                                                        }
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "sys"
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "id"
                                                                  }
                                                                }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "entryTitle"
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "displayText"
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "sectionItemsCollection"
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "items"
                                                                  },
                                                                  selectionSet: {
                                                                    kind: "SelectionSet",
                                                                    selections: [
                                                                      {
                                                                        kind: "InlineFragment",
                                                                        typeCondition: {
                                                                          kind: "NamedType",
                                                                          name: {
                                                                            kind: "Name",
                                                                            value: "Link"
                                                                          }
                                                                        },
                                                                        selectionSet: {
                                                                          kind: "SelectionSet",
                                                                          selections: [
                                                                            {
                                                                              kind: "Field",
                                                                              name: {
                                                                                kind: "Name",
                                                                                value: "sys"
                                                                              },
                                                                              selectionSet: {
                                                                                kind: "SelectionSet",
                                                                                selections: [
                                                                                  {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                      kind: "Name",
                                                                                      value: "id"
                                                                                    }
                                                                                  }
                                                                                ]
                                                                              }
                                                                            },
                                                                            {
                                                                              kind: "Field",
                                                                              name: {
                                                                                kind: "Name",
                                                                                value: "displayText"
                                                                              }
                                                                            },
                                                                            {
                                                                              kind: "Field",
                                                                              name: {
                                                                                kind: "Name",
                                                                                value: "url"
                                                                              },
                                                                              selectionSet: {
                                                                                kind: "SelectionSet",
                                                                                selections: [
                                                                                  {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                      kind: "Name",
                                                                                      value: "sys"
                                                                                    },
                                                                                    selectionSet: {
                                                                                      kind: "SelectionSet",
                                                                                      selections: [
                                                                                        {
                                                                                          kind: "Field",
                                                                                          name: {
                                                                                            kind: "Name",
                                                                                            value: "id"
                                                                                          }
                                                                                        }
                                                                                      ]
                                                                                    }
                                                                                  },
                                                                                  {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                      kind: "Name",
                                                                                      value: "url"
                                                                                    }
                                                                                  }
                                                                                ]
                                                                              }
                                                                            }
                                                                          ]
                                                                        }
                                                                      }
                                                                    ]
                                                                  }
                                                                }
                                                              ]
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "sys" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id"
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "entryTitle"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "displayText"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "url" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "sys"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "id"
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "url"
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "urlType"
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "promotionsCollection" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "limit" },
                            value: { kind: "IntValue", value: "6" }
                          }
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "total" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "items" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ContentBlock"
                                      }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "sys" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id"
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "primaryText"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "secondaryText"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "richText"
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "json"
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "ctasCollection"
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "items"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "sys"
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "id"
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "icon"
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "sys"
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "id"
                                                                  }
                                                                }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "title"
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "description"
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "size"
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "url"
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "width"
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "height"
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "linkType"
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "displayText"
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "url"
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "sys"
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "id"
                                                                  }
                                                                }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "url"
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "assetsCollection"
                                          },
                                          arguments: [
                                            {
                                              kind: "Argument",
                                              name: {
                                                kind: "Name",
                                                value: "limit"
                                              },
                                              value: {
                                                kind: "IntValue",
                                                value: "1"
                                              }
                                            }
                                          ],
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "total"
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "items"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "InlineFragment",
                                                      typeCondition: {
                                                        kind: "NamedType",
                                                        name: {
                                                          kind: "Name",
                                                          value: "Asset"
                                                        }
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "sys"
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "id"
                                                                  }
                                                                }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "title"
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "description"
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "size"
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "url"
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "width"
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "height"
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "siteSettings" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "entryTitle" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "logo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "size" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var FooterNavigationDocument = {
  __meta__: { hash: "53e7bd2f2f8ec12d7e44edd020abdd846f5d6717" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FooterNavigation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "footerCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "3" }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entryTitle" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "businessUnit" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "columnsCollection" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "items" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "displayText"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "sectionItemsCollection"
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "items"
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                  kind: "NamedType",
                                                  name: {
                                                    kind: "Name",
                                                    value: "Link"
                                                  }
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "sys"
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "id"
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "entryTitle"
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "displayText"
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "url"
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "sys"
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "id"
                                                                  }
                                                                }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "urlType"
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "url"
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "appLink" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "entryTitle" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayText" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "urlType" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "icon" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "size" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "socialSection" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayText" }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "sectionItemsCollection"
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "items" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: {
                                            kind: "NamedType",
                                            name: {
                                              kind: "Name",
                                              value: "Link"
                                            }
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "sys"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "id"
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "entryTitle"
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "displayText"
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "url"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "sys"
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "id"
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "urlType"
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "url"
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "icon"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "sys"
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "id"
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "url"
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "title"
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "description"
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "width"
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "height"
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "size"
                                                      }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "legalSection" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "sectionItemsCollection"
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "items" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: {
                                            kind: "NamedType",
                                            name: {
                                              kind: "Name",
                                              value: "Link"
                                            }
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "entryTitle"
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "displayText"
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "sys"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "id"
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "url"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "sys"
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "id"
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "urlType"
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "url"
                                                      }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "siteSettings" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "entryTitle" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "logo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "size" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var PageIdBySlugDocument = {
  __meta__: { hash: "9e5a3efcf775de352dd3a02648be6cdaec9ca85b" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PageIdBySlug" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "urlSlug" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "b2BCompositePageCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "urlSlug" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "url" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "urlSlug" }
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "2" }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "b2CCompositePageCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "urlSlug" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "url" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "urlSlug" }
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "2" }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "modularPageCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "urlSlug" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "url" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "urlSlug" }
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "2" }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "articlePageCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "urlSlug" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "url" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "urlSlug" }
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "2" }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "articleCategoryOverviewPageCollection"
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "urlSlug" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "url" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "urlSlug" }
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "2" }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var CardsSectionByIdDocument = {
  __meta__: { hash: "5c894642a6223e8389c391876b4dcb8a5199f032" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CardsSectionById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "cardsSection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionHeader" }
                },
                { kind: "Field", name: { kind: "Name", value: "overline" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionDescription" }
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "sectionBackgroundAndCardColor"
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "displayType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardsCollection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "MediaCard" }
                            },
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "TextCard" }
                            },
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ActionCard" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebLink" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WebLink" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "icon" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MediaCard" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MediaCard" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "header" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Asset" }
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Asset" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "priceEyebrow" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "priceDescription" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "linksCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Link" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Link" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TextCard" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TextCard" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "header" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "linksCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Link" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Link" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ActionCard" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ActionCard" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "header" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Asset" }
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Asset" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "link" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "WebLink" }
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "WebLink" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "priceNumber" },
            name: { kind: "Name", value: "price" }
          },
          { kind: "Field", name: { kind: "Name", value: "badge" } },
          { kind: "Field", name: { kind: "Name", value: "currency" } },
          { kind: "Field", name: { kind: "Name", value: "discount" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } }
        ]
      }
    }
  ]
};
var HeroPromotionalSectionByIdDocument = {
  __meta__: { hash: "23febbc071174ae01692c728dea3af8412fffdf2" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "HeroPromotionalSectionById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "heroPromotionalSection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "eyebrow" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "media" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Asset" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Asset" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "badge" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "price" } },
                { kind: "Field", name: { kind: "Name", value: "discount" } },
                { kind: "Field", name: { kind: "Name", value: "suffix" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    }
  ]
};
var HeroSectionByIdDocument = {
  __meta__: { hash: "a2c0aa2b969e3b22c445e4b9ea786f2e433942f2" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "HeroSectionById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "heroSection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "eyebrow" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "media" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Asset" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Asset" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "linksCollection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "Link" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "Link" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var TextAndMediaSectionByIdDocument = {
  __meta__: { hash: "c154ff4ededa2f097712af24a34959c263c42e94" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "TextAndMediaSectionById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "textAndMediaSection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "header" } },
                { kind: "Field", name: { kind: "Name", value: "variant" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionBackgroundColor" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "description" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "json" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mediaCollection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "Asset" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "Asset" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "linksCollection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "Link" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "Link" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "videoLink" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};

// src/api-calls/graphql/forms.ts
function useGetDynamicFormsData({
  client,
  id,
  locale,
  preview
}) {
  const { loading, error, data } = useQuery(DynamicFormDocument, {
    variables: { id, preview, locale },
    fetchPolicy: "network-only",
    client
  });
  return {
    loading,
    form: (data == null ? void 0 : data.form) || void 0,
    error: error == null ? void 0 : error.message
  };
}

// src/api-calls/helpers.ts
function transformLocaleToContententfulsLocale(locale) {
  const tmp = locale.split("-");
  if (tmp.length > 1) {
    tmp[1] = tmp[1].toUpperCase();
  }
  return tmp.join("-");
}

// src/api-calls/graphql/navigation.ts
async function fetchTopNavigations(client, locale) {
  const { data, error } = await client.query({
    variables: {
      locale: transformLocaleToContententfulsLocale(locale)
    },
    fetchPolicy: "cache-first",
    query: NavigationDocument
  });
  if (error)
    throw error;
  return data == null ? void 0 : data.navigationCollection;
}
async function fetchFooterNavigation(client, locale) {
  const { data, error } = await client.query({
    variables: {
      locale: transformLocaleToContententfulsLocale(locale)
    },
    fetchPolicy: "cache-first",
    query: FooterNavigationDocument
  });
  if (error)
    throw error;
  return data == null ? void 0 : data.footerCollection;
}

// src/api-calls/graphql/pages.ts
async function getPageQueryByUrl({
  template,
  client,
  id,
  locale,
  preview
}) {
  const templateToQuery = {
    articlePage: ArticlePageDocument,
    articleCategoryOverviewPage: ArticleCategoryOverviewPageByIdDocument
    // TODO: Add more templates and queries as needed
  };
  const { data, error } = await client.query({
    variables: {
      id,
      locale: transformLocaleToContententfulsLocale(locale),
      preview: !!preview
    },
    fetchPolicy: "no-cache",
    errorPolicy: "all",
    query: templateToQuery[template]
    // Use the dynamically selected query
  });
  if (error)
    throw error;
  if ((data == null ? void 0 : data.page.__typename) === "ArticleCategoryOverviewPage") {
    return getAndMergeArticles({ client, id, locale, preview, page: data.page });
  }
  return data == null ? void 0 : data.page;
}
var getAndMergeArticles = async ({
  client,
  preview,
  locale,
  page
}) => {
  var _a;
  const { data, error } = await client.query({
    variables: {
      category: page.category,
      preview: !!preview,
      locale: transformLocaleToContententfulsLocale(locale)
    },
    fetchPolicy: "no-cache",
    errorPolicy: "all",
    query: ArticlesByCategoryDocument
  });
  if (error)
    throw error;
  return __spreadProps(__spreadValues({}, page), {
    articleCollection: (_a = data.result) == null ? void 0 : _a.items
  });
};

// src/api-calls/rest/navigation.ts
async function getUrls(contentfulClient, locale, slug) {
  if (!slug)
    return {};
  const url = await contentfulClient.getEntries({
    content_type: "url",
    "fields.url": slug,
    locale: transformLocaleToContententfulsLocale(locale)
  });
  if (!url || url.items.length < 1) {
    console.error(
      `failed to get current url for locale ${locale} slug ${slug}`,
      url.errors
    );
    return {};
  }
  if (url.items.length > 1) {
    console.error("got multiple matches for the url");
  }
  const entry = await contentfulClient.withAllLocales.getEntry(
    url.items[0].sys.id
  );
  return entry.fields.url;
}

// src/api-calls/rest/pages.ts
async function getAllLocalizedPathsForAllPages(contentfulClient, contentType) {
  var _a, _b, _c;
  const pages = await contentfulClient.withAllLocales.getEntries({
    content_type: contentType,
    "fields.urlSlug.sys.contentType.sys.id": "url",
    "fields.urlSlug.fields.url[exists]": true,
    "fields.urlSlug.fields.urlType[match]": "Slug",
    include: 1
  });
  const localizedPaths = [];
  for (const page of pages.items) {
    const defaultLocale = "en";
    const localizedUrl = (_c = (_b = (_a = page == null ? void 0 : page.fields) == null ? void 0 : _a.urlSlug[defaultLocale]) == null ? void 0 : _b.fields) == null ? void 0 : _c.url;
    localizedPaths.push(localizedUrl);
  }
  return localizedPaths;
}
async function getAllLocalizedLandingPaths(contentfulClient, url) {
  const landingPages = await contentfulClient.withAllLocales.getEntries({
    content_type: "url",
    "fields.url": url,
    include: 1
  });
  const paths = landingPages.items[0].fields.url;
  return new Array(paths);
}

// src/utils/locales.ts
var locales = [
  { countryName: "Belgique - Fran\xE7ais", locale: "fr-BE" },
  { countryName: "Belgi\xEB - Nederlands", locale: "nl-BE" },
  { countryName: "\u0411\u044A\u043B\u0433\u0430\u0440\u0438\u044F", locale: "bg-BG" },
  { countryName: "Brasil - Portugu\xEAs", locale: "pt-BR" },
  { countryName: "\u4E2D\u56FD", locale: "zh-CN" },
  { countryName: "\u010Cesk\xE1 republika", locale: "cs-CZ" },
  { countryName: "Deutschland", locale: "de-DE" },
  { countryName: "Danmark", locale: "da-DK" },
  { countryName: "Eesti", locale: "et-EE" },
  { countryName: "Espa\xF1a", locale: "es-ES" },
  { countryName: "France", locale: "fr-FR" },
  { countryName: "Italia", locale: "it-IT" },
  { countryName: "\u65E5\u672C", locale: "ja-JP" },
  { countryName: "\uB300\uD55C\uBBFC\uAD6D", locale: "ko-KR" },
  { countryName: "Lietuva", locale: "lt-LT" },
  { countryName: "Latvija", locale: "lv-LV" },
  { countryName: "Maroc - Fran\xE7ais", locale: "fr-MA" },
  { countryName: "Nederland", locale: "nl-NL" },
  { countryName: "Norge", locale: "nb-NO" },
  { countryName: "Polska", locale: "pl-PL" },
  { countryName: "Rom\xE2nia", locale: "ro-RO" },
  { countryName: "\u0420\u043E\u0441\u0441\u0438\u044F", locale: "ru-RU" },
  { countryName: "Slovensko", locale: "sk-SK" },
  { countryName: "Suomi", locale: "fi-FI" },
  { countryName: "Sverige", locale: "sv-SE" },
  { countryName: "United Kingdom - English", locale: "en-GB" },
  { countryName: "T\xFCrkiye", locale: "tr-TR" },
  { countryName: "International", locale: "en" }
];
var availableLocales = new Set(
  locales.map((loc) => loc.locale.toLocaleLowerCase())
);

// src/api-calls/rest/redirects/validateUrls.ts
var sanitizeUrl = (url) => {
  url = (url == null ? void 0 : url.startsWith("/")) ? url.substring(1) : url;
  if (!url || !startsWithValidLocale(url))
    return url;
  const [locale, ...rest] = (url == null ? void 0 : url.split("/")) || [];
  return `${locale.toLowerCase()}/${rest.join("/")}`;
};
var startsWithValidLocale = (url) => {
  if (!url)
    return;
  const locale = url == null ? void 0 : url.split("/")[0].toLowerCase();
  return availableLocales.has(locale);
};
var appendLocaleToUrl = (url, localeItem) => {
  if (!url)
    return;
  return startsWithValidLocale(url) ? `/${url}` : `/${[localeItem == null ? void 0 : localeItem.toLowerCase(), url].join("/")}`;
};

// src/api-calls/rest/redirects/mapRedirects.ts
var redirectsAreEqual = (a, b) => {
  return a.source === b.source && a.destination === b.destination && a.permanent === b.permanent;
};
var addRedirectIfDoesNotExist = (newRedirect, redirects) => {
  const redirectAlreadyExists = redirects.some((existingRedirect) => {
    return redirectsAreEqual(existingRedirect, newRedirect);
  });
  if (!redirectAlreadyExists)
    redirects.push(newRedirect);
};
function mapRedirect({
  sourceUrls,
  destinationUrls,
  selectedLocale,
  permanent
}) {
  if (!selectedLocale)
    return;
  let source = sanitizeUrl(sourceUrls[selectedLocale]);
  if (!source || startsWithValidLocale(source))
    return;
  source = appendLocaleToUrl(source, selectedLocale);
  let destination = sanitizeUrl(destinationUrls[selectedLocale]);
  destination = appendLocaleToUrl(
    destination || sanitizeUrl(destinationUrls.en),
    destination ? selectedLocale : "en"
  );
  return { source, destination, permanent };
}
function mapRedirects({
  sourceUrls,
  destinationUrls,
  selectedLocales,
  permanent
}) {
  const mappedRedirects = [];
  selectedLocales.forEach((selectedLocale) => {
    const newRedirect = mapRedirect({
      sourceUrls,
      destinationUrls,
      selectedLocale,
      permanent
    });
    if (!newRedirect || !newRedirect.source || !newRedirect.destination)
      return;
    return addRedirectIfDoesNotExist(newRedirect, mappedRedirects);
  });
  return mappedRedirects;
}

// src/api-calls/rest/redirects/redirects.ts
async function getRedirects(contentfulClient) {
  let currentEntryId;
  try {
    const { items } = await contentfulClient.withAllLocales.getEntries(
      {
        content_type: "urlRedirect"
      }
    );
    return items.flatMap(({ fields, sys }) => {
      const { id } = sys || {};
      const { source, destination, sourceLocale } = fields || {};
      currentEntryId = id;
      const sourceUrls = source["en"] && source["en"]["fields"]["url"];
      const destinationUrls = destination["en"] && destination["en"]["fields"]["url"];
      const selectedLocales = sourceLocale["en"];
      if (!sourceUrls || !destinationUrls || !selectedLocales)
        return;
      return mapRedirects({
        sourceUrls,
        destinationUrls,
        selectedLocales,
        permanent: fields.permanent.en
      });
    });
  } catch (e) {
    throw new Error(
      `[Content error]: Broken Url Redirect configuration with id: ${currentEntryId}`
    );
  }
}

// src/clients/cache.ts
function createContentfulClientCache(clientCreation) {
  const clientLookup = {};
  return (contentfulSpace, env, accessToken, preview = false) => {
    const key = `${contentfulSpace}${env}${preview}`;
    if (!clientLookup[key]) {
      clientLookup[key] = clientCreation(
        contentfulSpace,
        env,
        accessToken,
        preview
      );
    }
    return clientLookup[key];
  };
}
var apolloLinks = ({
  contentfulSpace,
  env,
  accessToken
}) => {
  const httpLink = () => createHttpLink({
    fetch,
    uri: `https://graphql.contentful.com/content/v1/spaces/${contentfulSpace}/environments/${env}`,
    headers: {
      authorization: `Bearer ${accessToken}`
    }
  });
  const retryLink = () => new RetryLink({
    /* eslint-disable @typescript-eslint/no-unused-vars */
    attempts: (count, operation, error) => {
      const rateLimitReset = getRateLimitReset(error);
      return !!rateLimitReset;
    },
    delay: (count, _, error) => {
      const rateLimitReset = getRateLimitReset(error);
      if (!rateLimitReset) {
        return count * 1e3 * Math.random();
      }
      return Number.parseFloat(rateLimitReset) || 5;
    }
  });
  const loggerLink = () => new ApolloLink((operation, forward) => {
    const { variables, operationName } = operation;
    console.log("operation", operationName);
    console.log("variables", variables);
    return forward(operation);
  });
  return {
    httpLink,
    retryLink,
    loggerLink
  };
};
var getRateLimitReset = (error) => {
  if (error && "response" in error && error.response.headers.has("X-Contentful-RateLimit-Reset")) {
    const rateLimitReset = error.response.headers.get(
      "X-Contentful-RateLimit-Reset"
    );
    console.log("Rate limit reset", rateLimitReset);
    return rateLimitReset;
  }
};

// src/clients/graphqlContentfulClient.ts
var createContentfulGraphQLClient = createContentfulClientCache(
  (contentfulSpace, env, accessToken) => {
    if (contentfulSpace === "") {
      contentfulSpace = process.env.CONTENTFUL_SHARED_CONTENT_SPACE || "";
    }
    if (env === "") {
      env = process.env.CONTENTFUL_SHARED_CONTENT_ENV || "";
    }
    if (accessToken === "") {
      accessToken = process.env.CONTENTFUL_SHARED_CONTENT_ACCESS_TOKEN || "";
    }
    for (const [key, value] of Object.entries({
      contentfulSpace,
      env,
      accessToken
    })) {
      if (value === "") {
        throw new Error(`${key} must be provided!`);
      }
    }
    return new ApolloClient({
      link: createLink({ contentfulSpace, env, accessToken }),
      cache: new InMemoryCache()
    });
  }
);
var createLink = ({
  contentfulSpace,
  env,
  accessToken
}) => {
  const { httpLink, loggerLink, retryLink } = apolloLinks({
    contentfulSpace,
    env,
    accessToken
  });
  let link = from([retryLink(), httpLink()]);
  if (process.env.APOLLO_DEBUG_MODE === "debug") {
    link = from([loggerLink(), link]);
  }
  return link;
};
var createContentfulRestClient = createContentfulClientCache(
  (contentfulSpace, environment, accessToken, preview) => createClient({
    space: contentfulSpace,
    accessToken,
    environment,
    host: preview ? "preview.contentful.com" : void 0
  })
);

// src/data-management/exceptions.ts
var DataFetchingError = class extends Error {
  constructor(innerErrors) {
    super();
    __publicField(this, "innerErrors");
    this.message = "Error fetching data";
    this.name = "DataFetchingError";
    this.innerErrors = innerErrors;
  }
};
var ensureError = (value) => {
  if (value instanceof Error) {
    return value;
  }
  return new Error(
    `Converted to the instance of Error: ${JSON.stringify(value)}`
  );
};

// src/data-management/repository/repository.ts
var Repository = class {
  constructor(graphQLClient) {
    this.graphQLClient = graphQLClient;
  }
  get client() {
    return this.graphQLClient;
  }
  async getByQueryAsync(query, variables) {
    const { data, error } = await this.graphQLClient.query({
      variables,
      fetchPolicy: "no-cache",
      errorPolicy: "all",
      query
    });
    this.checkOrThrow(error);
    return data;
  }
  collectAndLogError(error, innerErrors) {
    console.error(`${error.name}: ${error.message}`);
    console.error("Stacktrace :", error.stack);
    innerErrors.push(error);
  }
  checkOrThrow(error) {
    var _a;
    const innerErrors = [];
    if (error == null ? void 0 : error.networkError) {
      this.collectAndLogError(error.networkError, innerErrors);
    }
    (_a = error == null ? void 0 : error.graphQLErrors) == null ? void 0 : _a.forEach(
      (error2) => this.collectAndLogError(error2, innerErrors)
    );
    if (innerErrors.length) {
      throw new DataFetchingError(innerErrors);
    }
  }
};

// src/data-management/services/content-service.ts
var ContentService = class {
  constructor() {
    __publicField(this, "providers", []);
    __publicField(this, "content", []);
    __publicField(this, "errors", []);
    __publicField(this, "isRejected", (data) => data.status === "rejected");
    __publicField(this, "isFulfilled", (data) => data.status === "fulfilled");
  }
  registerProvider(provider) {
    this.providers.push(provider);
    return this;
  }
  async resolveAsync() {
    const data = await Promise.all(
      this.providers.map((p) => p.getContentAsync())
    );
    this.content = [...this.content, ...data];
    this.providers = [];
    return this;
  }
  async settleAsync(contentKey) {
    const data = await Promise.allSettled(
      this.providers.map((p) => p.getContentAsync())
    );
    const content = data.filter(this.isFulfilled).map((p) => p.value);
    const errors = data.filter(this.isRejected).map((p) => p.reason);
    this.content = contentKey ? [...this.content, { [contentKey]: content }] : [...this.content, ...content];
    this.errors = [...this.errors, ...errors];
    this.providers = [];
    return this;
  }
};

// src/data-management/types/index.ts
var LegacyPageTypes = /* @__PURE__ */ ((LegacyPageTypes2) => {
  LegacyPageTypes2["ModularPage"] = "ModularPage";
  LegacyPageTypes2["ArticlePage"] = "ArticlePage";
  LegacyPageTypes2["ArticleCategoryOverviewPage"] = "ArticleCategoryOverviewPage";
  return LegacyPageTypes2;
})(LegacyPageTypes || {});
var DXPPageTypes = /* @__PURE__ */ ((DXPPageTypes2) => {
  DXPPageTypes2["B2BCompositePage"] = "B2BCompositePage";
  DXPPageTypes2["B2CCompositePage"] = "B2CCompositePage";
  return DXPPageTypes2;
})(DXPPageTypes || {});

export { AbnormalLoadLinkingCollectionsB2BRouteCollectionOrder, AbnormalLoadOrder, AccordionFragmentDoc, AccordionGroupAccordionItemCollectionOrder, AccordionGroupItemFragmentDoc, AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder, AccordionGroupItemOrder, AccordionGroupLinkingCollectionsPageSectionCollectionOrder, AccordionGroupOrder, AccordionLinkingCollectionsPageSectionCollectionOrder, AccordionOrder, ActionCardFragmentDoc, ActionCardLinkingCollectionsCardsSectionCollectionOrder, ActionCardOrder, AmendmentBookingOrder, AmendmentCabinOrder, AmendmentFaresOrder, AppOrder, AppSectionFragmentDoc, AppSectionLinkingCollectionsArticlePageCollectionOrder, AppSectionLinkingCollectionsModularPageCollectionOrder, AppSectionOrder, ArrayOfItemsOrder, ArticleCategoryOverviewPageByIdDocument, ArticleCategoryOverviewPageOrder, ArticlePageDocument, ArticlePageOrder, ArticlesByCategoryDocument, AssetFragmentDoc, AssetOrder, AuthorLinkingCollectionsArticlePageCollectionOrder, AuthorOrder, B2BCompositePageOrder, B2BPageDocument, B2BRouteAbnormalLoadsCollectionOrder, B2BRouteHazardousLoadsCollectionOrder, B2BRouteOrder, B2BRouteUnitTypesCollectionOrder, B2CCompositePageOrder, B2CPageDocument, BannerCollectionDocument, BannerOrder, CabinDetailsOrder, CabinGroupOrder, CabinLinkingCollectionsFerryCollectionOrder, CabinOrder, CampaignBlockLinkingCollectionsMobilePageCollectionOrder, CampaignBlockOrder, CardsSectionByIdDocument, CardsSectionLinkingCollectionsB2BCompositePageCollectionOrder, CardsSectionLinkingCollectionsB2CCompositePageCollectionOrder, CardsSectionOrder, ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder, ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder, ConsentTextOrder, ContentBlockCtasCollectionOrder, ContentBlockFragmentDoc, ContentBlockLinkingCollectionsAppSectionCollectionOrder, ContentBlockLinkingCollectionsArticlePageCollectionOrder, ContentBlockLinkingCollectionsCampaignBlockCollectionOrder, ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder, ContentBlockLinkingCollectionsNavigationCollectionOrder, ContentBlockLinkingCollectionsPageSectionCollectionOrder, ContentBlockOrder, ContentService, DXPPageTypes, DataFetchingError, DfdsAppSimpleStringOrder, DynamicFormDocument, DynamicFormFragmentDoc, EntryOrder, EventLinkingCollectionsFerryCollectionOrder, EventOrder, FaresTiersTncOrder, FerryCabinsCollectionOrder, FerryEventsCollectionOrder, FerryFacilitiesCollectionOrder, FerryFacilitiesLinkingCollectionsFerryCollectionOrder, FerryFacilitiesOrder, FerryInstructionAndSignalisationCollectionOrder, FerryLinkingCollectionsPaxRouteCollectionOrder, FerryOrder, FerryPetsInfoCollectionOrder, FerryRestaurantsCollectionOrder, FieldControllerFragmentDoc, FieldControllerLinkingCollectionsFormRowCollectionOrder, FieldControllerOrder, FieldFragmentDoc, FieldLinkingCollectionsFieldControllerCollectionOrder, FieldOptionsCollectionOrder, FieldOrder, FlowCabinFaresOrder, FlowCabinOrder, FlowFaresOrder, FlowMealsOrder, FlowTravelOrder, FooterColumnsCollectionOrder, FooterNavigationDocument, FooterOrder, FormCheckboxFieldOrder, FormConsentCheckboxFieldFragmentDoc, FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder, FormConsentCheckboxFieldOrder, FormInputFieldOrder, FormLinkingCollectionsAppSectionCollectionOrder, FormMarkdownFieldFragmentDoc, FormMarkdownFieldLinkingCollectionsFormCollectionOrder, FormMarkdownFieldLinkingCollectionsFormRowCollectionOrder, FormMarkdownFieldOrder, FormMessageFragmentDoc, FormMessageLinkingCollectionsFormCollectionOrder, FormMessageOrder, FormOptionalConsentCheckboxFieldFragmentDoc, FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder, FormOptionalConsentCheckboxFieldOrder, FormOrder, FormRatingFieldOrder, FormRowFragmentDoc, FormRowLinkingCollectionsFormCollectionOrder, FormRowOrder, FormSelectFieldOptionsCollectionOrder, FormSelectFieldOrder, FormSelectOptionLinkingCollectionsFieldCollectionOrder, FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder, FormSelectOptionOrder, FormSubmitButtonFragmentDoc, FormSubmitButtonLinkingCollectionsFormCollectionOrder, FormSubmitButtonOrder, FreightScheduleLinkingCollectionsB2BRouteCollectionOrder, FreightScheduleOrder, FreightTerminalLinkingCollectionsB2BRouteCollectionOrder, FreightTerminalOrder, GdprSettingsOrder, GenericAppSectionDocument, GenericPageSectionDocument, GenericRouteOrder, HazardousLoadLinkingCollectionsB2BRouteCollectionOrder, HazardousLoadOrder, HeroPromotionalSectionByIdDocument, HeroPromotionalSectionLinkingCollectionsB2CCompositePageCollectionOrder, HeroPromotionalSectionOrder, HeroSectionByIdDocument, HeroSectionLinkingCollectionsB2BCompositePageCollectionOrder, HeroSectionLinkingCollectionsB2CCompositePageCollectionOrder, HeroSectionLinksCollectionOrder, HeroSectionOrder, ImageFormat, ImageResizeFocus, ImageResizeStrategy, InstructionAndSignalisationLinkingCollectionsFerryCollectionOrder, InstructionAndSignalisationOrder, KeyValuePairCollectionItemsCollectionOrder, KeyValuePairCollectionOrder, KeyValuePairLinkingCollectionsKeyValuePairCollectionCollectionOrder, LegacyPageTypes, LinkFragmentDoc, LinkLinkingCollectionsBannerCollectionOrder, LinkLinkingCollectionsContentBlockCollectionOrder, LinkLinkingCollectionsFooterCollectionOrder, LinkLinkingCollectionsGdprSettingsCollectionOrder, LinkLinkingCollectionsHeroSectionCollectionOrder, LinkLinkingCollectionsLinksListCollectionOrder, LinkLinkingCollectionsMediaCardCollectionOrder, LinkLinkingCollectionsNavigationCollectionOrder, LinkLinkingCollectionsNavigationItemCollectionOrder, LinkLinkingCollectionsPageSectionCollectionOrder, LinkLinkingCollectionsTextAndMediaSectionCollectionOrder, LinkLinkingCollectionsTextCardCollectionOrder, LinkOrder, LinksListLinkingCollectionsPageSectionCollectionOrder, LinksListLinksListItemsCollectionOrder, LinksListOrder, LongStringLinkingCollectionsArrayOfItemsCollectionOrder, LongStringOrder, MealsRestaurantLinkingCollectionsFerryCollectionOrder, MealsRestaurantOrder, MediaCardFragmentDoc, MediaCardLinkingCollectionsCardsSectionCollectionOrder, MediaCardLinksCollectionOrder, MediaCardOrder, MetaDataAndSeoFragmentDoc, MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder, MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder, MetaDataAndSeoLinkingCollectionsB2BCompositePageCollectionOrder, MetaDataAndSeoLinkingCollectionsB2CCompositePageCollectionOrder, MetaDataAndSeoLinkingCollectionsModularPageCollectionOrder, MetaDataAndSeoOrder, MigrationLogOrder, MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder, MobileContentBlockOrder, MobilePageCampaignBlocksCollectionOrder, MobilePageOrder, MobileScreenMobileSectionsCollectionOrder, MobileScreenOrder, MobileSectionLinkingCollectionsMobileScreenCollectionOrder, MobileSectionOrder, MobileSectionSectionItemsCollectionOrder, ModularPageOrder, ModularPageSectionByIdDocument, NamespaceAndStringLinkingCollectionsArrayOfItemsCollectionOrder, NamespaceAndStringOrder, NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder, NavigationDiscoverSectionOrder, NavigationDocument, NavigationItemLinkingCollectionsFooterCollectionOrder, NavigationItemLinkingCollectionsNavigationCollectionOrder, NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder, NavigationItemLinkingCollectionsNavigationItemCollectionOrder, NavigationItemOrder, NavigationOrder, NavigationPromotionsCollectionOrder, OpenGraphSettingsOrder, PageIdBySlugDocument, PageSectionFragmentDoc, PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder, PageSectionLinkingCollectionsArticlePageCollectionOrder, PageSectionLinkingCollectionsModularPageCollectionOrder, PageSectionOrder, PaxObCardItemsCollectionOrder, PaxObCardOrder, PaxObItemLinkingCollectionsPaxObCardCollectionOrder, PaxObItemOrder, PaxObResourceOrder, PaxRouteFerriesCollectionOrder, PaxRouteOrder, PetsLinkingCollectionsFerryCollectionOrder, PetsOrder, PluralStringLinkingCollectionsArrayOfItemsCollectionOrder, PluralStringOrder, PriceChangedPopupOrder, ReleaseNotesOrder, Repository, ResourceOrder, RichTextStringLinkingCollectionsArrayOfItemsCollectionOrder, RichTextStringOrder, RouteLinkingCollectionsCabinDetailsCollectionOrder, RouteLinkingCollectionsCabinGroupCollectionOrder, RouteLinkingCollectionsFlowCabinFaresCollectionOrder, RouteLinkingCollectionsMealsRestaurantCollectionOrder, RouteOrder, SectionThemeFragmentDoc, SectionTypeLinkingCollectionsPageSectionCollectionOrder, SectionTypeOrder, SimpleStringLinkingCollectionsArrayOfItemsCollectionOrder, SimpleStringLinkingCollectionsFooterCollectionOrder, SimpleStringLinkingCollectionsGenericRouteCollectionOrder, SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder, SimpleStringOrder, SiteSettingsLinkingCollectionsFooterCollectionOrder, SiteSettingsLinkingCollectionsNavigationCollectionOrder, SiteSettingsOrder, TeamNameLinkingCollectionsArrayOfItemsCollectionOrder, TeamNameLinkingCollectionsLongStringCollectionOrder, TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder, TeamNameLinkingCollectionsReleaseNotesCollectionOrder, TeamNameLinkingCollectionsRichTextStringCollectionOrder, TeamNameLinkingCollectionsSimpleStringCollectionOrder, TeamNameLinkingCollectionsTitleAndLinkCollectionOrder, TeamNameLinkingCollectionsTitleAndMediaCollectionOrder, TeamNameOrder, TerminalLinkingCollectionsPaxRouteCollectionOrder, TerminalOrder, TestOrder, TextAndMediaSectionByIdDocument, TextAndMediaSectionLinkingCollectionsB2BCompositePageCollectionOrder, TextAndMediaSectionLinkingCollectionsB2CCompositePageCollectionOrder, TextAndMediaSectionLinksCollectionOrder, TextAndMediaSectionOrder, TextCardFragmentDoc, TextCardLinkingCollectionsCardsSectionCollectionOrder, TextCardLinksCollectionOrder, TextCardOrder, ThemeLinkingCollectionsAppSectionCollectionOrder, ThemeLinkingCollectionsPageSectionCollectionOrder, ThemeOrder, TitleAndLinkLinkingCollectionsArrayOfItemsCollectionOrder, TitleAndLinkOrder, TitleAndMediaLinkingCollectionsArrayOfItemsCollectionOrder, TitleAndMediaOrder, TrackingAndActivationLinkingCollectionsModularPageCollectionOrder, TrackingAndActivationOrder, UnitTypeLinkingCollectionsB2BRouteCollectionOrder, UnitTypeOrder, UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder, UrlLinkingCollectionsArticlePageCollectionOrder, UrlLinkingCollectionsB2BCompositePageCollectionOrder, UrlLinkingCollectionsB2CCompositePageCollectionOrder, UrlLinkingCollectionsLinkCollectionOrder, UrlLinkingCollectionsModularPageCollectionOrder, UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder, UrlLinkingCollectionsUrlRedirectCollectionOrder, UrlLinkingCollectionsWebLinkCollectionOrder, UrlOrder, UrlRedirectOrder, WebLinkFragmentDoc, WebLinkLinkingCollectionsActionCardCollectionOrder, WebLinkOrder, appendLocaleToUrl, availableLocales, createContentfulClientCache, createContentfulGraphQLClient, createContentfulRestClient, ensureError, fetchFooterNavigation, fetchTopNavigations, getAllLocalizedLandingPaths, getAllLocalizedPathsForAllPages, getPageQueryByUrl, getRedirects, getUrls, locales, sanitizeUrl, startsWithValidLocale, transformLocaleToContententfulsLocale, useGetDynamicFormsData };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.mjs.map